<div class="" *ngIf="section === 'handbook'">
  <div class="container-fluid hero">
    <app-header></app-header>

    <div class="container hand-book-container">
      <div class="row">
        <div class="col-lg-6 head-top">
          <nav aria-label="breadcrumb">
            <ol class="breadcrumb">
              <li class="breadcrumb-item">
                <a [routerLink]="['/']">Home</a>
              </li>
              <li class="breadcrumb-item activebread">
                <a [routerLink]="['/handbook']">Handbook</a>
              </li>
            </ol>
          </nav>

          <h1 class="mb-2 p-class">HANDBOOK</h1>
          <p class="mobile-view">
            GrammarIn <span class="green"> Vision</span>
          </p>
          <p class="py-3 head-p">
            Find answers to all your writing conundrums with our simple guide to
            English grammar rules.
          </p>

          <a
            class="handbook-btn"
            style="
              cursor: pointer;
              display: inline-flex;
              align-items: center;
              text-decoration: none;
            "
            [routerLink]="['/grammar-checker']"
          >
            <p>Correct grammatical mistakes and other writing errors.</p>

            <app-icons-free-tools name="handbookCircleTickIcon" class="ms-2" />
          </a>
        </div>

        <div class="col-lg-6 img-col">
          <img
            src="/assets/images/handbook/boybooks.png"
            width="568px"
            height="412px"
            alt="handbook"
            class="mt-4 handbok-img"
            style="width: 568px; height: 412px"
          />
        </div>
      </div>
    </div>
  </div>

  <div class="container hand-book-content">
    <div class="row">
      <div class="col-lg-12 col-md-12 col-12 mt-5">
        <a [routerLink]="['/handbook/grammar']">
          <h2 class="handbook-heading">Grammar</h2>
        </a>
        <ul class="mt-4">
          <li *ngFor="let item of Grammar1" class="me-3 icon">
            <a [routerLink]="[item.route]">
              {{ item.name }}
              <app-icons-free-tools name="handbookItemTickIcon" />
            </a>
          </li>
        </ul>
        <ul>
          <li *ngFor="let item of Grammar2" class="me-3 icon">
            <a [routerLink]="[item.route]">
              {{ item.name }}
              <app-icons-free-tools name="handbookItemTickIcon" />
            </a>
          </li>
        </ul>
      </div>

      <div class="col-lg-12 col-md-12 col-12 mt-5">
        <a [routerLink]="['/handbook/punctuation']">
          <h2 class="handbook-heading">Punctuation</h2>
        </a>

        <ul class="mt-4">
          <li *ngFor="let item of Punctuation1" class="me-3 icon">
            <a [routerLink]="[item.route]">
              {{ item.name }}
              <app-icons-free-tools name="handbookItemTickIcon" />
            </a>
          </li>
        </ul>

        <ul>
          <li *ngFor="let item of Punctuation2" class="me-3 icon">
            <a [routerLink]="[item.route]">
              {{ item.name }}
              <app-icons-free-tools name="handbookItemTickIcon" />
            </a>
          </li>
        </ul>

        <ul class="">
          <li *ngFor="let item of Punctuation3" class="me-3 icon">
            <a [routerLink]="[item.route]">
              {{ item.name }}
              <app-icons-free-tools name="handbookItemTickIcon" />
            </a>
          </li>
        </ul>
      </div>

      <div class="col-lg-12 col-md-12 col-12mt-5">
        <a [routerLink]="['/handbook/mechanics']">
          <h2 class="handbook-heading">Mechanics</h2>
        </a>
        <ul class="mt-4">
          <li *ngFor="let item of Mechanics1" class="me-3 icon">
            <a [routerLink]="[item.route]">
              {{ item.name }}
              <app-icons-free-tools name="handbookItemTickIcon" />
            </a>
          </li>
        </ul>
      </div>

      <div class="col-lg-12 col-md-12 col-12 mt-5">
        <a [routerLink]="['/handbook/techniques']">
          <h2 class="handbook-heading">Techniques</h2>
        </a>
        <ul class="mt-4">
          <li *ngFor="let item of Techniques1" class="me-3 icon">
            <a [routerLink]="[item.route]">
              {{ item.name }}
              <app-icons-free-tools name="handbookItemTickIcon" />
            </a>
          </li>
        </ul>
        <ul>
          <li *ngFor="let item of Techniques2" class="me-3 icon">
            <a [routerLink]="[item.route]">
              {{ item.name }}
              <app-icons-free-tools name="handbookItemTickIcon" />
            </a>
          </li>
        </ul>
        <ul>
          <li *ngFor="let item of Techniques3" class="me-3 icon">
            <a [routerLink]="[item.route]">
              {{ item.name }}
              <app-icons-free-tools name="handbookItemTickIcon" />
            </a>
          </li>
        </ul>
      </div>

      <div class="col-lg-12 col-md-12 col-12 mt-5">
        <a [routerLink]="['/handbook/style']">
          <h2 class="handbook-heading">Style</h2>
        </a>
        <ul class="mt-4">
          <li *ngFor="let item of Style" class="me-3 icon">
            <a [routerLink]="[item.route]">
              {{ item.name }}
              <app-icons-free-tools name="handbookItemTickIcon" />
            </a>
          </li>
        </ul>
      </div>
    </div>
  </div>
</div>

<div class="" *ngIf="section === 'grammar'">
  <div class="container-fluid heros">
    <app-header></app-header>

    <div class="container hand-book-container">
      <div class="row">
        <div class="col-lg-6 head-top">
          <nav aria-label="breadcrumb">
            <ol class="breadcrumb">
              <li class="breadcrumb-item">
                <a [routerLink]="['/']">Home</a>
              </li>
              <li class="breadcrumb-item">
                <a [routerLink]="['/handbook']">Handbook</a>
              </li>
              <li class="breadcrumb-item activebread">
                <a [routerLink]="['/handbook/grammar']">Grammar</a>
              </li>
            </ol>
          </nav>

          <h1 class="mb-2 heading">Grammar</h1>
          <p class="py-3 head-p">
            Words were once wild like a big jumble. But Grammar fixed them. It
            taught them to line up, follow the rules, and make sensible
            sentences. Now, words are polite and orderly, and we can understand
            each other easily.
          </p>

          <a
            class="handbook-btn1"
            style="
              cursor: pointer;
              display: inline-flex;
              align-items: center;
              text-decoration: none;
            "
            [routerLink]="['/grammar-checker']"
          >
            <p>Get GrammarIn’s Grammar Checker for Free</p>
            <img
              src="/assets/images/handbook/white-arrow.svg"
              height="30px"
              width="30px"
              alt="white-arrow"
              class="ms-2"
            />
          </a>
        </div>

        <div class="col-lg-6 img-col">
          <img
            src="../../assets/images/handbook/Hgrammar.png"
            alt="grammar"
            style="width: 568px; height: 412px"
            class="mt-4 handbok-img"
            style="width: 568px; height: 412px"
          />
        </div>
      </div>
    </div>
  </div>

  <section class="common-writing">
    <div class="container">
      <div class="row mt-4">
        <div class="col-lg-4 col-12">
          <div class="common-tab">
            <h3>Conceptions of Grammar</h3>
            <p>
              Grammar is the underlying structure of a language. It includes
              phonology, morphology, syntax,<a
                href="https://www.grammarin.com/handbook/style"
                class="aTag"
              >
                style
              </a>
              and semantics. It can be prescriptive, descriptive, or generative,
              depending on the focus of the person studying. Grammar has
              undergone a complete transformation over time.
            </p>
          </div>
        </div>
        <div class="col-lg-4 col-12 martop">
          <div class="common-tab">
            <h3>Ancient and Medieval Grammars</h3>
            <p>
              The Greeks first developed grammar to study literary language.
              Later, the Romans adopted the Greek system. Latin grammarians,
              focused on discovering structures and protecting language from
              decay. Finally, grammarians from Port-Royal sought a universal
              grammar that was more focused on linguistics.
            </p>
          </div>
        </div>
        <div class="col-lg-4 col-12 martop">
          <div class="common-tab">
            <h3>Modern and Contemporary Grammars</h3>
            <p>
              In the century 1700, grammars of 61 language dialects were printed
              for standardizing language. This prescriptive approach dominated
              schools. However, historical linguistics scholars studied all
              types of written records of modern European languages, including
              dialects and contemporary spoken languages.
            </p>
          </div>
        </div>
      </div>
    </div>
  </section>

  <div class="hero-1 mb-5">
    <div class="container-fluid">
      <div class="container">
        <div class="row mt-5">
          <div class="row text-center justify-content-center">
            <div class="col-lg-9 col-md-9 mb-4">
              <h2 class="title mt-5">Primary Components of Grammar</h2>
              <span class="description p-5"
                >The primary components of grammar are essential for
                understanding and constructing sentences correctly. These
                components include:
              </span>
            </div>
          </div>

          <div class="col-lg-3 col-md-4 col-12 hvr-icon-hang">
            <a [routerLink]="['/what-are-modifiers']">
              <div class="card">
                <div class="img-pen">
                  <span> Modifiers </span>
                  <div class="arrow hvr-icon-hang">
                    <div id="section-arrow" class="hvr-icon"></div>
                  </div>
                </div>
                <p>
                  A modifier adds additional information to another element in a
                  sentence.
                </p>
              </div>
            </a>
          </div>

          <div class="col-lg-3 col-md-4 col-12 hvr-icon-hang">
            <a [routerLink]="['/what-are-adjectives']">
              <div class="card">
                <div class="img-pen">
                  <span> Adjectives </span>
                  <div class="arrow hvr-icon-hang">
                    <div id="section-arrow" class="hvr-icon"></div>
                  </div>
                </div>
                <p>
                  Adjectives give us more information about nouns (people,
                  animals, places or things) and pronouns.
                </p>
              </div>
            </a>
          </div>

          <div class="col-lg-3 col-md-4 col-12 hvr-icon-hang">
            <a [routerLink]="['/what-are-determiners']">
              <div class="card">
                <div class="img-pen">
                  <span> Determiners </span>
                  <div class="arrow hvr-icon-hang">
                    <div id="section-arrow" class="hvr-icon"></div>
                  </div>
                </div>
                <p>
                  A determiner is a word that introduces a noun. It appears
                  before noun and any adjectives describing the noun.
                </p>
              </div>
            </a>
          </div>

          <div class="col-lg-3 col-md-4 col-12 hvr-icon-hang">
            <a [routerLink]="['/what-are-adverbs']">
              <div class="card">
                <div class="img-pen">
                  <span> Adverbs </span>
                  <div class="arrow hvr-icon-hang">
                    <div id="section-arrow" class="hvr-icon"></div>
                  </div>
                </div>
                <p>
                  An adverb is a word that modifies (describes) a verb, an
                  adjective, another adverb, or even a whole sentence.
                </p>
              </div>
            </a>
          </div>

          <div class="col-lg-3 col-md-4 col-12 hvr-icon-hang">
            <a [routerLink]="['/what-are-articles']">
              <div class="card">
                <div class="img-pen">
                  <span> Articles </span>
                  <div class="arrow hvr-icon-hang">
                    <div id="section-arrow" class="hvr-icon"></div>
                  </div>
                </div>
                <p>
                  Articles are words that define a noun as specific or
                  unspecific.
                </p>
              </div>
            </a>
          </div>

          <div class="col-lg-3 col-md-4 col-12 hvr-icon-hang">
            <a [routerLink]="['/what-are-conjunction']">
              <div class="card">
                <div class="img-pen">
                  <span> Conjunctions </span>
                  <div class="arrow hvr-icon-hang">
                    <div id="section-arrow" class="hvr-icon"></div>
                  </div>
                </div>
                <p>
                  Conjunction are words that link other words, phrases, or
                  clauses together.
                </p>
              </div>
            </a>
          </div>

          <div class="col-lg-3 col-md-4 col-12 hvr-icon-hang">
            <a [routerLink]="['/what-are-interjections']">
              <div class="card">
                <div class="img-pen">
                  <span> Interjections </span>
                  <div class="arrow hvr-icon-hang">
                    <div id="section-arrow" class="hvr-icon"></div>
                  </div>
                </div>
                <p>
                  An interjection is a word that you use in between sentences or
                  thoughts to express a sudden feeling.
                </p>
              </div>
            </a>
          </div>

          <div class="col-lg-3 col-md-4 col-12 hvr-icon-hang">
            <a [routerLink]="['/what-are-nouns']">
              <div class="card">
                <div class="img-pen">
                  <span> Nouns </span>
                  <div class="arrow hvr-icon-hang">
                    <div id="section-arrow" class="hvr-icon"></div>
                  </div>
                </div>
                <p>
                  A noun is a word that names something: either a person, place,
                  feeling or tangible and intangible thing.
                </p>
              </div>
            </a>
          </div>

          <div class="col-lg-3 col-md-4 col-12 hvr-icon-hang">
            <a [routerLink]="['/what-are-prepositions']">
              <div class="card">
                <div class="img-pen">
                  <span> Prepositions </span>
                  <div class="arrow hvr-icon-hang">
                    <div id="section-arrow" class="hvr-icon"></div>
                  </div>
                </div>
                <p>
                  Prepositions indicate relationships between other words in a
                  sentence.
                </p>
              </div>
            </a>
          </div>

          <div class="col-lg-3 col-md-4 col-12 hvr-icon-hang">
            <a [routerLink]="['/what-are-pronouns']">
              <div class="card">
                <div class="img-pen">
                  <span> Pronouns </span>
                  <div class="arrow hvr-icon-hang">
                    <div id="section-arrow" class="hvr-icon"></div>
                  </div>
                </div>
                <p>
                  Pronouns substitute other nouns. Also, these are very
                  effective cohesive device.
                </p>
              </div>
            </a>
          </div>

          <div class="col-lg-3 col-md-4 col-12 hvr-icon-hang">
            <a [routerLink]="['/what-is-a-verb']">
              <div class="card">
                <div class="img-pen">
                  <span> Verbs </span>
                  <div class="arrow hvr-icon-hang">
                    <div id="section-arrow" class="hvr-icon"></div>
                  </div>
                </div>
                <p>
                  A verb is a word that expresses action. The action can be
                  physical, mental or state of being.
                </p>
              </div>
            </a>
          </div>
        </div>
      </div>
    </div>
  </div>
  <section class="common-writing">
    <div class="container">
      <div class="row text-center justify-content-center">
        <div class="col-lg-9 col-md-9 mb-4">
          <h2 class="title mt-5">Grammar in Different Forms of Writing</h2>
          <span class="description p-5">
            In today’s modern era,
            <a href="https://www.grammarin.com/handbook/grammar" class="aTag">
              grammar</a
            >
            has taken different forms. It has various rules for each type of
            writing. Here is how it works.
          </span>
        </div>
      </div>

      <div class="row mt-4">
        <div class="col-lg-4 col-12">
          <div class="common-tab1">
            <h3>Academic Writing:</h3>
            <p>
              In academic writing, all the grammar rules are strictly followed.
              The text is written in a formal tone with perfect use of
              <a
                class="aTag"
                href="https://www.grammarin.com/what-are-adjectives"
                >adjectives </a
              >,
              <a class="aTag" href="https://www.grammarin.com/what-are-adverbs"
                >adverbs
              </a>
              , complex sentence structure, no slang, no
              <a
                class="aTag"
                href="https://www.grammarin.com/what-are-contractions"
                >contractions </a
              >, and is described in a third-person perspective.
            </p>
          </div>
        </div>
        <div class="col-lg-4 col-12 martop">
          <div class="common-tab1">
            <h3>Business Writing:</h3>
            <p>
              For business or professional writing, the wording and structure
              used are easy to read. It uses relevant technical terms to be
              precise. The aim of business writing is to communicate so the
              language is clear and the structure is readable.
            </p>
          </div>
        </div>
        <div class="col-lg-4 col-12 martop">
          <div class="common-tab1">
            <h3>Creative Writing:</h3>
            <p>
              This is the form of writing, where you are not bound by the
              grammar. You can let the artist inside you jot down the
              imagination without having to follow all the strict grammar rules.
              You can invent new analogies and use them in writing creatively.
            </p>
          </div>
        </div>
      </div>
    </div>
  </section>
  <br /><br /><br />
</div>
<div class="" *ngIf="section === 'punctuation'">
  <div class="container-fluid heros">
    <app-header></app-header>
    <div class="container hand-book-container">
      <div class="row">
        <div class="col-lg-6 head-top">
          <nav aria-label="breadcrumb">
            <ol class="breadcrumb">
              <li class="breadcrumb-item">
                <a [routerLink]="['/']">Home</a>
              </li>
              <li class="breadcrumb-item">
                <a [routerLink]="['/handbook']">Handbook</a>
              </li>
              <li class="breadcrumb-item activebread">
                <a [routerLink]="['/handbook/punctuation']">Punctuation</a>
              </li>
            </ol>
          </nav>
          <h1 class="mb-2 heading">Punctuation</h1>
          <p class="py-3 head-p">
            Punctuation marks are like traffic signals for words. They tell
            words when to stop, go, or slow down. Without them, sentences would
            be in a rush, like cars driving without rules.
          </p>
          <br /><br />
          <a
            class="handbook-btn1"
            style="
              cursor: pointer;
              display: inline-flex;
              align-items: center;
              text-decoration: none;
            "
            [routerLink]="['/punctuation-checker']"
          >
            <p>Get GrammarIn’s Punctuation Checker for Free</p>
            <img
              src="/assets/images/handbook/white-arrow.svg"
              height="30px"
              width="30px"
              alt="white-arrow"
              class="ms-2"
            />
          </a>
        </div>
        <div class="col-lg-6 img-col">
          <img
            src="../../assets/images/handbook/Hgrammar.png"
            alt="grammar"
            style="width: 568px; height: 412px"
            class="mt-4 handbok-img"
            style="width: 568px; height: 412px"
          />
        </div>
      </div>
    </div>
  </div>

  <div class="container" style="margin-bottom: 50px">
    <div class="row text-center justify-content-center">
      <div class="col-lg-9 col-md-9 mb-4">
        <h2 class="title">What is Punctuation?</h2>
        <span class="description p-5"
          >Punctuation is the use of specific marks at certain places in the
          text. They work as silent intonation to separate sentences and other
          elements. The punctuation signs are also used to take a pause, set the
          tone, and make it easy to follow the flow of ideas.</span
        >
      </div>
    </div>
  </div>

  <section class="intro-section mt-2s">
    <div class="container">
      <div class="row">
        <div class="col-lg-6 col-md-12 col-sm-12 intro-list-col">
          <img
            src="../../assets/images/punctuation/Group 38050.svg"
            alt="How Does GrammarIn"
            width="588px"
            height="362px"
          />
        </div>
        <div class="col-lg-6 col-md-12 col-sm-12 intro-list-text">
          <div class="introduction mt-5">
            <h2 class="titleL">Understand the Basics of Punctuation</h2>
            <p class="descriptionL mt-3">
              Punctuation signs such as
              <a class="aTag" href="https://www.grammarin.com/what-is-a-comma"
                >commas </a
              >,<a
                class="aTag"
                href="https://www.grammarin.com/what-is-a-period"
              >
                periods</a
              >
              ,
              <a
                class="aTag"
                href="https://www.grammarin.com/what-does-exclamation-mark-mean"
                >exclamation marks </a
              >,
              <a
                class="aTag"
                href="https://www.grammarin.com/how-to-do-upside-down-question-mark"
                >question marks </a
              >,
              <a class="aTag" href="https://www.grammarin.com/what-are-slashes"
                >slashes </a
              >,
              <a
                class="aTag"
                href="https://www.grammarin.com/what-are-parentheses"
              >
                parentheses</a
              >,
              <a class="aTag" href="https://www.grammarin.com/what-is-brackets">
                brackets</a
              >,
              <a
                class="aTag"
                href="https://www.grammarin.com/what-are-apostrophes"
              >
                apostrophes</a
              >,
              <a
                class="aTag"
                href="https://www.grammarin.com/what-is-an-ellipsis"
                >ellipsis
              </a>
              and
              <a class="aTag" href="https://www.grammarin.com/what-are-dashes"
                >dashes
              </a>
              are helpful for the reader to understand the context. They tell us
              where to pause, stop, stress, or inquire. Punctuation signs direct
              the reader to understand the text clearly without missing any
              detail. It adds precision and gives the writing a specific tone at
              certain parts.
            </p>
          </div>
        </div>
      </div>
    </div>
  </section>

  <div class="hero-1 mb-5">
    <div class="container-fluid">
      <div class="container">
        <div class="row mt-5">
          <div class="row text-center justify-content-center">
            <div class="col-lg-9 col-md-9 mb-4">
              <h2 class="title mt-2">Primary Components of Punctuation</h2>
              <span class="description p-5"
                >The primary components of
                <a
                  class="aTag"
                  href="https://www.grammarin.com/handbook/punctuation"
                >
                  punctuation</a
                >
                are essential for organizing and clarifying written
                communication. These components include:</span
              >
            </div>
          </div>
          <div class="col-lg-3 col-md-4 col-12 hvr-icon-hang">
            <a [routerLink]="['/what-are-apostrophes']">
              <div class="card">
                <div class="img-pen">
                  <span> Apostrophes </span>
                  <div class="arrow hvr-icon-hang">
                    <div id="section-arrow" class="hvr-icon"></div>
                  </div>
                </div>
                <p>Apostrophes form possessives and contractions.</p>
              </div>
            </a>
          </div>
          <div class="col-lg-3 col-md-4 col-12 hvr-icon-hang">
            <a [routerLink]="['/what-is-a-colon']">
              <div class="card">
                <div class="img-pen">
                  <span> Colon </span>
                  <div class="arrow hvr-icon-hang">
                    <div id="section-arrow" class="hvr-icon"></div>
                  </div>
                </div>
                <p>
                  A colon is used in a sentence to further demonstrate or
                  exemplify the information.
                </p>
              </div>
            </a>
          </div>
          <div class="col-lg-3 col-md-4 col-12 hvr-icon-hang">
            <a [routerLink]="['/what-is-a-comma']">
              <div class="card">
                <div class="img-pen">
                  <span> Comma </span>
                  <div class="arrow hvr-icon-hang">
                    <div id="section-arrow" class="hvr-icon"></div>
                  </div>
                </div>
                <p>
                  While a period ends a sentence, a comma indicates a smaller
                  break.
                </p>
              </div>
            </a>
          </div>
          <div class="col-lg-3 col-md-4 col-12 hvr-icon-hang">
            <a [routerLink]="['/what-are-dashes']">
              <div class="card">
                <div class="img-pen">
                  <span> Dashes </span>
                  <div class="arrow hvr-icon-hang">
                    <div id="section-arrow" class="hvr-icon"></div>
                  </div>
                </div>
                <p>
                  A dash is a little horizontal line that is placed in the
                  middle of a line of text.
                </p>
              </div>
            </a>
          </div>
          <div class="col-lg-3 col-md-4 col-12 hvr-icon-hang">
            <a [routerLink]="['/what-is-an-ellipsis']">
              <div class="card">
                <div class="img-pen">
                  <span> Ellipsis </span>
                  <div class="arrow hvr-icon-hang">
                    <div id="section-arrow" class="hvr-icon"></div>
                  </div>
                </div>
                <p>
                  Three little dots (…) are called an ellipsis (plural:
                  ellipses)
                </p>
              </div>
            </a>
          </div>
          <div class="col-lg-3 col-md-4 col-12 hvr-icon-hang">
            <a [routerLink]="['/what-does-exclamation-mark-mean']">
              <div class="card">
                <div class="img-pen">
                  <span> Exclamation Mark </span>
                  <div class="arrow hvr-icon-hang">
                    <div id="section-arrow" class="hvr-icon"></div>
                  </div>
                </div>
                <p>
                  Exclamation mark is used to convey emotion and intent that can
                  be expressed through the tone if spoken.
                </p>
              </div>
            </a>
          </div>
          <div class="col-lg-3 col-md-4 col-12 hvr-icon-hang">
            <a [routerLink]="['/what-are-parentheses']">
              <div class="card">
                <div class="img-pen">
                  <span> Parentheses </span>
                  <div class="arrow hvr-icon-hang">
                    <div id="section-arrow" class="hvr-icon"></div>
                  </div>
                </div>
                <p>
                  Parentheses are punctuation marks that are used to set off
                  information within a text or paragraph.
                </p>
              </div>
            </a>
          </div>
          <div class="col-lg-3 col-md-4 col-12 hvr-icon-hang">
            <a [routerLink]="['/what-is-a-period']">
              <div class="card">
                <div class="img-pen">
                  <span> Period </span>
                  <div class="arrow hvr-icon-hang">
                    <div id="section-arrow" class="hvr-icon"></div>
                  </div>
                </div>
                <p>
                  The most common use of the period is to end a declarative
                  sentence.
                </p>
              </div>
            </a>
          </div>
          <div class="col-lg-3 col-md-4 col-12 hvr-icon-hang">
            <a [routerLink]="['/how-to-do-upside-down-question-mark']">
              <div class="card">
                <div class="img-pen">
                  <span> Question Mark (?) </span>
                  <div class="arrow hvr-icon-hang">
                    <div id="section-arrow" class="hvr-icon"></div>
                  </div>
                </div>
                <p>
                  The main purpose of a question mark is to indicate that a
                  sentence is a question.
                </p>
              </div>
            </a>
          </div>
          <div class="col-lg-3 col-md-4 col-12 hvr-icon-hang">
            <a [routerLink]="['/when-to-use-quotation-marks']">
              <div class="card">
                <div class="img-pen">
                  <span> Quotation Marks (“ ”) </span>
                  <div class="arrow hvr-icon-hang">
                    <div id="section-arrow" class="hvr-icon"></div>
                  </div>
                </div>
                <p>
                  Quotation marks are used to identify words that someone has
                  said.
                </p>
              </div>
            </a>
          </div>
          <div class="col-lg-3 col-md-4 col-12 hvr-icon-hang">
            <a [routerLink]="['/what-is-a-semicolon']">
              <div class="card">
                <div class="img-pen">
                  <span> Semicolon (;) </span>
                  <div class="arrow hvr-icon-hang">
                    <div id="section-arrow" class="hvr-icon"></div>
                  </div>
                </div>
                <p>
                  The most common use of the semicolon is to join two
                  independent clauses without using a conjunction like and.
                </p>
              </div>
            </a>
          </div>
          <div class="col-lg-3 col-md-4 col-12 hvr-icon-hang">
            <a [routerLink]="['/what-are-slashes']">
              <div class="card">
                <div class="img-pen">
                  <span> Slashes (/) </span>
                  <div class="arrow hvr-icon-hang">
                    <div id="section-arrow" class="hvr-icon"></div>
                  </div>
                </div>
                <p>
                  The backslash is used in coding, while the forward slash is a
                  punctuation mark in English.
                </p>
              </div>
            </a>
          </div>
          <!-- <div class="col-lg-3 col-md-4 col-12 hvr-icon-hang">
            <a [routerLink]="['/what-is-hyphen']">
              <div class="card">
                <div class="img-pen">
                  <span>
                    Hyphen (-)
                  </span>
                  <div class="arrow hvr-icon-hang">
                    <div id="section-arrow" class="hvr-icon"></div>
                  </div>
                </div>
                <p>A hyphen (-) is a punctuation mark that is used to join words or parts of words. </p>
              </div>
            </a>
          </div> -->
          <div class="col-lg-3 col-md-4 col-12 hvr-icon-hang">
            <a [routerLink]="['/what-is-brackets']">
              <div class="card">
                <div class="img-pen">
                  <span> Brackets [] </span>
                  <div class="arrow hvr-icon-hang">
                    <div id="section-arrow" class="hvr-icon"></div>
                  </div>
                </div>
                <p>
                  Square brackets are used to indicate added words in a direct
                  quotation.
                </p>
              </div>
            </a>
          </div>
        </div>
      </div>
    </div>
  </div>

  <section class="fqa mt-5 mb-5">
    <div class="container">
      <div class="row text-center justify-content-center">
        <div class="col-lg-9 col-md-9 mb-4 mt-5">
          <h2 class="title main-display">Frequently Asked Questions</h2>
        </div>
      </div>

      <div class="v-pills-tab-list row mt-3">
        <div class="col-md-6" id="row_faqs">
          <div
            class="nav flex-column nav-pills"
            id="v-pills-tab"
            role="tablist"
            aria-orientation="vertical"
          >
            <div
              class="nav-link nav-pills"
              [ngClass]="{ active: activeTab === 'q1' }"
              (click)="toggleTab('q1')"
              id="v-pills-first-tab"
              aria-controls="q1"
              aria-expanded="false"
            >
              <h3 class="ms-3">
                <div class="d-flex nav-linkFAQ">
                  <div>
                    <span
                      class="card-header faqHeading"
                      [class.closed]="activeTab !== 'q1'"
                      >What is the purpose of punctuation in writing?
                    </span>
                  </div>
                  <div>
                    <img
                      src="../assets/images/homepage/plus.svg"
                      width="18px"
                      height="18px"
                      alt="plus"
                      *ngIf="activeTab !== 'q1'"
                      class="float-right mt-1 faqImag"
                    />
                    <img
                      src="../assets/images/homepage/minus.svg"
                      width="18px"
                      height="18px"
                      alt="minus"
                      *ngIf="activeTab === 'q1'"
                      class="float-right mt-1 faqImag"
                    />
                  </div>
                </div>
              </h3>
              <div
                aria-labelledby="q1"
                class="collapse"
                [ngClass]="{ show: activeTab === 'q1' }"
                id="q1"
                role="tabpanel"
                data-parent="#v-pills-tab-list"
              >
                <div class="card-body faqPar ms-3 me-3">
                  Punctuation helps readers to understand the ideas in a written
                  piece. It provides structure and clarity by breaking up the
                  sentences or adding emphasis to some phrases.
                </div>
              </div>
            </div>

            <div class="mb-4"></div>

            <div
              class="nav-link nav-pills"
              [ngClass]="{ active: activeTab === 'q2' }"
              (click)="toggleTab('q2')"
              id="v-pills-2nd-tab"
              aria-controls="q2"
              aria-expanded="false"
            >
              <h3 class="ms-3">
                <div class="d-flex nav-linkFAQ">
                  <div>
                    <span
                      class="card-header faqHeading"
                      [class.closed]="activeTab !== 'q2'"
                      >Why is proper punctuation important for effective
                      communication?
                    </span>
                  </div>
                  <div>
                    <img
                      src="../assets/images/homepage/plus.svg"
                      width="18px"
                      height="18px"
                      alt="plus"
                      *ngIf="activeTab !== 'q2'"
                      class="float-right mt-1 faqImag"
                    />
                    <img
                      src="../assets/images/homepage/minus.svg"
                      width="18px"
                      height="18px"
                      alt="minus"
                      *ngIf="activeTab === 'q2'"
                      class="float-right mt-1 faqImag"
                    />
                  </div>
                </div>
              </h3>
              <div
                aria-labelledby="q2"
                class="collapse"
                [ngClass]="{ show: activeTab === 'q2' }"
                id="q2"
                role="tabpanel"
                data-parent="#v-pills-tab-list"
              >
                <div class="card-body faqPar ms-3 me-3">
                  Proper punctuation helps to clarify the tone, enhances
                  readability, and prevents miscommunication. Through these
                  signs, the reader will know where to emphasize, pause, or
                  stop.
                </div>
              </div>
            </div>

            <div class="mb-4"></div>

            <div
              class="nav-link nav-pills"
              [ngClass]="{ active: activeTab === 'q3' }"
              (click)="toggleTab('q3')"
              id="v-pills-3rd-tab"
              aria-controls="q3"
              aria-expanded="false"
            >
              <h3 class="ms-3">
                <div class="d-flex nav-linkFAQ">
                  <div>
                    <span
                      class="card-header faqHeading"
                      [class.closed]="activeTab !== 'q3'"
                      >How does punctuation affect the meaning of a sentence?
                    </span>
                  </div>
                  <div>
                    <img
                      src="../assets/images/homepage/plus.svg"
                      width="18px"
                      height="18px"
                      alt="plus"
                      *ngIf="activeTab !== 'q3'"
                      class="float-right mt-1 faqImag"
                    />
                    <img
                      src="../assets/images/homepage/minus.svg"
                      width="18px"
                      height="18px"
                      alt="minus"
                      *ngIf="activeTab === 'q3'"
                      class="float-right mt-1 faqImag"
                    />
                  </div>
                </div>
              </h3>
              <div
                aria-labelledby="q3"
                class="collapse"
                [ngClass]="{ show: activeTab === 'q3' }"
                id="q3"
                role="tabpanel"
                data-parent="#v-pills-tab-list"
              >
                <div class="card-body faqPar ms-3 me-3">
                  One missed comma, or exclamation mark can completely change
                  the meaning of the sentence. “You are sick!” seems quite
                  offensive while “You are sick?” conveys that the person saying
                  this is concerned about your well-being.
                </div>
              </div>
            </div>

            <div class="mb-4 osmal"></div>
          </div>
        </div>
        <div class="col-md-6">
          <div
            class="nav flex-column nav-pills"
            id="v-pills-tab"
            role="tablist"
            aria-orientation="vertical"
          >
            <div
              class="nav-link nav-pills"
              [ngClass]="{ active: activeTab === 'q4' }"
              (click)="toggleTab('q4')"
              id="v-pills-4th-tab"
              aria-controls="q4"
              aria-expanded="false"
            >
              <h3 class="ms-3">
                <div class="d-flex nav-linkFAQ">
                  <div>
                    <span
                      class="card-header faqHeading"
                      [class.closed]="activeTab !== 'q4'"
                      >When should you use a semicolon instead of a period or
                      comma?
                    </span>
                  </div>
                  <div>
                    <img
                      src="../assets/images/homepage/plus.svg"
                      width="18px"
                      height="18px"
                      alt="plus"
                      *ngIf="activeTab !== 'q4'"
                      class="float-right mt-1 faqImag"
                    />
                    <img
                      src="../assets/images/homepage/minus.svg"
                      width="18px"
                      height="18px"
                      alt="minus"
                      *ngIf="activeTab === 'q4'"
                      class="float-right mt-1 faqImag"
                    />
                  </div>
                </div>
              </h3>
              <div
                aria-labelledby="q4"
                class="collapse"
                [ngClass]="{ show: activeTab === 'q4' }"
                id="q4"
                role="tabpanel"
                data-parent="#v-pills-tab-list"
              >
                <div class="card-body faqPar ms-3 me-3">
                  A comma is used to separate lists or take a pause, while a
                  period means the ending of a thought. A
                  <a
                    class="aTag"
                    href="https://www.grammarin.com/what-is-a-semicolon"
                  >
                    semicolon</a
                  >
                  is used instead of these when you want to join two independent
                  clauses that are closely related and also not joined by any
                  coordinating conjunction.
                </div>
              </div>
            </div>

            <div class="mb-4"></div>

            <div
              class="nav-link nav-pills"
              [ngClass]="{ active: activeTab === 'q5' }"
              (click)="toggleTab('q5')"
              id="v-pills-5th-tab"
              aria-controls="q5"
              aria-expanded="false"
            >
              <h3 class="ms-3">
                <div class="d-flex nav-linkFAQ">
                  <div>
                    <span
                      class="card-header faqHeading"
                      [class.closed]="activeTab !== 'q5'"
                      >What are the main differences between a dash and a
                      hyphen?
                    </span>
                  </div>
                  <div>
                    <img
                      src="../assets/images/homepage/plus.svg"
                      width="18px"
                      height="18px"
                      alt="plus"
                      *ngIf="activeTab !== 'q5'"
                      class="float-right mt-1 faqImag"
                    />
                    <img
                      src="../assets/images/homepage/minus.svg"
                      width="18px"
                      height="18px"
                      alt="minus"
                      *ngIf="activeTab === 'q5'"
                      class="float-right mt-1 faqImag"
                    />
                  </div>
                </div>
              </h3>
              <div
                aria-labelledby="q5"
                class="collapse"
                [ngClass]="{ show: activeTab === 'q5' }"
                id="q5"
                role="tabpanel"
                data-parent="#v-pills-tab-list"
              >
                <div class="card-body faqPar ms-3 me-3">
                  A dash is used to separate words, phrases, or clauses. It may
                  indicate a break or change in thought flow, or to insert an
                  interjection or pause. While a hyphen is used to join words
                  together. It is also used to link parts of a compound word
                  like self-esteem.
                </div>
              </div>
            </div>

            <div class="mb-4"></div>

            <div
              class="nav-link nav-pills"
              [ngClass]="{ active: activeTab === 'q6' }"
              (click)="toggleTab('q6')"
              id="v-pills-6th-tab"
              aria-controls="q6"
              aria-expanded="false"
            >
              <h3 class="ms-3">
                <div class="d-flex nav-linkFAQ">
                  <div>
                    <span
                      class="card-header faqHeading"
                      [class.closed]="activeTab !== 'q6'"
                      >What are some common uses for parentheses in writing?
                    </span>
                  </div>
                  <div>
                    <img
                      src="../assets/images/homepage/plus.svg"
                      width="18px"
                      height="18px"
                      alt="plus"
                      *ngIf="activeTab !== 'q6'"
                      class="float-right mt-1 faqImag"
                    />
                    <img
                      src="../assets/images/homepage/minus.svg"
                      width="18px"
                      height="18px"
                      alt="minus"
                      *ngIf="activeTab === 'q6'"
                      class="float-right mt-1 faqImag"
                    />
                  </div>
                </div>
              </h3>
              <div
                aria-labelledby="q6"
                class="collapse"
                [ngClass]="{ show: activeTab === 'q6' }"
                id="q6"
                role="tabpanel"
                data-parent="#v-pills-tab-list"
              >
                <div class="card-body faqPar ms-3 me-3">
                  Parentheses are used to enclose additional or non-essential
                  information in a sentence. It usually clarifies, explains, or
                  adds a side note in a sentence. It will prevent disrupting the
                  flow of the sentence while adding more insights.
                </div>
              </div>
            </div>

            <div class="mb-4"></div>
            <div
              class="nav-link nav-pills"
              [ngClass]="{ active: activeTab === 'q7' }"
              (click)="toggleTab('q7')"
              id="v-pills-7th-tab"
              aria-controls="q7"
              aria-expanded="false"
            >
              <h3 class="ms-3">
                <div class="d-flex nav-linkFAQ">
                  <div>
                    <span
                      class="card-header faqHeading"
                      [class.closed]="activeTab !== 'q7'"
                      >How can practicing punctuation improve overall writing
                      skills?
                    </span>
                  </div>
                  <div>
                    <img
                      src="../assets/images/homepage/plus.svg"
                      width="18px"
                      height="18px"
                      alt="plus"
                      *ngIf="activeTab !== 'q7'"
                      class="float-right mt-1 faqImag"
                    />
                    <img
                      src="../assets/images/homepage/minus.svg"
                      width="18px"
                      height="18px"
                      alt="minus"
                      *ngIf="activeTab === 'q7'"
                      class="float-right mt-1 faqImag"
                    />
                  </div>
                </div>
              </h3>
              <div
                aria-labelledby="q7"
                class="collapse"
                [ngClass]="{ show: activeTab === 'q7' }"
                id="q7"
                role="tabpanel"
                data-parent="#v-pills-tab-list"
              >
                <div class="card-body faqPar ms-3 me-3">
                  Practicing punctuation helps to add clarity in meaning,
                  improves readability, and demonstrates professionalism.
                  Writers can convey their ideas with precision and clarity by
                  understanding the correct use of punctuation in sentences. You
                  can also get the assistance of our advanced
                  <a
                    class="aTag"
                    href="https://www.grammarin.com/punctuation-checker"
                  >
                    punctuation checker</a
                  >
                  to improve your writing skills.
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</div>
<div class="" *ngIf="section === 'mechanics'">
  <div class="container-fluid heros">
    <app-header></app-header>
    <div class="container hand-book-container">
      <div class="row">
        <div class="col-lg-6 head-top">
          <nav aria-label="breadcrumb">
            <ol class="breadcrumb">
              <li class="breadcrumb-item">
                <a [routerLink]="['/']">Home</a>
              </li>
              <li class="breadcrumb-item">
                <a [routerLink]="['/handbook']">Handbook</a>
              </li>
              <li class="breadcrumb-item activebread">
                <a [routerLink]="['/handbook/mechanics']">Mechanics</a>
              </li>
            </ol>
          </nav>
          <h1 class="mb-2 heading">Mechanics</h1>
          <p class="py-3 head-p">
            Perfection in writing is only possible through writing mechanics.
            Learn what they are and how to master them for impactful and
            professional communication.
          </p>
          <br /><br />
          <a
            class="handbook-btn1"
            style="
              cursor: pointer;
              display: inline-flex;
              align-items: center;
              text-decoration: none;
            "
            [routerLink]="['/grammar-checker']"
          >
            <p>Correct Mechanics with GrammarIn Grammar Checker</p>
            <img
              src="/assets/images/handbook/white-arrow.svg"
              height="30px"
              width="30px"
              alt="white-arrow"
              class="ms-2"
            />
          </a>
        </div>
        <div class="col-lg-6 img-col">
          <img
            src="../../assets/images/handbook/Hgrammar.png"
            alt="grammar"
            style="width: 568px; height: 412px"
            class="mt-4 handbok-img"
            style="width: 568px; height: 412px"
          />
        </div>
      </div>
    </div>
  </div>
  <div class="container">
    <div class="row text-center justify-content-center">
      <div class="col-lg-9 col-md-9 mb-4">
        <h2 class="title">What Are Mechanics in Writing?</h2>
        <span class="description p-5"
          >Mechanics in the context of writing refers to technical guidelines
          and conventions that specify how to structure text properly. They
          generally revolve around the following factors:</span
        >
      </div>
    </div>
  </div>
  <div class="hero-1 mb-5">
    <div class="container-fluid">
      <div class="container">
        <div class="row mt-1">
          <div class="col-lg-3 col-md-4 col-12 hvr-icon-hang">
            <a [routerLink]="['/what-is-abbreviation']">
              <div class="card">
                <div class="img-pen">
                  <span> Abbreviation </span>
                  <div class="arrow hvr-icon-hang">
                    <div id="section-arrow" class="hvr-icon"></div>
                  </div>
                </div>
                <p>An abbreviation is a short form of a word or phrase.</p>
              </div>
            </a>
          </div>
          <div class="col-lg-3 col-md-4 col-12 hvr-icon-hang">
            <a [routerLink]="['/what-are-contractions']">
              <div class="card">
                <div class="img-pen">
                  <span> Contractions </span>
                  <div class="arrow hvr-icon-hang">
                    <div id="section-arrow" class="hvr-icon"></div>
                  </div>
                </div>
                <p>
                  A contraction is short form of a word or group of words by
                  omitting certain letters or sounds.
                </p>
              </div>
            </a>
          </div>
          <div class="col-lg-3 col-md-4 col-12 hvr-icon-hang">
            <a [routerLink]="['/what-are-spelling-rules']">
              <div class="card">
                <div class="img-pen">
                  <span> Spelling Rules </span>
                  <div class="arrow hvr-icon-hang">
                    <div id="section-arrow" class="hvr-icon"></div>
                  </div>
                </div>
                <p>Spellings are hard to learn. Reasons are many.</p>
              </div>
            </a>
          </div>
          <div class="col-lg-3 col-md-4 col-12 hvr-icon-hang">
            <a [routerLink]="['/what-is-capitalization']">
              <div class="card">
                <div class="img-pen">
                  <span> Rules of Capitalization </span>
                  <div class="arrow hvr-icon-hang">
                    <div id="section-arrow" class="hvr-icon"></div>
                  </div>
                </div>
                <p>
                  Prepositions indicate relationships between other words in a
                  sentence.
                </p>
              </div>
            </a>
          </div>
          <div class="col-lg-3 col-md-4 col-12 hvr-icon-hang">
            <a [routerLink]="['/what-are-compound-words']">
              <div class="card">
                <div class="img-pen">
                  <span> Compound Words </span>
                  <div class="arrow hvr-icon-hang">
                    <div id="section-arrow" class="hvr-icon"></div>
                  </div>
                </div>
                <p>
                  The words that are written together to produce a new meaning
                  are called compound words.
                </p>
              </div>
            </a>
          </div>
        </div>
      </div>
    </div>
  </div>

  <div class="container">
    <div class="row mb-5">
      <div class="col">
        <span class="description"
          >These factors facilitate the creation of precise, clear, and
          professional write-ups. Therefore, writers often keep all these in
          check in order to increase the readability and understanding of their
          text pieces.</span
        >
      </div>
    </div>
  </div>

  <div class="container" style="margin-bottom: 50px">
    <div class="row text-center justify-content-center">
      <div class="col-lg-9 col-md-9 mb-4">
        <h2 class="title">Why Are Mechanics Important?</h2>
        <span class="description p-5"
          >Writing mechanics are crucial in ensuring the clarity and
          professionalism of the intended message. Here is how:
        </span>
      </div>
    </div>
  </div>

  <section class="common-writing">
    <div class="container">
      <div class="row mt-4">
        <div class="col-lg-4 col-12">
          <div class="common-tab">
            <h3>Clarity:</h3>
            <p>
              Errors in abbreviations, compound words, contractions, and
              spelling rules can change the text’s meaning. But when you use
              these writing mechanics properly, you make it easier for readers
              to understand your target message without becoming victims of any
              confusion.
            </p>
          </div>
        </div>
        <div class="col-lg-4 col-12 martop">
          <div class="common-tab">
            <h3>Professionalism:</h3>
            <p>
              If you craft content with flawless writing mechanics, it will
              reflect professionalism in your work. This professionalism will
              eventually help you build trust and credibility among readers and
              your community.
            </p>
          </div>
        </div>
        <div class="col-lg-4 col-12 martop">
          <div class="common-tab">
            <h3>Consistency:</h3>
            <p>
              Inconsistency in writing mechanics can distract readers.
              Therefore, when you follow all the writing mechanics correctly in
              a write-up, this will improve your content’s readability and make
              it easier to understand.
            </p>
          </div>
        </div>
      </div>
    </div>
  </section>

  <br /><br />
  <div class="container" style="margin-bottom: 50px">
    <div class="row text-center justify-content-center">
      <div class="col-lg-9 col-md-9 mb-4">
        <h2 class="title">Tips for Mastering Writing Mechanics</h2>
        <span class="description p-5"
          >Mastering the art of using writing mechanics correctly may sound
          overwhelming, but it’s not. Simply by following these tips, you can
          maintain accuracy in your work and sharpen your skills in no time:
        </span>
      </div>
    </div>

    <br />
    <div class="row">
      <div class="col-lg-6">
        <div class="common-tab-mec">
          <h3>Proofread:</h3>
          <p>
            Perfection in the implementation of writing mechanics becomes
            possible through proofreading. Therefore, read your text aloud,
            which will help you locate all the underlying hidden common errors,
            such as the ones related to grammar, punctuation, and spelling.
          </p>
        </div>
      </div>
      <div class="col-lg-6">
        <div class="common-tab-mec">
          <h3>Learn the Rules:</h3>
          <p>
            Getting better at writing mechanics adaptation is impossible if you
            don’t know the basic rules. Therefore, enroll yourself in a grammar
            course or use a reliable style guide to familiarize yourself with
            the essentials.
          </p>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-lg-6">
        <div class="common-tab-mec">
          <h3>Use Tools:</h3>
          <p>
            You can also learn to follow writing mechanics correctly by taking
            assistance from GrammarIn’s
            <a
              href="https://www.grammarin.com/grammar-checker"
              style="color: black; text-decoration: underline"
              >grammar checker </a
            >. Such a tool can quickly catch errors and suggest improvements by
            understanding your content’s context. But make sure to review its
            recommendations before applying.
          </p>
        </div>
      </div>
      <div class="col-lg-6">
        <div class="common-tab-mec">
          <h3>Practice:</h3>
          <p>
            Perfection in adapting writing mechanics demands practice.
            Therefore, develop a habit of conducting a writing exercise, such as
            blogging or journaling, daily with the implementation of appropriate
            writing mechanics. Doing so will gradually refine your skillset.
          </p>
        </div>
      </div>
    </div>
  </div>

  <section class="fqa mt-5 mb-5">
    <div class="container">
      <div class="row text-center justify-content-center">
        <div class="col-lg-9 col-md-9 mb-4 mt-5">
          <h2 class="title main-display">
            Frequently Asked Questions Related to Mechanics
          </h2>
        </div>
      </div>

      <div class="v-pills-tab-list row mt-3">
        <div class="col-md-6" id="row_faqs">
          <div
            class="nav flex-column nav-pills"
            id="v-pills-tab"
            role="tablist"
            aria-orientation="vertical"
          >
            <div
              class="nav-link nav-pills"
              [ngClass]="{ active: activeTab === 'q1' }"
              (click)="toggleTab('q1')"
              id="v-pills-first-tab"
              aria-controls="q1"
              aria-expanded="false"
            >
              <h3 class="ms-3">
                <div class="d-flex nav-linkFAQ">
                  <div>
                    <span
                      class="card-header faqHeading"
                      [class.closed]="activeTab !== 'q1'"
                      >What Are the Key Components of Writing Mechanics?
                    </span>
                  </div>
                  <div>
                    <img
                      src="../assets/images/homepage/plus.svg"
                      width="18px"
                      height="18px"
                      alt="plus"
                      *ngIf="activeTab !== 'q1'"
                      class="float-right mt-1 faqImag"
                    />
                    <img
                      src="../assets/images/homepage/minus.svg"
                      width="18px"
                      height="18px"
                      alt="minus"
                      *ngIf="activeTab === 'q1'"
                      class="float-right mt-1 faqImag"
                    />
                  </div>
                </div>
              </h3>
              <div
                aria-labelledby="q1"
                class="collapse"
                [ngClass]="{ show: activeTab === 'q1' }"
                id="q1"
                role="tabpanel"
                data-parent="#v-pills-tab-list"
              >
                <div class="card-body faqPar ms-3 me-3">
                  Writing mechanics generally revolves around the following key
                  components: abbreviations, capitalization, compound words,
                  contractions, and spelling rules.
                </div>
              </div>
            </div>

            <div class="mb-4"></div>

            <div
              class="nav-link nav-pills"
              [ngClass]="{ active: activeTab === 'q2' }"
              (click)="toggleTab('q2')"
              id="v-pills-2nd-tab"
              aria-controls="q2"
              aria-expanded="false"
            >
              <h3 class="ms-3">
                <div class="d-flex nav-linkFAQ">
                  <div>
                    <span
                      class="card-header faqHeading"
                      [class.closed]="activeTab !== 'q2'"
                      >Why Is It Important to Pay Attention to Mechanics When
                      Writing?
                    </span>
                  </div>
                  <div>
                    <img
                      src="../assets/images/homepage/plus.svg"
                      width="18px"
                      height="18px"
                      alt="plus"
                      *ngIf="activeTab !== 'q2'"
                      class="float-right mt-1 faqImag"
                    />
                    <img
                      src="../assets/images/homepage/minus.svg"
                      width="18px"
                      height="18px"
                      alt="minus"
                      *ngIf="activeTab === 'q2'"
                      class="float-right mt-1 faqImag"
                    />
                  </div>
                </div>
              </h3>
              <div
                aria-labelledby="q2"
                class="collapse"
                [ngClass]="{ show: activeTab === 'q2' }"
                id="q2"
                role="tabpanel"
                data-parent="#v-pills-tab-list"
              >
                <div class="card-body faqPar ms-3 me-3">
                  When writing, paying attention to the appropriate mechanics is
                  essential because doing so guarantees the creation of clear,
                  consistent, professional, and well-polished content.
                </div>
              </div>
            </div>

            <div class="mb-4 osmal"></div>
          </div>
        </div>
        <div class="col-md-6">
          <div
            class="nav flex-column nav-pills"
            id="v-pills-tab"
            role="tablist"
            aria-orientation="vertical"
          >
            <div
              class="nav-link nav-pills"
              [ngClass]="{ active: activeTab === 'q4' }"
              (click)="toggleTab('q4')"
              id="v-pills-4th-tab"
              aria-controls="q4"
              aria-expanded="false"
            >
              <h3 class="ms-3">
                <div class="d-flex nav-linkFAQ">
                  <div>
                    <span
                      class="card-header faqHeading"
                      [class.closed]="activeTab !== 'q4'"
                      >How Do Proper Mechanics Improve the Readability of Your
                      Writing?</span
                    >
                  </div>
                  <div>
                    <img
                      src="../assets/images/homepage/plus.svg"
                      width="18px"
                      height="18px"
                      alt="plus"
                      *ngIf="activeTab !== 'q4'"
                      class="float-right mt-1 faqImag"
                    />
                    <img
                      src="../assets/images/homepage/minus.svg"
                      width="18px"
                      height="18px"
                      alt="minus"
                      *ngIf="activeTab === 'q4'"
                      class="float-right mt-1 faqImag"
                    />
                  </div>
                </div>
              </h3>
              <div
                aria-labelledby="q4"
                class="collapse"
                [ngClass]="{ show: activeTab === 'q4' }"
                id="q4"
                role="tabpanel"
                data-parent="#v-pills-tab-list"
              >
                <div class="card-body faqPar ms-3 me-3">
                  When you properly follow the appropriate writing mechanics,
                  your content will automatically be easy to follow and read. As
                  a result, people will be able to understand your intended
                  message easily.
                </div>
              </div>
            </div>

            <div class="mb-4"></div>

            <div
              class="nav-link nav-pills"
              [ngClass]="{ active: activeTab === 'q5' }"
              (click)="toggleTab('q5')"
              id="v-pills-5th-tab"
              aria-controls="q5"
              aria-expanded="false"
            >
              <h3 class="ms-3">
                <div class="d-flex nav-linkFAQ">
                  <div>
                    <span
                      class="card-header faqHeading"
                      [class.closed]="activeTab !== 'q5'"
                      >How Can Regular Practice Help Improve Your Writing
                      Mechanics?
                    </span>
                  </div>
                  <div>
                    <img
                      src="../assets/images/homepage/plus.svg"
                      width="18px"
                      height="18px"
                      alt="plus"
                      *ngIf="activeTab !== 'q5'"
                      class="float-right mt-1 faqImag"
                    />
                    <img
                      src="../assets/images/homepage/minus.svg"
                      width="18px"
                      height="18px"
                      alt="minus"
                      *ngIf="activeTab === 'q5'"
                      class="float-right mt-1 faqImag"
                    />
                  </div>
                </div>
              </h3>
              <div
                aria-labelledby="q5"
                class="collapse"
                [ngClass]="{ show: activeTab === 'q5' }"
                id="q5"
                role="tabpanel"
                data-parent="#v-pills-tab-list"
              >
                <div class="card-body faqPar ms-3 me-3">
                  Regular practice strengthens grammatical principles and
                  increases writing confidence. It enables you to recognize and
                  fix common errors, which can help you write more fluently over
                  time.
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>

  <br /><br /><br />
</div>
<div class="" *ngIf="section === 'techniques'">
  <div class="container-fluid heros">
    <app-header></app-header>
    <div class="container hand-book-container">
      <div class="row">
        <div class="col-lg-6 head-top">
          <nav aria-label="breadcrumb">
            <ol class="breadcrumb">
              <li class="breadcrumb-item">
                <a [routerLink]="['/']">Home</a>
              </li>
              <li class="breadcrumb-item">
                <a [routerLink]="['/handbook']">Handbook</a>
              </li>
              <li class="breadcrumb-item activebread">
                <a [routerLink]="['/handbook/techniques']">Techniques</a>
              </li>
            </ol>
          </nav>
          <h1 class="mb-2 heading">Techniques</h1>
          <p class="py-3 head-p" style="margin-top: -20px">
            Language was like a forest where sounds and words used to wander
            aimlessly. But fortunately, techniques stepped in like gentle
            gardeners. They shaped linguistic chaos into proper pathways that
            now have a clear purpose and structure.
          </p>
          <a
            class="handbook-btn1"
            style="
              cursor: pointer;
              display: inline-flex;
              align-items: center;
              text-decoration: none;
            "
            [routerLink]="['/grammar-checker']"
          >
            <p>Get Writing Techniques with Grammar Checker</p>
            <img
              src="/assets/images/handbook/white-arrow.svg"
              height="30px"
              width="30px"
              alt="white-arrow"
              class="ms-2"
            />
          </a>
        </div>
        <div class="col-lg-6 img-col">
          <img
            src="../../assets/images/handbook/Hgrammar.png"
            alt="grammar"
            style="width: 568px; height: 412px"
            class="mt-4 handbok-img"
            style="width: 568px; height: 412px"
          />
        </div>
      </div>
    </div>
  </div>

  <div class="container" style="margin-bottom: 50px">
    <div class="row">
      <div class="col mb-4">
        <p>
          With techniques, words learned to collaborate, which eventually paved
          the way for clear and meaningful communication.
        </p>
        <br />
        <h2 class="title">Fundamental Principles of Effective Techniques</h2>
        <span class="description"
          >The techniques in grammar serve as the backbone of effective
          communication. They enable words to convey thoughts seamlessly and
          guarantee clarity, consistency, and adaptability. By understanding and
          applying them, language becomes a combination of a tool and an art
          form.</span
        >
      </div>
    </div>
  </div>
  <div class="container" style="margin-bottom: 50px">
    <div class="row">
      <div class="col">
        <h3 class="title">Understanding the Role of Techniques</h3>
        <span class="description"
          >Grammar techniques are the methods and strategies that help ensure
          that language follows the rules and conveys meaning effectively. They
          guide words to form coherent sentences and ideas. Therefore, they act
          as a gateway between raw language and polished communication.
        </span>
      </div>
    </div>
  </div>
  <div class="container" style="margin-bottom: 50px">
    <div class="row">
      <div class="col">
        <h3 class="title">Core Principles Behind Every Effective Technique</h3>
        <span class="description"
          >Every effective grammar technique relies on a set of guiding
          principles. These principles make sure that the language is smooth,
          ideas are clear, and communication achieves its purpose. Here is a
          list that highlights the core principles of grammar’s techniques:
        </span>
      </div>
    </div>
  </div>

  <section class="common-writing">
    <div class="container">
      <div class="row mt-4">
        <div class="col-lg-4 col-12">
          <div class="common-tab">
            <h4>Efficiency</h4>
            <p>
              Efficiency ensures the simplicity and conciseness of the
              communication. Effective grammar techniques remove unnecessary
              complexity, which makes it easier for the reader to grasp the
              intended message without any confusion.
            </p>
          </div>
        </div>
        <div class="col-lg-4 col-12 martop">
          <div class="common-tab">
            <h4>Consistency</h4>
            <p>
              Consistency is essential for a language’s stability. It applies
              the same rules across various contexts. That’s how it makes sure
              that the message remains clear and uniform, regardless of the
              industry. This reliability makes it easier for both writers and
              readers to trust the communication process.
            </p>
          </div>
        </div>
        <div class="col-lg-4 col-12 martop">
          <div class="common-tab">
            <h4>Adaptability</h4>
            <p>
              Adaptability allows techniques to evolve and fit different
              audiences, contexts, and purposes. Whether in casual conversation
              or formal writing, grammar techniques adjust to maintain relevance
              and effectiveness.
            </p>
          </div>
        </div>
      </div>
    </div>
  </section>

  <div class="hero-1 mb-5">
    <div class="container-fluid">
      <div class="container">
        <div class="row mt-1">
          <div class="col-lg-12 mb-2 mt-4">
            <!-- <h2 class="mb-2">Techniques</h2> -->
            <p>
              Whether you’re refining a complex paragraph or crafting a sentence
              from scratch, these principles work together to create harmony in
              writing. By mastering them, anyone can elevate their language
              skills and make their message impactful. A few important part of
              techniques are discussed below:
            </p>
          </div>
          <div class="col-lg-3 col-md-4 col-12 hvr-icon-hang">
            <a [routerLink]="['/what-are-literary-devices']">
              <div class="card">
                <div class="img-pen">
                  <span> Literary Devices </span>
                  <div class="arrow hvr-icon-hang">
                    <div id="section-arrow" class="hvr-icon"></div>
                  </div>
                </div>
                <p>
                  Literary devices are techniques writers use to create impact,
                  convey information, and deepen reader understanding.
                </p>
              </div>
            </a>
          </div>
          <div class="col-lg-3 col-md-4 col-12 hvr-icon-hang">
            <a [routerLink]="['/what-is-irony']">
              <div class="card">
                <div class="img-pen">
                  <span> Irony </span>
                  <div class="arrow hvr-icon-hang">
                    <div id="section-arrow" class="hvr-icon"></div>
                  </div>
                </div>
                <p>
                  Irony is often used for critical or humorous effect in
                  literature, music, art, and film.
                </p>
              </div>
            </a>
          </div>
          <div class="col-lg-3 col-md-4 col-12 hvr-icon-hang">
            <a [routerLink]="['/what-is-a-motif']">
              <div class="card">
                <div class="img-pen">
                  <span> Motif </span>
                  <div class="arrow hvr-icon-hang">
                    <div id="section-arrow" class="hvr-icon"></div>
                  </div>
                </div>
                <p>
                  A motif is a symbolic image or idea that appears frequently in
                  a story.
                </p>
              </div>
            </a>
          </div>
          <div class="col-lg-3 col-md-4 col-12 hvr-icon-hang">
            <a [routerLink]="['/what-is-oxymoron']">
              <div class="card">
                <div class="img-pen">
                  <span> Oxymoron </span>
                  <div class="arrow hvr-icon-hang">
                    <div id="section-arrow" class="hvr-icon"></div>
                  </div>
                </div>
                <p>
                  An oxymoron is a figure of speech that puts together opposite
                  elements.
                </p>
              </div>
            </a>
          </div>
          <div class="col-lg-3 col-md-4 col-12 hvr-icon-hang">
            <a [routerLink]="['/what-is-paradox']">
              <div class="card">
                <div class="img-pen">
                  <span> Paradox </span>
                  <div class="arrow hvr-icon-hang">
                    <div id="section-arrow" class="hvr-icon"></div>
                  </div>
                </div>
                <p>
                  A paradox is a statement that contradicts itself, or that must
                  be both true and untrue at the same time.
                </p>
              </div>
            </a>
          </div>
          <!-- <div class="col-lg-3 col-md-4 col-12 hvr-icon-hang">
            <a [routerLink]="['/what-does-exclamation-mark-mean']">
              <div class="card">
                <div class="img-pen">
                  <span>
                    Exclamation Mark
                  </span>
                  <div class="arrow hvr-icon-hang">
                    <div id="section-arrow" class="hvr-icon"></div>
                  </div>
                </div>
                <p> Exclamation mark is used to convey emotion and intent that can be expressed through the tone if
                  spoken. </p>
              </div>
            </a>
          </div> -->
          <div class="col-lg-3 col-md-4 col-12 hvr-icon-hang">
            <a [routerLink]="['/what-is-personification']">
              <div class="card">
                <div class="img-pen">
                  <span> Personification </span>
                  <div class="arrow hvr-icon-hang">
                    <div id="section-arrow" class="hvr-icon"></div>
                  </div>
                </div>
                <p>
                  Personification is a kind of metaphor in which we describe an
                  inanimate object, abstract thing in human terms.
                </p>
              </div>
            </a>
          </div>
          <div class="col-lg-3 col-md-4 col-12 hvr-icon-hang">
            <a [routerLink]="['/what-is-suspense']">
              <div class="card">
                <div class="img-pen">
                  <span> Suspense </span>
                  <div class="arrow hvr-icon-hang">
                    <div id="section-arrow" class="hvr-icon"></div>
                  </div>
                </div>
                <p>
                  No matter what type of story you are telling, suspense is a
                  valuable tool for keeping a reader’s attention and interest.
                </p>
              </div>
            </a>
          </div>
          <div class="col-lg-3 col-md-4 col-12 hvr-icon-hang">
            <a [routerLink]="['/what-is-a-symbol']">
              <div class="card">
                <div class="img-pen">
                  <span> Symbol </span>
                  <div class="arrow hvr-icon-hang">
                    <div id="section-arrow" class="hvr-icon"></div>
                  </div>
                </div>
                <p>
                  Prepositions indicate relationships between other words in a
                  sentence.
                </p>
              </div>
            </a>
          </div>
          <div class="col-lg-3 col-md-4 col-12 hvr-icon-hang">
            <a [routerLink]="['/what-is-verisimilitude']">
              <div class="card">
                <div class="img-pen">
                  <span> Verisimilitude </span>
                  <div class="arrow hvr-icon-hang">
                    <div id="section-arrow" class="hvr-icon"></div>
                  </div>
                </div>
                <p>
                  A work of art, or any part of a work of art, has
                  verisimilitude if it seems realistic.
                </p>
              </div>
            </a>
          </div>
          <div class="col-lg-3 col-md-4 col-12 hvr-icon-hang">
            <a [routerLink]="['/what-is-vignette']">
              <div class="card">
                <div class="img-pen">
                  <span> Vignette </span>
                  <div class="arrow hvr-icon-hang">
                    <div id="section-arrow" class="hvr-icon"></div>
                  </div>
                </div>
                <p>
                  The word vignette originates from the French vigne meaning
                  "little vine," referring to the small vine designs on printed
                  texts.
                </p>
              </div>
            </a>
          </div>
          <div class="col-lg-3 col-md-4 col-12 hvr-icon-hang">
            <a [routerLink]="['/what-is-hyperbole']">
              <div class="card">
                <div class="img-pen">
                  <span> Hyperbole </span>
                  <div class="arrow hvr-icon-hang">
                    <div id="section-arrow" class="hvr-icon"></div>
                  </div>
                </div>
                <p>
                  Hyperbole is a type of a figurative language. Often metaphors
                  and simile incorporate hyperbole.
                </p>
              </div>
            </a>
          </div>
          <div class="col-lg-3 col-md-4 col-12 hvr-icon-hang">
            <a [routerLink]="['/what-are-onomatopoeia-words']">
              <div class="card">
                <div class="img-pen">
                  <span> Onomatopoeia </span>
                  <div class="arrow hvr-icon-hang">
                    <div id="section-arrow" class="hvr-icon"></div>
                  </div>
                </div>
                <p>
                  The words denoted to the sounds produced by various things and
                  beings are called onomatopoeia words.
                </p>
              </div>
            </a>
          </div>
          <div class="col-lg-3 col-md-4 col-12 hvr-icon-hang">
            <a [routerLink]="['/what-is-an-idiom']">
              <div class="card">
                <div class="img-pen">
                  <span> Idiom </span>
                  <div class="arrow hvr-icon-hang">
                    <div id="section-arrow" class="hvr-icon"></div>
                  </div>
                </div>
                <p>
                  Idiom is a phrase that has different meaning from the words it
                  is composed of.
                </p>
              </div>
            </a>
          </div>
          <div class="col-lg-3 col-md-4 col-12 hvr-icon-hang">
            <a [routerLink]="['/what-are-collocations']">
              <div class="card">
                <div class="img-pen">
                  <span> Collocations </span>
                  <div class="arrow hvr-icon-hang">
                    <div id="section-arrow" class="hvr-icon"></div>
                  </div>
                </div>
                <p>
                  The way Native speakers combine words to express certain
                  meaning to their thought is called collocation.
                </p>
              </div>
            </a>
          </div>
          <div class="col-lg-3 col-md-4 col-12 hvr-icon-hang">
            <a [routerLink]="['/what-are-similes']">
              <div class="card">
                <div class="img-pen">
                  <span> Simile </span>
                  <div class="arrow hvr-icon-hang">
                    <div id="section-arrow" class="hvr-icon"></div>
                  </div>
                </div>
                <p>
                  A simile is a figure of speech that describes an object
                  directly comparing it to another in an interesting way.
                </p>
              </div>
            </a>
          </div>
          <div class="col-lg-3 col-md-4 col-12 hvr-icon-hang">
            <a [routerLink]="['/what-are-metaphors']">
              <div class="card">
                <div class="img-pen">
                  <span> Metaphors </span>
                  <div class="arrow hvr-icon-hang">
                    <div id="section-arrow" class="hvr-icon"></div>
                  </div>
                </div>
                <p>
                  Metaphor is a figure of speech that describes the object by
                  stating one object as another thing.
                </p>
              </div>
            </a>
          </div>
          <div class="col-lg-3 col-md-4 col-12 hvr-icon-hang">
            <a [routerLink]="['/what-is-satire']">
              <div class="card">
                <div class="img-pen">
                  <span> Satire </span>
                  <div class="arrow hvr-icon-hang">
                    <div id="section-arrow" class="hvr-icon"></div>
                  </div>
                </div>
                <p>
                  Satire uses humor or irony to criticize people's flaws or
                  societal issues.
                </p>
              </div>
            </a>
          </div>
        </div>
      </div>
    </div>
  </div>

  <div class="container">
    <div class="row">
      <div class="col-lg-12 mb-2 mt-4">
        <h2 class="title mb-2">
          The Evolution of Techniques Across Disciplines
        </h2>
        <p>
          Grammar’s techniques have evolved alongside human communication. In
          old times, techniques were rooted in oral traditions, where
          storytellers used to have patterns to aid memory and clarity. However,
          with the advent of written language, these methods have been
          formalized to preserve language and make it universally
          understandable.
        </p>
        <br />
        <p>
          Today, grammar techniques are dynamic because they effortlessly adapt
          to various disciplines like business, digital media, and even
          technology. For instance, syntax mirrors grammatical rules in coding,
          while in social media, brevity and clarity define new-age grammar.
        </p>
        <br />
        <p>
          Hence, grammatical techniques continue to ensure that language remains
          a versatile tool for expressing ideas effectively across all
          disciplines.
        </p>
      </div>
    </div>
  </div>

  <br /><br />
</div>
<div class="" *ngIf="section === 'style'">
  <div class="container-fluid heros">
    <app-header></app-header>
    <div class="container hand-book-container">
      <div class="row">
        <div class="col-lg-6 head-top">
          <nav aria-label="breadcrumb">
            <ol class="breadcrumb">
              <li class="breadcrumb-item">
                <a [routerLink]="['/']">Home</a>
              </li>
              <li class="breadcrumb-item">
                <a [routerLink]="['/handbook']">Handbook</a>
              </li>
              <li class="breadcrumb-item activebread">
                <a [routerLink]="['/handbook/style']">Style</a>
              </li>
            </ol>
          </nav>
          <h1 class="mb-2 heading">Style</h1>
          <p class="py-3 head-p">
            Style is the wardrobe of writing that is chosen to suit the context.
            It is the artful selection of words, the rhythm of sentences, and
            the unique voice of the author that captivates the reader's mind.
          </p>
          <br />
          <a
            class="handbook-btn1"
            style="
              cursor: pointer;
              display: inline-flex;
              align-items: center;
              text-decoration: none;
            "
            [routerLink]="['/grammar-checker']"
          >
            <p>Correct Writing Style With Grammar Checker</p>
            <img
              src="/assets/images/handbook/white-arrow.svg"
              height="30px"
              width="30px"
              alt="white-arrow"
              class="ms-2"
            />
          </a>
        </div>
        <div class="col-lg-6 img-col">
          <img
            src="../../assets/images/handbook/Hgrammar.png"
            alt="grammar"
            style="width: 568px; height: 412px"
            class="mt-4 handbok-img"
            style="width: 568px; height: 412px"
          />
        </div>
      </div>
    </div>
  </div>

  <div class="hero-1 mb-5">
    <div class="container-fluid">
      <div class="container">
        <div class="row">
          <div class="col-lg-12 mb-2">
            <h2 class="title mb-2">Style History and Origins</h2>
            <p>
              The concept of writing style has evolved with time due to
              cultural, social, and technological changes. Early writing systems
              were pictorial and symbolic. But as civilizations progressed the
              sophistication of writing also developed.
            </p>
            <br />
            <p>
              Classical Greek and Roman rhetoricians laid the foundation for
              Western rhetorical theory that was focused on clarity, logic, and
              persuasion. This marked a turning point, with renewed interest in
              classical texts and new literary genres. The Enlightenment focused
              on rationality and scientific inquiry, while Romanticism
              celebrated emotion and individual expression.
            </p>
            <br />
            <p>
              The 19th century saw the rise of realism and naturalism, while
              postmodernism blurred the lines between fiction and reality.
              Today, writing styles continue to evolve under the influence of
              new technologies and globalized culture.
            </p>
          </div>
          <div class="col-lg-3 col-md-4 col-12 hvr-icon-hang">
            <a [routerLink]="['/what-is-passive-voice-construction']">
              <div class="card">
                <div class="img-pen">
                  <span> Passive Voice </span>
                  <div class="arrow hvr-icon-hang">
                    <div id="section-arrow" class="hvr-icon"></div>
                  </div>
                </div>
                <p>
                  Tenses are time references and voice shows who perform and
                  receive the action.
                </p>
              </div>
            </a>
          </div>
          <div class="col-lg-3 col-md-4 col-12 hvr-icon-hang">
            <a [routerLink]="['/what-is-parallelism']">
              <div class="card">
                <div class="img-pen">
                  <span> Parallelism </span>
                  <div class="arrow hvr-icon-hang">
                    <div id="section-arrow" class="hvr-icon"></div>
                  </div>
                </div>
                <p>
                  Parallelism is when phrases in a sentence have similar or have
                  the same grammatical structure.
                </p>
              </div>
            </a>
          </div>
        </div>
      </div>
    </div>
  </div>

  <div class="container">
    <div class="row text-center justify-content-center">
      <div class="col-lg-9 col-md-9 mb-2">
        <h2 class="title">Techniques to Improve Writing Style</h2>
        <span class="description p-5"
          >The writing style could be improved with practice and using the right
          techniques. Here are the three tried and tested methods of elevating
          your writing style to the next level.</span
        >
      </div>
    </div>
  </div>

  <section class="common-writing">
    <div class="container">
      <div class="row mt-4">
        <div class="col-lg-4 col-12">
          <div class="common-tab1">
            <h3>Editing for Style</h3>
            <p>
              After writing the text, review it to identify and remove any
              redundant terminologies and concepts that are disrupting the flow.
              Work one paragraph at a time to improve and refine it at the
              sentence level.
            </p>
          </div>
        </div>
        <div class="col-lg-4 col-12 martop">
          <div class="common-tab1">
            <h3>Using Literary Devices</h3>
            <p>
              Utilize literary devices such as intellect, emotions, flow, and
              others in the correct way to enhance their effectiveness. To
              ensure the accuracy of these literary devices, use the
              <a
                href="https://www.grammarin.com/grammar-checker"
                style="color: black; text-decoration: underline"
              >
                grammar corrector
              </a>
              which will suggest corrections on every mistake.
            </p>
          </div>
        </div>
        <div class="col-lg-4 col-12 martop">
          <div class="common-tab1">
            <h3>Achieving Consistency</h3>
            <p>
              A consistent structure and style are also a good practice if you
              want to attain perfection. So, maintain a constant style
              throughout the content. Also, align each piece of text with your
              objectives and requirements.
            </p>
          </div>
        </div>
      </div>
    </div>
  </section>
  <br /><br />
</div>

<div class="" *ngIf="section === 'what-are-modifiers'">
  <div class="container-fluid hero-modifiers">
    <app-header></app-header>

    <div class="container modify-container">
      <div class="row">
        <div class="col-12 head-top">
          <nav aria-label="breadcrumb" class="mb-2">
            <ol class="breadcrumb">
              <li class="breadcrumb-item">
                <a [routerLink]="['/']">Home</a>
              </li>
              <li class="breadcrumb-item">
                <a [routerLink]="['/handbook']">Handbook</a>
              </li>
              <li class="breadcrumb-item">
                <a [routerLink]="['/handbook/grammar']">Grammar</a>
              </li>
              <li class="breadcrumb-item activebread">
                <a [routerLink]="['/what-are-modifiers']">What Are Modifiers</a>
              </li>
            </ol>
          </nav>

          <h1 class="mb-2 heading">What Are Modifiers</h1>
          <p class="py-3 head-details">
            A modifier adds additional information to another element in a
            sentence. It can be an adjective or an adverb; a phrase or a clause
            acting as an adjective or an adverb. To make writing better,
            modifiers should be placed correctly in a sentence.
          </p>
        </div>
      </div>
    </div>
  </div>

  <section class="hero-1 mb-5">
    <div class="container-fluid">
      <div class="container">
        <div class="row">
          <div class="col-12">
            <h2>Misplaced Modifiers</h2>
            <p>
              Misplaced modifiers create confusion in understanding the idea
              communicated through the sentence. As these are placed to modify
              wrong component; therefore, we should avoid misplaced modifiers.
            </p>
            <p>
              To avoid this mistake, place single-word modifiers near the word
              or words they modify.
            </p>
            <br />
            <p class="examplFnt">Example:</p>
            <div>
              <ul class="example">
                <li>
                  After our conversation lessons, we could understand the
                  Spanish spoken by our visitors from Madrid easily.<i
                    style="font-weight: bold"
                    id="all"
                    >(Confusing sentence)</i
                  >
                </li>
              </ul>
            </div>
            <p>
              It is confusing in the way that; do we understand the Spanish
              easily or the visitors speak Spanish easily?
            </p>
            <p>It can be clear if we write it in this way:</p>
            <div class="tips_right">
              <ul class="example">
                <li>
                  We could easily understand the Spanish spoken by our visitors
                  from Madrid.<i style="font-weight: bold">(Clarity)</i>
                </li>
              </ul>
            </div>
          </div>
          <div class="col-12 mt-5">
            <h2>Limiting Modifiers</h2>
            <p>
              Limiting modifiers such as almost, hardly, nearly, just, only,
              merely, simply, at first, change the meaning of the sentence; if
              placed next to the wrong word.
            </p>
            <br />
            <p class="examplFnt">Examples:</p>
            <ul class="example">
              <li>
                Merely, this car covered 100 miles and broke down.
                <i style="font-weight: bold"
                  >(Means only this car can cover the mileage)</i
                >
              </li>
              <li>
                This car merely covered 100 miles and broke down.
                <i style="font-weight: bold"
                  >(Means only mentioned mileage is covered by this car)</i
                >
              </li>
            </ul>
          </div>

          <div class="col-12 mt-5">
            <h2>Misplaced Phrases and Clauses</h2>
            <p>
              It is important to place the modifying phrase or clause as close
              as possible to the word or words it modifies; to convey the right
              message/idea.
            </p>
            <br />
            <p class="examplFnt">Examples:</p>
            <ul class="example">
              <li>
                By accident, he poked the little girl
                <i style="font-weight: bold">with his finger</i> in the eye.
                <i style="font-weight: bold"
                  >. (This shows as he poked little girl with finger)</i
                >
              </li>
              <li>
                By accident, he poked the little girl in the eye
                <i style="font-weight: bold"> with his finger.</i>
                <i style="font-weight: bold">
                  (This shows he poked his finger in the eye)</i
                >
              </li>
            </ul>
            <p>
              <i style="font-weight: bold">After the wedding,</i> Ian told us at
              his stag party that he would start behaving like a responsible
              adult.
              <i style="font-weight: bold"
                >(Here it is as ‘Ian told after the wedding’)</i
              >
            </p>
            <p>
              Ian told us at his stag party that he would start behaving like a
              responsible adult
              <i style="font-weight: bold"> after the wedding.</i>
              <i style="font-weight: bold">
                (Here it is as ‘Ian will behave after the wedding’)</i
              >
            </p>
          </div>
          <div class="col-12 mt-5">
            <h2>Squinting Modifiers</h2>
            <p>
              A squinting modifier is placed in such a way that it creates
              confusion for the position of the word it is modifying; whether it
              is before or after the modifier.
            </p>
            <br />
            <p class="examplFnt">Examples:</p>
            <ul class="example">
              <li>
                Taking aspirin <i style="font-weight: bold">often</i> helps with
                headaches.<i style="font-weight: bold">
                  (Confusing: is it headaches that often gets better or is it
                  taking aspirin often)</i
                >
              </li>
              <li>
                <i style="font-weight: bold">Often</i>, taking aspirin helps
                with headaches.<i style="font-weight: bold"> (Clear message)</i>
              </li>
            </ul>
          </div>
          <div class="col-12 mt-5">
            <h2>Dangling Modifiers</h2>
            <p>
              A dangling modifier occurs when the anticipated subject of the
              modifier is missing from the sentence, and instead another subject
              appears in its place.
            </p>
            <p>
              In a correct sentence, the subject (or doer) that is modified
              should immediately follow the
              <a href="https://www.grammarin.com/what-is-a-comma" class="aTag"
                >comma
              </a>
              after the modifier.
            </p>
            <br />
            <p class="examplFnt">Examples:</p>
            <ul class="example">
              <li>
                Hungry after two hours of hiking,
                <i style="font-weight: bold">my packed sandwich</i> was quickly
                devoured upon reaching the peak.<i style="font-weight: bold"
                  >(Dangling modifier: subject[doer] of the action is missing;
                  who eat the sandwich?)</i
                >
              </li>
              <li>
                after two hours of hiking,<i style="font-weight: bold">I</i>
                quickly devoured my packed sandwich upon reaching the peak.<i
                  style="font-weight: bold"
                  >(Clear: it’s ‘I’ who eat the sandwich)</i
                >
              </li>
            </ul>
          </div>
          <div class="col-12 mt-5">
            <h2>Split Infinitives</h2>
            <p>
              The
              <a href="https://www.grammarin.com/what-is-a-verb" class="aTag"
                >infinitive form of the verb
              </a>
              consists of the word ‘to’ followed by the base form of the verb:
              ‘to be’, ‘to serve’, ‘to chop’ etc.
            </p>
            <p>
              Placing a word or words between the ‘to’ and the ‘verb’ of an
              infinitive creates what is known as a split infinitive.
            </p>
            <p>
              It is better to avoid inserting words between ‘to’ and ‘verb’ to
              construct clear sentence.
            </p>
            <br />
            <p class="examplFnt">Examples:</p>
            <ul class="example">
              <li>
                marketing team voted to before they launched the new software,
                <i style="font-weight: bold">run</i> an anticipatory ad
                campaign.<i style="font-weight: bold"
                  >(Disruptive -- the infinitive should not be split)</i
                >
              </li>
              <li>
                The marketing team voted to run an anticipatory ad campaign
                before they launched the new software.
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>
  </section>
</div>

<!--End modifiers-->
<!-- adjective-->
<div class="mb-5" *ngIf="section === 'what-are-adjectives'">
  <div class="container-fluid hero-short">
    <app-header></app-header>

    <div class="container modify-container">
      <div class="row">
        <div class="col-12 head-top">
          <nav aria-label="breadcrumb" class="mb-1">
            <ol class="breadcrumb">
              <li class="breadcrumb-item">
                <a [routerLink]="['/']">Home</a>
              </li>
              <li class="breadcrumb-item">
                <a [routerLink]="['/handbook']">Handbook</a>
              </li>
              <li class="breadcrumb-item">
                <a [routerLink]="['/handbook/grammar']">Grammar</a>
              </li>
              <li class="breadcrumb-item activebread">
                <a [routerLink]="['/what-are-adjectives']"
                  >What Are Adjectives</a
                >
              </li>
            </ol>
          </nav>

          <h1 class="mb-2 heading">What Are Adjectives</h1>
          <p class="py-3 head-details">
            Adjectives give us more information about nouns (people, animals,
            places or things) and pronouns.
          </p>
        </div>
      </div>
    </div>
  </div>

  <div class="container-fluid">
    <div class="container">
      <div class="row justify-content-center">
        <div class="col-12">
          <h2 style="margin-bottom: 25px">Uses of Adjectives</h2>
          <br />
          <h2>Adjectives Modify Nouns</h2>
          <p>
            Adjectives modify or describe features and qualities of people,
            animals, places and things.
          </p>
          <br />
          <p class="examplFnt">Examples:</p>
          <div class="tips">
            <ul class="example">
              <li>
                Henry bought a
                <i style="font-weight: bold" id="all">colourful</i> hat for his
                daughter’s birthday.
              </li>
              <li>
                A very <i style="font-weight: bold" id="all">elegant </i> and
                <i style="font-weight: bold" id="all">gorgeous </i> lady stepped
                on the stage.
              </li>
              <li>
                Colourful, elegant and gorgeous are adjectives describing hat
                and lady respectively.
              </li>
            </ul>
          </div>
        </div>
        <div class="col-12 mt-5">
          <h2>Predicate Adjective</h2>
          <p>
            Predicate Adjective is an adjective that can act as a complement to
            linking verbs or the verb ‘to be’ that describes a sensory
            experience. such as: to feel, to seem, or to taste.
          </p>
          <p>
            The linking
            <a class="aTag" href="https://www.grammarin.com/what-is-a-verb">
              verb
            </a>
            and adjectives are the part of predicate in a sentence.
          </p>
          <br />
          <p class="examplFnt">Example:</p>
          <ul class="example">
            <li>This girl is <i style="font-weight: bold">happy.</i></li>
            <li>
              It feels <i style="font-weight: bold">rough </i> on the pebble
              beach.
            </li>
          </ul>
        </div>
        <div class="col-12 mt-5">
          <h2>Adjectives vs. Adverbs</h2>
          <p>
            Bear in mind, an
            <a class="aTag" href="https://www.grammarin.com/what-are-adverbs">
              adverb</a
            >
            describes how an action is performed —an adjective describes what a
            <a class="aTag" href="https://www.grammarin.com/what-are-nouns">
              noun</a
            >
            or
            <a class="aTag" href="https://www.grammarin.com/what-are-pronouns">
              pronoun</a
            >
            feels.
          </p>
          <br />
          <p class="examplFnt">Example:</p>
          <ul class="example">
            <li>
              I feel <i style="font-weight: bold">badly </i> about what
              happened.
              <i style="font-weight: bold">(adverb)</i>
            </li>
            <li>
              I feel <i style="font-weight: bold"> bad </i> about his tragedy.
              <i style="font-weight: bold"> (adjective)</i>
            </li>
            <li>
              That boy is so
              <i style="font-weight: bold"> loud! (adjective) </i>
            </li>
            <li>
              That boy speaks so
              <i style="font-weight: bold"> loudly! (adverb) </i>
            </li>
          </ul>
          <p>
            In above example, ‘I feel badly’ means that you are not good or weak
            at feeling things. However, in second sentence ‘I feel bad’ means
            that you are describing an emotion for his situation.
          </p>
        </div>
        <div class="col-12 mt-5">
          <h2>Adjectives describe the Quantity</h2>
          <p>
            They can also describe the quantity of nouns:
            <i style="font-weight: bold"> many, few, millions, eleven.</i>
            Adjectives tell the reader how much—or how many—of something.
          </p>
          <br />
          <p class="examplFnt">Example:</p>
          <ul class="example">
            <li>
              Please colour <i style="font-weight: bold">three </i> shades of
              pink in this painting.
            </li>
            <li>
              My cake should have
              <i style="font-weight: bold"> sixteen </i> candles.
            </li>
            <li>
              <i style="font-weight: bold"> Several </i> eggs are collected each
              morning.
            </li>
          </ul>
        </div>
        <div class="col-12 mt-5">
          <h2>Coordinate Adjectives</h2>
          <p>
            Coordinate adjectives should be separated by a
            <a class="aTag" href="https://www.grammarin.com/what-is-a-comma"
              >comma</a
            >
            or the word <i style="font-weight: bold"> and.</i> Adjectives are
            coordinate if they modify the same noun in a sentence.
          </p>
          <p>
            In a correct sentence, the subject (or doer) that is modified should
            immediately follow the comma after the modifier.
          </p>
          <br />
          <br />
          <p class="examplFnt">Examples of Coordinate Adjectives:</p>
          <ul class="example">
            <li>
              This is going to be a
              <i style="font-weight: bold"> suffocating, hot </i> summer.
            </li>
            <li>
              Sam’s
              <i style="font-weight: bold"> devoted and vigorous </i> efforts
              made the impossible possible.
            </li>
          </ul>
          <br />
          <br />
          <p class="examplFnt">Examples of Cumulative Adjectives:</p>
          <ul class="example">
            <li>
              My parrot, Mickey, loves sleeping on this
              <i style="font-weight: bold"> dotted fleece </i>
              rug.
            </li>
            <li>
              No one could open the
              <i style="font-weight: bold"> rusted bronze </i> gate.
            </li>
          </ul>
          <p>
            In the cumulative adjective example, you would not say, “No one
            could open the bronze rusted gate.” Whereas, you can change the
            order of adjectives from first example, ‘vigorous and devoted’
            efforts and it still sounds right.
          </p>
        </div>

        <div class="col-12 mt-5">
          <h2>Degrees of Comparison</h2>
          <p>
            Adjectives have three forms:
            <i style="font-weight: bold"> absolute, comparative, </i> and
            <i style="font-weight: bold"> superlative. </i>
          </p>
          <p>Absolute adjectives describe something in its own right.</p>
          <br />
          <h2>Absolute Adjectives:</h2>
          <ul class="example">
            <li>A <i style="font-weight: bold">wealthy</i> woman</li>
            <li>
              <p>A <i style="font-weight: bold">naughty </i> monkey</p>
            </li>
            <li>A <i style="font-weight: bold">fluffy </i> rabbit</li>
            <li>
              A <i style="font-weight: bold">Beautiful </i> painting
              <!-- <i style="font-weight: bold">Sturdy </i> horses -->
            </li>
          </ul>
        </div>
        <div class="col-12 mt-5">
          <h2>Comparative Adjectives</h2>
          <p>
            Comparative adjectives make a comparison between two or more things.
            For most one-syllable adjectives, the comparative is formed by
            adding the suffix -er (or just -r if the adjective already ends with
            an e). For two-syllable adjectives ending in -y, replace -y with
            -ier. For multi-syllable adjectives, add the word more.
          </p>

          <ul class="example">
            <li>A <i style="font-weight: bold">wealthier </i> woman</li>
            <li>A <i style="font-weight: bold">naughtier </i> monkey</li>
            <li>A <i style="font-weight: bold">fluffier </i> cat</li>
            <li><i style="font-weight: bold"> More beautiful </i> painting</li>
          </ul>
        </div>
        <div class="col-12 mt-5">
          <h2>Superlative Adjectives</h2>
          <p>
            Superlative adjectives indicate that something has the highest
            degree of the quality in question. One-syllable adjectives become
            superlatives by adding the suffix -est (or just -st for adjectives
            that already end in e). Two-syllable adjectives ending in -y replace
            -y with -iest. Multi-syllable adjectives use the word most. When you
            use an article with a superlative adjective, it will usually be the
            definite article ‘the’ rather than ‘a or an’. Using a superlative
            indicates that you are talking about a specific item or items.
          </p>

          <ul class="example">
            <li>A <i style="font-weight: bold">wealthiest </i> woman</li>
            <li>A <i style="font-weight: bold">naughtiest </i> monkey</li>
            <li>A <i style="font-weight: bold">fluffiest </i> cat</li>
            <li>
              The <i style="font-weight: bold"> most beautiful </i> painting.
            </li>
          </ul>
        </div>
        <div class="col-12 mt-5">
          <h2>When Nouns Become Adjectives and Adjectives Become Nouns</h2>
          <p>
            Sometimes, a word that normally functions as a noun can act as an
            adjective, depending on its placement.
          </p>
          <br />
          <p class="examplFnt">Examples:</p>
          <ul class="example">
            <li>
              Never try to pet someone’s
              <i style="font-weight: bold">guide </i> dog without asking
              permission first.
            </li>
            <li>
              <i style="font-weight: bold"> Guide</i> is a noun. But in this
              sentence, it modifies <i style="font-weight: bold"> dog. </i> So
              it functions as an adjective. It can be vice versa, too. Some
              words that are normally adjectives can function as nouns:
            </li>

            <li>
              Alex is working on a fundraiser to help the
              <i style="font-weight: bold"> hungry. </i>
            </li>
            <li>
              In the context of this sentence,
              <i style="font-weight: bold"> hungry </i> is functioning as a
              noun.
            </li>
          </ul>
        </div>

        <div></div>
      </div>
    </div>
  </div>
</div>
<!--End Adjective-->

<!-- Determiners-->
<div class="mb-5" *ngIf="section === 'what-are-determiners'">
  <div class="container-fluid hero-Adjectives">
    <app-header></app-header>

    <div class="container modify-container">
      <div class="row">
        <div class="col-12 head-top">
          <nav aria-label="breadcrumb" class="mb-1">
            <ol class="breadcrumb">
              <li class="breadcrumb-item">
                <a [routerLink]="['/']">Home</a>
              </li>
              <li class="breadcrumb-item">
                <a [routerLink]="['/handbook']">Handbook</a>
              </li>
              <li class="breadcrumb-item">
                <a [routerLink]="['/handbook/grammar']">Grammar</a>
              </li>
              <li class="breadcrumb-item activebread">
                <a [routerLink]="['/what-are-determiners']"
                  >What Are Determiners</a
                >
              </li>
            </ol>
          </nav>

          <h1 class="mb-2 heading">What Are Determiners</h1>
          <p class="py-3 head-details">
            A determiner is a word that introduces a noun. It always comes
            before a noun, not after, and it also comes before any adjective
            used to describe the noun.
          </p>
        </div>
      </div>
    </div>
  </div>

  <div class="container-fluid">
    <div class="container">
      <div class="row justify-content-center">
        <div class="col-12">
                             
          <h2 style="margin-bottom: -1rem !important">Determiners</h2>
                             
          <p>
            Determiner suggests the context in which noun is used whether it is
            ownership, quantity or relative location. Determiners always come
            first in the noun phrase.  
          </p>
          <p>
            Generally, an indefinite article (a or an) is used before
            <a class="aTag" href="https://www.grammarin.com/what-are-nouns">
              singular nouns </a
            >. When speaking about singular or plural nouns specifically;
            definite article,
            <a class="aTag" href="https://www.grammarin.com/what-are-pronouns"
              >demonstrative pronoun </a
            >, possessive pronoun or quantifier is used.
          </p>
          <p>
            <a
              class="aTag"
              href="https://www.grammarin.com/what-are-determiners"
            >
              Determiners
            </a>
            can be divided into two groups:
          </p>
                             
          <br />
                 
          <h2 style="margin-bottom: -1rem !important">Group A Determiner</h2>
                                                 
          <ul class="example">
                                 
            <li>Articles</li>
            <li>Possessives</li>
            <li>Demonstratives</li>
                                                       
          </ul>
                              <br />
                             
          <h2 style="margin-bottom: -1rem !important">1.  Articles</h2>
                             
          <p>
            <a class="aTag" href="https://www.grammarin.com/what-are-articles"
              >Articles
            </a>
            specify (or determine) which noun the speaker is referring to. A and
            an are indefinite articles and are used for a general noun.
          </p>
                             
          <p class="examplFnt">Examples:</p>
                             
          <ul class="example">
            <li>
              <i style="font-weight: bold">A </i> dog is<i
                style="font-weight: bold"
              >
                a
              </i>
              good pet.  
            </li>
            <li>
              <i style="font-weight: bold">An  </i> ostrich would beat a chicken
              in <i style="font-weight: bold"> a </i> race.
            </li>
          </ul>
                         
          <p>
            In these examples, the sentence is talking about dogs or ostriches
            in general, meaning any dog. Note that ‘a’ is used before words that
            begin with consonants while ‘an’ is used before words beginning with
            vowel sounds.
          </p>
                     
          <p>
            On the other hand, <i style="font-weight: bold"> the </i> is a
            definite article, meaning the speaker is referring to a specific
            noun.
          </p>
                           
          <p class="examplFnt">Examples:</p>
                           
          <ul class="example">
            <li>
              We went to <i style="font-weight: bold"> the </i> best restaurant
              in town.
            </li>
            <li>
              <i style="font-weight: bold">The </i> dog is barking too loudly.
            </li>
          </ul>
                           
          <p>
            Here the speaker is referring to a particular dog and a particular
            restaurant. It's not a general category, but only one animal or
            place that's important. When your meaning is specific, use a
            definite article.
          </p>
                           <br />
                           
          <h2 style="margin-bottom: -1rem !important">2. Demonstratives</h2>
                           
          <p>
            <a class="aTag" href="https://www.grammarin.com/what-are-pronouns"
              >Demonstrative pronouns</a
            >
            are also used as determiners in English. There are four of them:
            <i style="font-weight: bold"> this, that, these </i> and
            <i style="font-weight: bold"> those. </i>                    
          </p>
                                             
          <p class="examplFnt">Examples:</p>
                           
          <ul class="example">
            <li>
              Do you want <i style="font-weight: bold"> this </i> piece of
              chicken?                      
            </li>
            <li>
              I don't want to go to
              <i style="font-weight: bold"> that   </i> movie.                  
                 
            </li>
            <li>
              <i style="font-weight: bold"> These </i> black raspberries are
              sour.
            </li>
                                 
            <li>
              He wanted <i style="font-weight: bold"> These </i> boys to go
              away.
            </li>
                                 
            <li>
              <i style="font-weight: bold">This </i> and  <i
                style="font-weight: bold"
              >
                these
              </i>
              refer to items nearby;
              <i style="font-weight: bold"> that </i> and
              <i style="font-weight: bold"> those </i> refer to items far away.
              In addition, <i style="font-weight: bold"> this </i> and
              <i style="font-weight: bold"> that  </i> are singular while
              <i style="font-weight: bold"> these </i> and
              <i style="font-weight: bold"> those </i> are plural.
            </li>
                         
          </ul>
                       
          <!-- <p>
            In these examples, the sentence is talking about dogs or ostriches
            in general, meaning any dog. Note that ‘a’ is used before words that
            begin with consonants while ‘an’ is used before words beginning with
            vowel sounds.
          </p>
                   
          <p>
            On the other hand, <i style="font-weight: bold"> the </i> is a
            definite article, meaning the speaker is referring to a specific
            noun.
          </p>
                         
          <p class="examplFnt">Examples:</p>
                         
          <ul class="example">
                             
            <li>

              We went to <i style="font-weight: bold"> the </i> best
              restaurant in town.

            </li>
                             
            <li>

              <i style="font-weight: bold">The  </i> dog is barking too
              loudly.

            </li>
                           
          </ul>
                         
          <p>
            Here the speaker is referring to a particular dog and a particular
            restaurant. It's not a general category, but only one animal or
            place that's important. When your meaning is specific, use a
            definite article.
          </p> -->
                         <br />
                         
          <h2 style="margin-bottom: -1rem !important">3.  Possessives</h2>
                         
          <p>
            When referring to a noun that belongs to someone or something,
            possessive pronouns are used to show ownership.
            <a class="aTag" href="https://www.grammarin.com/what-are-pronouns"
              >Possessive pronouns
            </a>
            include
            <i style="font-weight: bold">
               my, your, his, her, its, our, one’s, whose
            </i>
            and <i style="font-weight: bold">  their. </i>
          </p>
                                       
          <p class="examplFnt">Examples:</p>
                         
          <ul class="example">
                           
            <li>
              Where is  <i style="font-weight: bold"> your </i> car?            
                     
            </li>
                           
            <li>
              The dog growled and showed
              <i style="font-weight: bold"> its </i> teeth.                    
            </li>
                               
            <li>
              <i style="font-weight: bold"> My </i> best friend is a cat.  
            </li>
                               
            <li>
              Which <i style="font-weight: bold"> one </i> is his house?  
            </li>
                               
            <li>
              Honesty is  <i style="font-weight: bold"> her </i> best quality.  
                                 
            </li>
                                 
            <li>
              It is  <i style="font-weight: bold"> our </i> secret recipe.      
                               
            </li>
                       
          </ul>
                     
          <p>
            As always, the determiner comes before the noun and any modifying
            <a class="aTag" href="https://www.grammarin.com/what-are-adjectives"
              >adjectives
            </a>
            .
          </p>
                     
          <p>We cannot put two determiners from Group A together.</p>
                     
          <p class="examplFnt">Examples:</p>
                         
          <ul class="example">
                           
            <li>
              She is  <i style="font-weight: bold"> a my </i> friend
              <i style="font-weight: bold"> (Wrong)</i>                    
            </li>
                               
            <li>
              She is  <i style="font-weight: bold"> my </i> friend
              <i style="font-weight: bold"> (Correct)</i>                    
            </li>
                               
            <li>
              Where is <i style="font-weight: bold"> your the </i> car?
              <i style="font-weight: bold"> (Wrong)</i>                    
            </li>
                               
            <li>
              Where is  <i style="font-weight: bold"> your </i> car?
              <i style="font-weight: bold"> (Correct)</i>                    
            </li>

                           
          </ul>
                          <br />
                                         
          <h2 style="margin-bottom: -1rem !important">Group B Determiners</h2>
                         
          <p>Mostly, this category includes Quantifiers.</p>
                         
          <h2>1.  Quantifiers</h2>
                         
          <p>
            Quantifiers indicate how much or how little of the noun is
            discussed.
          </p>
                         
          <p>The following quantifiers work with countable nouns:</p>
                         
          <ul style="margin-bottom: -1rem !important" class="example">
                               
            <li><i style="font-weight: bold">Many  </i> trees</li>
                               
            <li><i style="font-weight: bold">A few  </i> trees</li>
                               
            <li>
              <p><i style="font-weight: bold">Few tree  </i> trees</p>
            </li>
                               
            <li><i style="font-weight: bold">Several   </i> trees</li>
                               
            <li><i style="font-weight: bold">A  </i> couple of trees</li>
                               
            <li><i style="font-weight: bold"> None </i> of the trees</li>
                               
          </ul>
                             
          <p style="margin-bottom: -1rem !important">
            The following quantifiers work with un-countable nouns:
          </p>
                             
          <ul style="margin-bottom: -1rem !important" class="example">
                               
            <li>not <i style="font-weight: bold"> much  </i> dancing</li>
                               
            <li><i style="font-weight: bold"> A little </i> dancing</li>
                               
            <li><i style="font-weight: bold">Little </i> dancing</li>
                               
            <li><i style="font-weight: bold">A bit  </i> of dancing</li>

                               
            <li><i style="font-weight: bold"> A good deal </i> of dancing</li>
                               
            <li><i style="font-weight: bold">No  </i>  dancing</li>
                               
          </ul>
               
          <p style="margin-bottom: -1rem !important">
            The following quantifiers work with both countable and un-countable
            nouns:
          </p>
                       
          <ul class="example">
                                                       
            <li>
              <i style="font-weight: bold">All of  </i>     the trees/dancing
            </li>
                               
            <li><i style="font-weight: bold">Some </i>  trees/dancing</li>
                               
            <li>
              <i style="font-weight: bold">Most of   </i>  the trees/dancing
            </li>
                               
            <li><i style="font-weight: bold">Enough </i>  trees/dancing</li>
                               
            <li>
              <p><i style="font-weight: bold">A lot of  </i>  trees/dancing</p>
            </li>
                               
            <li>
              <p><i style="font-weight: bold">Lots of  </i>  trees/dancing</p>
            </li>
                               
            <li>
              <p><i style="font-weight: bold">Plenty </i>  of trees/dancing</p>
            </li>
                               
            <li>
              <i style="font-weight: bold">A lack of  </i>   trees/dancing
            </li>
                                               
          </ul>
                         
          <h2 style="margin-bottom: -1rem !important">
            Other determiners: other, such, what, only and numbers
          </h2>
                         
          <p>
            Note that <i style="font-weight: bold"> ‘all’ </i> can be used with
            other determiners to specify which particular items are meant (i.e.
             <i style="font-weight: bold"> all </i>
            the books in this pile). In this case, the quantifier always comes
            before the article or demonstrative. It is also possible to use
            <i style="font-weight: bold"> ‘all’ </i> alone to refer to items
            generally (i.e. all books on the table needs dusting)
          </p>
                     
        </div>
                   
        <div class="col-12" style="margin-bottom: -1rem !important">
                         
          <h2 style="margin-bottom: -1rem !important">
            Determiners without nouns
          </h2>
                         
          <p class="examplFnt">Examples:</p>
                         
          <ul class="example">
                               
            <li>
              <i style="font-weight: bold">Many  </i> are called but  <i
                style="font-weight: bold"
              >
                few
              </i>
              are chosen.
            </li>
                               
            <li>
              <i style="font-weight: bold"> Some </i>  say one thing,
              <i style="font-weight: bold"> some </i> say another.
            </li>
                               
            <li>
              <p>
                <i style="font-weight: bold"> (many, few, some </i> are
                determiners which do not need nouns)
              </p>
            </li>
                           
          </ul>
                     
        </div>
        <div></div>
      </div>
    </div>
  </div>
</div>

<!--End Determiners-->
<!--Adverbs-->

<div class="mb-5" *ngIf="section === 'what-are-adverbs'">
  <div class="container-fluid hero-short">
    <app-header></app-header>

    <div class="container modify-container">
      <div class="row">
        <div class="col-12 head-top">
          <nav aria-label="breadcrumb" class="mb-1">
            <ol class="breadcrumb">
              <li class="breadcrumb-item">
                <a [routerLink]="['/']">Home</a>
              </li>
              <li class="breadcrumb-item">
                <a [routerLink]="['/handbook']">Handbook</a>
              </li>
              <li class="breadcrumb-item">
                <a [routerLink]="['/handbook/grammar']">Grammar</a>
              </li>
              <li class="breadcrumb-item activebread">
                <a [routerLink]="['/what-are-adverbs']">What Are Adverbs</a>
              </li>
            </ol>
          </nav>

          <h1 class="mb-2 heading">What Are Adverbs</h1>
          <p class="py-3 head-details">
            An adverb is a word that modifies (describes) a verb, an adjective,
            another adverb, or even a whole sentence.
          </p>
        </div>
      </div>
    </div>
  </div>
  <div class="container-fluid">
    <div class="container">
      <div class="row justify-content-center">
        <div class="col-12">
          <p class="examplFnt">Example:</p>
          <div class="tips">
            <ul class="example">
              <li>
                He works
                <i style="font-weight: bold"> quietly. (Modifies verb)</i>
              </li>
              <li>
                I am <i style="font-weight: bold"> extremely </i> busy this
                Monday.
                <i style="font-weight: bold" id="all"> (Modifies adjective) </i>
              </li>
              <li>
                She started her day
                <i style="font-weight: bold"> too </i> early.
                <i style="font-weight: bold"> (Modifies adverb) </i>
              </li>
              <li>
                <i style="font-weight: bold"> Unfortunately, I</i> forgot my
                wallet home.
                <i style="font-weight: bold"> (Modifies whole sentence)</i>
              </li>
            </ul>
            <br />
            <p>
              Adverbs often end in –ly, but some (such as fast) are the same as
              their adjective.
            </p>
          </div>
        </div>
        <div class="col-12 mt-5">
          <h2>Adverbs and Verbs</h2>
          <p>
            Adverbs explain how (drive
            <i style="font-weight: bold"> slow), </i> when (reached
            <i style="font-weight: bold"> late) </i> and where (drop
            <i style="font-weight: bold"> here) </i> a verb performs an action.
            <i style="font-weight: bold"> (slow, late </i> and
            <i style="font-weight: bold"> here </i> are adverbs in above
            instances).
          </p>
          <!-- <p>
            However, adverb is not used with Linking verbs, such as
            <i style="font-weight: bold"> feel, smell, sound, seem, </i> and
            <i style="font-weight: bold"> appear. </i> These typically need
            adjectives, not adverbs.
          </p> -->
          <br />
          <p class="examplFnt">Example:</p>
          <div class="tips">
            <ul class="example">
              <li>
                Food tasted <i style="font-weight: bold"> badly. (Adverb) </i>
              </li>
              <li>
                Food tasted
                <i style="font-weight: bold"> bad. (Adjective) </i>
              </li>
              <!-- <li>

                An adverb describes <i style="font-weight: bold"> how </i> you
                perform the action of feeling—an adjective describes
                <i style="font-weight: bold"> what </i> you feel.

              </li>
              <li>

                An adverb describes <i style="font-weight: bold"> how </i> you
                perform the action of feeling—an adjective describes
                <i style="font-weight: bold"> what </i> you feel.

              </li> -->
            </ul>

            <br />
            <p>
              An adverb describes <i style="font-weight: bold"> how </i> you
              perform the action of feeling—an adjective describes
              <i style="font-weight: bold"> what </i> you feel.
            </p>

            <br />
            <p>
              An adverb describes <i style="font-weight: bold"> how </i> you
              perform the action of feeling—an adjective describes
              <i style="font-weight: bold"> what </i> you feel.
            </p>
          </div>
        </div>
        <div class="col-12 mt-5">
          <h2>Adverbs and Adjectives</h2>
          <p>
            Adverbs can also modify adjectives and other adverbs. Often, the
            purpose of the adverb is to add
            <i style="font-weight: bold"> a degree of intensity </i> to the
            <a
              class="aTag"
              href="https://www.grammarin.com/what-are-adjectives"
            >
              adjective</a
            >.
          </p>
          <br />
          <p class="examplFnt">Example:</p>
          <ul class="example">
            <li>
              The cat is <i style="font-weight: bold"> quite </i> funny. (The
              adverb <i style="font-weight: bold"> quite </i> is modifying the
              adjective <i style="font-weight: bold"> funny) </i>
            </li>
            <li>
              This movie is <i style="font-weight: bold"> more </i> thrilling
              than the previous one. (The adverb
              <i style="font-weight: bold"> more </i> is modifying the adjective
              <i style="font-weight: bold"> thrilling) </i>
            </li>
          </ul>
        </div>

        <div class="col-12 mt-5">
          <h2>Adverbs and Other Adverbs</h2>
          <p>
            An adverb can describe another adverb. In fact, one adverb can
            describe more than one, other adverbs.
          </p>
          <br />
          <p class="examplFnt">Example:</p>
          <ul class="example">
            <li>
              Astrologer’s prediction is
              <i style="font-weight: bold"> almost always </i> wrong.
            </li>
            <li>
              <i style="font-weight: bold"> Almost </i> and
              <i style="font-weight: bold"> always </i> are two adverbs
              modifying
              <i style="font-weight: bold"> wrong (adjective). </i>
            </li>
          </ul>
        </div>
        <div class="col-12 mt-5">
          <h2>Adverbs and Sentences</h2>
          <p>
            Some adverbs can modify entire sentences—hence, are called sentence
            adverbs. Most common sentence adverbs are
            <i style="font-weight: bold">
              generally, fortunately, interestingly,
            </i>
            and <i style="font-weight: bold"> accordingly. </i> Sentence adverbs
            describe a general feeling about all of the information in the
            sentence.
          </p>
          <br />
          <p class="examplFnt">Example:</p>
          <ul class="example">
            <li>
              <i style="font-weight: bold">Fortunately, </i> her life was saved
              in accident.
            </li>
            <li>
              <i style="font-weight: bold">Interestingly, </i> no one agreed to
              the mayo on his latest proposal.
            </li>
          </ul>
        </div>
        <div class="col-12 mt-5">
          <h2>Degrees of Comparison</h2>
          <p>Like adjectives, adverbs can show degrees of comparison.</p>
          <p>An absolute adverb describes something in its own right:</p>
          <br />
          <p class="examplFnt">Example:</p>
          <ul class="example">
            <li>They cried <i style="font-weight: bold"> bitterly.</i></li>
            <li>A <i style="font-weight: bold"> hastily </i> written note.</li>
            <!-- <li>

              To make the comparative form of an adverb that ends in -ly, add
              the word <i style="font-weight: bold"> more: </i>

            </li> -->
          </ul>
          <br />
          To make the comparative form of an adverb that ends in -ly, add the
          word <i style="font-weight: bold"> more: </i>

          <br />
          <p class="examplFnt">Example:</p>
          <ul class="example">
            <li>
              He smiled <i style="font-weight: bold"> more</i> warmly than the
              others did.
            </li>
            <li>
              The <i style="font-weight: bold"> more </i> hastily written note
              contained the clue.
            </li>
          </ul>
          <p>
            To make the superlative form of an adverb that ends in -ly, add the
            word most:
          </p>
          <br />
          <p class="examplFnt">Example:</p>
          <ul class="example">
            <li>
              He smiled <i style="font-weight: bold"> most </i> warmly of them
              all.
            </li>
            <li>
              The <i style="font-weight: bold"> most </i> hastily written note
              on the desk was overlooked.
            </li>
          </ul>
        </div>
        <div class="col-12 mt-5">
          <h2>Placement of Adverbs</h2>
          <p>
            Place adverbs close to the words they have to modify. Placing the
            adverb with any other word can change the meaning of the sentence;
            especially limiting modifiers such as
            <i style="font-weight: bold">
              merely, only, almost, hardly, nearly, just, simply, at first.
            </i>
            Consider the difference between these two sentences:
          </p>

          <br />
          <p class="examplFnt">Example:</p>
          <ul class="example">
            <li>
              Alice <i style="font-weight: bold"> only </i> enjoys movies.
            </li>

            <li>
              Alice enjoys <i style="font-weight: bold"> only </i> movies.
            </li>
          </ul>
          <p>
            First sentence means it is only Alice who enjoys movies. Whereas,
            other sentence shows Alice enjoys movies only.
          </p>
        </div>
        <div class="col-12 mt-5">
          <h2>Tip to use adverbs effectively</h2>
          <p>
            To make writing precise and powerful use stronger
            <a class="aTag" href="https://www.grammarin.com/what-is-a-verb">
              verbs</a
            >
            and adjectives instead of using adverbs.
          </p>
        </div>
      </div>
    </div>
  </div>
</div>

<!--End Adverbs-->

<!--start Articles-->
<div class="mb-5" *ngIf="section === 'what-are-articles'">
  <div class="container-fluid hero-Adjectives">
    <app-header></app-header>

    <div class="container modify-container">
      <div class="row">
        <div class="col-12 head-top">
          <nav aria-label="breadcrumb" class="mb-1">
            <ol class="breadcrumb">
              <li class="breadcrumb-item">
                <a [routerLink]="['/']">Home</a>
              </li>
              <li class="breadcrumb-item">
                <a [routerLink]="['/handbook']">Handbook</a>
              </li>
              <li class="breadcrumb-item">
                <a [routerLink]="['/handbook/grammar']">Grammar</a>
              </li>
              <li class="breadcrumb-item activebread">
                <a [routerLink]="['/what-are-articles']">What Are Articles</a>
              </li>
            </ol>
          </nav>
          <h1 class="mb-2 heading">What Are Articles</h1>
          <p class="py-3 head-details">
            Articles are words that define a noun as specific or unspecific.
            English language has two types of articles: definite and indefinite.
          </p>
        </div>
      </div>
    </div>
  </div>
  <div class="container-fluid">
    <div class="container">
      <div class="row justify-content-center">
        <div class="col-12">
          <h2>The Definite Article (the)</h2>
          <p>
            It limits the meaning of a noun to one particular thing. The
            definite article can be used with singular, plural, or uncountable
            nouns.
          </p>
          <p>
            However, the
            <a class="aTag" href="https://www.grammarin.com/what-are-adverbs"
              >adverb
            </a>
            is not used with Linking verbs, such as
            <i style="font-weight: bold"> feel, smell, sound, seem, </i> and
            <i style="font-weight: bold"> appear. </i> These typically need
            adjectives, not adverbs.
          </p>
          <br />
          <p class="examplFnt">Examples:</p>
          <div class="tips">
            <ul class="example">
              <li>
                On <i style="font-weight: bold"> the </i> festive day,
                <i style="font-weight: bold"> the </i> chocolate cake tasted
                delicious.
              </li>
              <!-- <li>

                By using the article ‘the’, we have shown that it was one
                specific day that was festive and one specific chocolate cake
                that tasted good.

              </li> -->
            </ul>
            <br />
            <p>
              By using the article ‘the’, we have shown that it was one specific
              day that was festive and one specific chocolate cake that tasted
              good.
            </p>
            <br />
          </div>
        </div>
        <div class="col-12 mt-5">
          <h2>The Indefinite Article (a, an)</h2>
          <p>
            The
            <a class="aTag" href="https://www.grammarin.com/what-are-articles">
              indefinite article</a
            >
            takes two forms. The letter ‘<i style="font-weight: bold"> a </i>’
            precedes a word that begins with a consonant sound including the
            vowel letter for example
            <i style="font-weight: bold"> a </i> university. The word ‘<i
              style="font-weight: bold"
            >
              an </i
            >’ precedes a word with a vowel sound including the consonant letter
            for example: an honest man.
          </p>
          <p>
            The indefinite article indicates that a noun refers to a general
            idea rather than a particular thing. The indefinite article is only
            used with
            <a class="aTag" href="https://www.grammarin.com/what-are-nouns">
              singular nouns</a
            >.
          </p>
          <br />
          <p class="examplFnt">Examples:</p>
          <ul class="example">
            <li>
              On <i style="font-weight: bold"> a </i> festive day,
              <i style="font-weight: bold"> a </i> chocolate cake tasted
              delicious.
            </li>

            <!-- <li>

              By using the article <i style="font-weight: bold"> ‘a’ </i>,
              we’ve created a general statement, implying that any
              chocolate cake would taste good on any festive day.

            </li> -->
          </ul>
          <br />
          <p>
            By using the article <i style="font-weight: bold"> ‘a’ </i>, we’ve
            created a general statement, implying that any chocolate cake would
            taste good on any festive day.
          </p>
          <br />
        </div>

        <div class="col-12 mt-5">
          <h2>Article Before an Adjective</h2>
          <p>
            Sometimes an adjective is used before a noun to describe it. In this
            case, an article will be used before adjective. The usual word order
            is
            <i style="font-weight: bold"> article + adjective + noun. </i> If
            adverb is used before adjective followed by noun, then article will
            be used before adverb. The word order would be
            <i style="font-weight: bold"> Adverb +adjective +noun. </i> If the
            article is indefinite(a/an), choose
            <i style="font-weight: bold"> ‘a’ </i> or
            <i style="font-weight: bold"> ‘an’ </i> based on the word that
            immediately follows it.
          </p>
          <br />
          <p class="examplFnt">Examples:</p>
          <ul class="example">
            <li>
              Sara will bring <i style="font-weight: bold"> a </i> colourful
              umbrella to Dua’s party.
            </li>
            <li>
              I heard <i style="font-weight: bold"> a </i> very interesting
              story yesterday.
            </li>
          </ul>
        </div>
        <div class="col-12 mt-5">
          <h2>Indefinite Articles with Uncountable Nouns</h2>
          <p>
            <a class="aTag" href="https://www.grammarin.com/what-are-nouns">
              Uncountable nouns
            </a>
            are nouns that are either difficult or impossible to count.
            Uncountable nouns include intangible things (e.g., information,
            air), liquids (e.g., milk, wine), and things that are too large or
            numerous to count (e.g., equipment, sand, wood). As these things
            cannot be counted, ‘a’ or ‘an’ should not be used with them.
            Uncountable nouns can be modified by words like some or by unit of
            measurement like 20 litres of water or countable units like three
            pieces of furniture Note that depending on the context, some nouns
            can be countable or uncountable (e.g., hair, noise, time):
          </p>
          <br />
          <p class="examplFnt">Examples:</p>
          <ul class="example">
            <li>
              I have a grey hair
              <i style="font-weight: bold"> (refers to one grey hair) </i>
            </li>
            <li>
              I have grey hair
              <i style="font-weight: bold">
                (refers to whole head is grey haired)
              </i>
            </li>
          </ul>
        </div>
        <div class="col-12 mt-5">
          <h2>Using Articles with Pronouns</h2>
          <p>
            <a class="aTag" href="https://www.grammarin.com/what-are-pronouns"
              >Possessive pronouns
            </a>
            are words like
            <i style="font-weight: bold"> his, my, our, its, her, your </i> and
            <i style="font-weight: bold"> their. </i> Articles should not be
            used with pronouns because both articles and possessive pronouns
            specify the noun/items.
          </p>

          <br />
          <p class="examplFnt">Examples:</p>
          <ul class="example">
            <li>
              Why are you using
              <i style="font-weight: bold"> the my </i> computer?
              <i style="font-weight: bold"> (Wrong) </i>
            </li>
          </ul>
          <br />
          <p>
            <i style="font-weight: bold"> The </i> and
            <i style="font-weight: bold"> my </i> should not be used together
            since they are both meant to modify the same noun.
          </p>
          <br />
          <p>
            Instead, you should use one or the other, depending on the meaning
            you want to deliver:
          </p>
          <br />
          <p class="examplFnt">Examples:</p>
          <ul class="example">
            <li>
              Why are you using
              <i style="font-weight: bold"> the </i> computer?
              <i style="font-weight: bold"> (Correct) </i>
            </li>
            <li>
              Why are you using
              <i style="font-weight: bold"> my </i> computer?
              <i style="font-weight: bold"> (Correct) </i>
            </li>
          </ul>
        </div>
        <div class="col-12 mt-5">
          <h2>Uses of Definite Article ‘The’</h2>

          <ul class="example">
            <li>
              There is only one item in the world (the
              <i style="font-weight: bold"> pope, </i> the
              <i style="font-weight: bold"> sun, </i> the
              <i style="font-weight: bold"> universe) </i>
            </li>

            <li>
              With superlative degree of adjective (the
              <i style="font-weight: bold"> tallest, </i> the
              <i style="font-weight: bold"> most beautiful) </i>
            </li>

            <!-- <li>
              <i style="font-weight: bold"> ‘The’ </i> is not used if
              <a class="aTag" href="https://www.grammarin.com/what-are-nouns">
                possessive noun</a
              >
              is placed before the superlative e.g. my biggest achievement.
            </li> -->
            <li>
              <div class="li-flex">
                <i style="font-weight: bold">‘The’</i> is not used if
                <a class="aTag" href="https://www.grammarin.com/what-are-nouns">possessive noun</a>
                is placed before the superlative e.g. my biggest achievement.
              </div>
            </li>
            <li>
              Referred to by a noun: The wolf is not really a dangerous animal.
              (= Wolves are not dangerous animals.)
            </li>
            <li>
              To refer to a system or service (the
              <i style="font-weight: bold"> police, </i> the
              <i style="font-weight: bold"> radio) </i>
            </li>
            <li>
              <div class="li-flex">
              When
              <a
                class="aTag"
                href="https://www.grammarin.com/what-are-adjectives"
                >adjectives
              </a>
              are used as a noun: rich, poor, elderly, unemployed, about groups
              of people.
              </div>
            </li>
            <li>
              Before musical instruments: Joe plays the
              <i style="font-weight: bold"> piano </i> really well.
            </li>
            <li>
              Countries whose names include words like kingdom, states or
              republic: The
              <i style="font-weight: bold"> United Kingdom, </i> The
              <i style="font-weight: bold"> Kingdom of Bhutan, </i> The
              <i style="font-weight: bold"> United States </i>
            </li>
            <li>
              Countries which have plural nouns as their names: for example: The
              <i style="font-weight: bold"> Netherlands </i> , The
              <i style="font-weight: bold"> Philippines </i>
            </li>
            <li>
              Geographical features, such as mountain ranges, groups of islands,
              rivers, seas, oceans and canals: for example: The
              <i style="font-weight: bold"> Himalayas </i> , The
              <i style="font-weight: bold"> Canaries </i> , The
              <i style="font-weight: bold"> Atlantic (Ocean) </i> , the
              <i style="font-weight: bold"> Amazon </i> , the
              <i style="font-weight: bold"> Panama Canal </i>
            </li>
            <li>
              Newspapers: The <i style="font-weight: bold"> Times </i>, The
              <i style="font-weight: bold"> Washington Post </i> .
            </li>
            <li>
              Well-known buildings or works of art: The
              <i style="font-weight: bold"> Empire State Building </i>, The
              <i style="font-weight: bold"> Taj Mahal </i> , The
              <i style="font-weight: bold"> Mona Lisa </i>
            </li>
            <li>
              Organizations: The
              <i style="font-weight: bold"> United Nations </i>, The
              <i style="font-weight: bold"> Seamen's Union </i>
            </li>
            <li>
              Hotels, pubs and restaurants: for example: The
              <i style="font-weight: bold"> Ritz </i>, The
              <i style="font-weight: bold"> Ritz Hotel </i> , The
              <i style="font-weight: bold"> King's Head </i>, The
              <i style="font-weight: bold"> Déjà Vu </i>
            </li>
            <li>
              However, definite article ‘the’ is not used, if the name of the
              hotel or restaurant is the name of the owner: Brown's, Brown's
              Hotel, Morel's, Morel's Restaurant.
            </li>
            <li>
              Families: the <i style="font-weight: bold"> Obamas </i> , the
              <i style="font-weight: bold"> Jacksons </i>
            </li>
          </ul>
          <!-- <p class="examplFnt">Example:</p>
          <p>
            First sentence means it is only Alice who enjoys movies. Whereas,
            other sentence shows Alice enjoys movies only.
          </p> -->
        </div>
        <div class="col-12 mt-5">
          <h2>Omission of Articles</h2>
          <p>
            Occasionally, articles are omitted altogether before certain nouns.
          </p>
          <ul class="example">
            <li>
              Often, the article is omitted before nouns that refer to abstract
              ideas.
            </li>
          </ul>
          <br />
          <p class="examplFnt">Examples:</p>
          <ul class="example">
            <li>Let us go out for lunch next Monday.</li>
            <li>Creativity is a valuable quality in children.</li>
          </ul>
          <p>
            Many languages and nationalities are not preceded by an article.
          </p>
          <br />
          <p class="examplFnt">Examples:</p>
          <ul class="example">
            <li>
              I learnt <i style="font-weight: bold">French</i> in college for
              two years.
            </li>
          </ul>
          <p>Sports and academic subjects do not require articles.</p>
          <br />
          <p class="examplFnt">Examples:</p>
          <ul class="example">
            <li>I like to play <i style="font-weight: bold">baseball. </i></li>
          </ul>
          <ul class="example">
            <li>
              My daughter was always good at
              <i style="font-weight: bold">Math. </i>
            </li>
          </ul>
        </div>
      </div>
    </div>
  </div>
</div>
<!--End articles -->
<!--Conjuctions-->
<div class="mb-5" *ngIf="section === 'what-are-conjunction'">
  <div class="container-fluid hero-Adjectives">
    <app-header></app-header>

    <div class="container modify-container">
      <div class="row">
        <div class="col-12 head-top">
          <nav aria-label="breadcrumb" class="mb-1">
            <ol class="breadcrumb">
              <li class="breadcrumb-item">
                <a [routerLink]="['/']">Home</a>
              </li>
              <li class="breadcrumb-item">
                <a [routerLink]="['/handbook']">Handbook</a>
              </li>
              <li class="breadcrumb-item">
                <a [routerLink]="['/handbook/grammar']">Grammar</a>
              </li>
              <li class="breadcrumb-item activebread">
                <a [routerLink]="['/what-are-conjunction']"
                  >What Are Conjunction</a
                >
              </li>
            </ol>
          </nav>

          <h1 class="mb-2 heading">What Are Conjunction</h1>
          <p class="py-3 head-details">
            Conjunction are words that link other words, phrases, or clauses
            together. Conjunction assist to form complex, elegant sentences and
            avoid the breakdown of an idea into short multiple sentences.
          </p>
        </div>
      </div>
    </div>
  </div>
  <div class="container-fluid">
    <div class="container">
      <div class="row justify-content-center">
        <div class="col-12">
          <br />
          <p class="examplFnt">Examples:</p>
          <div class="tips">
            <ul class="example">
              <li>
                I like book reading. I like watching movies. I do not like
                listening music.
                <i style="font-weight: bold"> (Without conjunction) </i>
              </li>
              <li>
                I like book reading <i style="font-weight: bold"> and </i> I
                like watching movies <i style="font-weight: bold"> but </i> I do
                not like listening music.
                <i style="font-weight: bold"> (With conjunctions) </i>
              </li>
            </ul>
          </div>
          <br />
          <p>
            While joining phrases with conjunctions, make sure they are
            parallel, (share the same structure).
          </p>
          <br />
          <p class="examplFnt">Examples:</p>
          <div class="tips">
            <ul class="example">
              <li>
                I walk slowly and lazy.
                <i style="font-weight: bold">
                  (Not parallel: slowly is adverb and lazy is adjective)
                </i>
              </li>
              <li>
                I walk slowly and lazily.
                <i style="font-weight: bold">
                  (Parallel: Slowly and lazily, both are adverbs)
                </i>
              </li>
            </ul>
          </div>
        </div>
        <div class="col-12 mt-5">
          <h2>Coordinating Conjunctions</h2>
          <p>
            Coordinating conjunctions join the words, phrases, and clauses in a
            sentence.
          </p>
          <!-- <p>
            The most common coordinating conjunctions are
            <i style="font-weight: bold"> for, and, nor, but, or, yet, </i> and
            <i style="font-weight: bold"> so </i>; these can be remembered by
            using the mnemonic device
            <i style="font-weight: bold"> FANBOYS. </i>
          </p> -->
          <br />
          <p class="examplFnt">Examples:</p>
          <div class="tips">
            <ul class="example">
              <li>
                I like reading <i style="font-weight: bold"> or </i> sleeping in
                my free time.
              </li>
              <li>
                She picked her brother
                <i style="font-weight: bold"> and </i> dropped her sister on her
                way back to home.
              </li>
              <li>
                <p>
                  He tried his best <i style="font-weight: bold"> but </i> all
                  in vain.
                </p>
              </li>
              <li>
                I went to the park, <i style="font-weight: bold"> and </i> my
                sister slept.
              </li>
            </ul>
            <p>
              <i style="font-weight: bold"> Note: </i>A
              <a class="aTag" href="https://www.grammarin.com/what-is-a-comma">
                comma</a
              >
              is used when coordinating conjunction is joining two independent
              clauses.
            </p>
          </div>
        </div>
        <div class="col-12 mt-5">
          <h2>Correlative Conjunctions</h2>
          <p>
            Correlative conjunctions are pairs of conjunctions that work
            together. Some examples are either/or, neither/nor and not only/but
            also.
          </p>
          <br />
          <p class="examplFnt">Examples:</p>
          <ul class="example">
            <li>
              <i style="font-weight: bold"> Not only </i> is he doing job
              <i style="font-weight: bold"> but also </i> completing his degree.
              He is doing both job and studies at the same time.
            </li>

            <li>
              <i style="font-weight: bold"> Either </i> they should follow the
              code of conduct <i style="font-weight: bold"> or </i> they should
              leave the job.
            </li>
          </ul>
        </div>

        <div class="col-12 mt-5">
          <h2>Subordinating Conjunctions</h2>
          <p>
            Subordinating conjunctions join independent and dependent clauses. A
            subordinating conjunction shows some kind of relationship such as a
            cause-and-effect relationship, a contrast, or any other type of
            relationship between the clauses. Common subordinating conjunctions
            are <i style="font-weight: bold"> because </i>,
            <i style="font-weight: bold"> since </i>,
            <i style="font-weight: bold"> as </i>,
            <i style="font-weight: bold"> although </i>,
            <i style="font-weight: bold"> though </i>,<i
              style="font-weight: bold"
            >
              while
            </i>
            and <i style="font-weight: bold"> whereas </i>.
          </p>
          <br />

          <p>
            Sometimes an
            <a class="aTag" href="https://www.grammarin.com/what-are-adverbs"
              >adverb </a
            >, such as <i style="font-weight: bold"> until </i>,
            <i style="font-weight: bold"> after</i> or
            <i style="font-weight: bold"> before </i> can function as a
            conjunction.
          </p>
          <br />
          <p class="examplFnt">Examples:</p>
          <ul class="example">
            <li>
              I can work <i style="font-weight: bold"> until </i> my friend
              picks me up.
            </li>
            <!-- <li>

              Here, the adverb until functions as a coordinating conjunction
              to connect two ideas:
              <i style="font-weight: bold"> I can work </i> (the independent
              clause) and
              <i style="font-weight: bold"> until my friend picks me up. </i>
              (the dependent clause).

            </li>
            <li>

              The independent clause could stand alone as a sentence; the
              dependent clause depends on the independent clause to make
              sense.

            </li>
            <li>

              The subordinating conjunction does not always come in the middle
              of the sentence. It has to be part of the dependent clause.
              Moreover, the dependent clause can come before the independent
              clause.

            </li> -->
          </ul>
          <br />
          <p>
            Here, the adverb until functions as a coordinating conjunction to
            connect two ideas:
            <i style="font-weight: bold"> I can work </i> (the independent
            clause) and
            <i style="font-weight: bold"> until my friend picks me up. </i>
            (the dependent clause).
          </p>
          <br />
          <p>
            The independent clause could stand alone as a sentence; the
            dependent clause depends on the independent clause to make sense.
          </p>
          <br />
          <p>
            The subordinating conjunction does not always come in the middle of
            the sentence. It has to be part of the dependent clause. Moreover,
            the dependent clause can come before the independent clause.
          </p>
          <br />
          <p class="examplFnt">Examples:</p>
          <ul class="example">
            <li>
              <i style="font-weight: bold"> Before she leaves, </i> make sure
              her work is completed.
            </li>
          </ul>
          <br />
          <p>
            If the dependent clause comes first, use a comma before the
            independent clause.
          </p>
          <p>
            Make sure her work is completed
            <i style="font-weight: bold">
              before she leaves. (Comma is not required when dependant clause
              comes later)
            </i>
          </p>
          <br />
        </div>
        <div class="col-12 mt-5">
          <h2>List of Conjunctions</h2>
          <br />
          <br />

          <h2>1. Coordinating Conjunctions</h2>
          <p>for, and, nor, but, or, yet, so</p>
          <br />
          <br />
          <h2>2. Correlative Conjunctions</h2>
          <p>
            Both/and, either/or, neither/nor, not only/but, not only/but also,
            whether/or, rather/than, no sooner/then, just as/so
          </p>

          <br />
          <br />
          <h2>3. Some Subordinating Conjunctions</h2>
          <p>
            after, although, as, as if, as long as, as much as, as soon as, as
            though, because, before, by the time, even if, even though, if, in
            order that, in case, in the event that, lest, now that, once, only,
            only if, provided that, since, so, supposing, that, than, though,
            till, unless, until, when, whenever, where, whereas, wherever,
            whether or not, while
          </p>
        </div>
      </div>
    </div>
  </div>
</div>
<!--End conjuctions-->
<!--Interjectios-->
<div class="mb-5" *ngIf="section === 'what-are-interjections'">
  <div class="container-fluid hero-Adjectives">
    <app-header></app-header>

    <div class="container modify-container">
      <div class="row">
        <div class="col-12 head-top">
          <nav aria-label="breadcrumb" class="mb-1">
            <ol class="breadcrumb">
              <li class="breadcrumb-item">
                <a [routerLink]="['/']">Home</a>
              </li>
              <li class="breadcrumb-item">
                <a [routerLink]="['/handbook']">Handbook</a>
              </li>
              <li class="breadcrumb-item">
                <a [routerLink]="['/handbook/grammar']">Grammar</a>
              </li>
              <li class="breadcrumb-item activebread">
                <a [routerLink]="['/what-are-interjections']"
                  >What Are Interjection</a
                >
              </li>
            </ol>
          </nav>

          <h1 class="mb-2 heading">What Are Interjection</h1>

          <p class="head-details">
            Ouch! Oh my! Wow! Yikes!<br />
            An interjection is a word that you use in between sentences or
            thoughts to express a sudden feeling.
          </p>
        </div>
      </div>
    </div>
  </div>
  <div class="container-fluid">
    <div class="container">
      <div class="row justify-content-center">
        <div class="col-12">
          <h2>Stand-alone Interjections</h2>
          <p>
            Interjections usually express the feelings of surprise (both good
            surprises and bad ones) or excitement.
          </p>
          <p>
            The<a
              class="aTag"
              href="https://www.grammarin.com/what-are-conjunction"
            >
              most common coordinating conjunctions</a
            >
            are
            <i style="font-weight: bold"> for, and, nor, but, or, yet, </i> and
            <i style="font-weight: bold"> so </i>; these can be remembered by
            using the mnemonic device
            <i style="font-weight: bold"> FANBOYS. </i>
          </p>
          <br />
          <p class="examplFnt">Examples:</p>
          <div class="tips">
            <ul class="example">
              <li>
                <i style="font-weight: bold"> Yikes! </i> There’s a lizard on
                the bed!
              </li>
              <li>
                <p>
                  You planned this party just for me ?
                  <i style="font-weight: bold"> Wow!</i>
                </p>
              </li>
              <li>
                <i style="font-weight: bold"> Ouch! </i> That wasp just stung
                me!
              </li>
            </ul>

            <br />
            <p>
              An interjection can be used before or after a sentence that
              explains what’s going on. Interjection can be used alone, but it
              would not make sense if the cause is not described. Interjections
              often use exclamation points, but they don’t necessarily have to.
            </p>
            <br />
          </div>
        </div>
        <div class="col-12 mt-5">
          <h2>Interjections in a Sentence</h2>
          <p>
            An interjection can be used within a sentence. The interjection must
            be placed inside parentheses or set it off with
            <a class="aTag" href="https://www.grammarin.com/what-is-a-comma">
              commas</a
            >.
          </p>
          <br />
          <p class="examplFnt">Examples:</p>
          <ul class="example">
            <li>
              I may not get that car, but
              <i style="font-weight: bold"> hey </i> at least I tried.
              <i style="font-weight: bold"> (Wrong) </i>
            </li>

            <li>
              I may not get that car, but,
              <i style="font-weight: bold"> hey, </i> at least I tried.
              <i style="font-weight: bold"> (Correct) </i>
            </li>
            <li>
              The project was a flop because the logistics team made a few
              <i style="font-weight: bold"> ahem </i> mistakes.
              <i style="font-weight: bold"> (Wrong) </i>
            </li>
            <li>
              The project was a flop because the logistics team made a few
              <i style="font-weight: bold"> (ahem) </i> mistakes.
              <i style="font-weight: bold"> (Correct) </i>
            </li>
            <li>
              It will take only ten minutes
              <i style="font-weight: bold"> Wow! </i> to reach the city on the
              new train. <i style="font-weight: bold"> (Wrong) </i>
            </li>
            <li>
              It will take only ten minutes
              <i style="font-weight: bold"> (Wow!) </i> to reach the city on the
              new train.
              <i style="font-weight: bold"> (Correct) </i>
            </li>
          </ul>
        </div>

        <div class="col-12 mt-5">
          <h2>When to Use Interjections</h2>
          <p>
            Interjections can be used in informal writing. However, avoid using
            interjections in formal writing because it may appear that you are
            not treating the topic seriously.
          </p>
        </div>
      </div>
    </div>
  </div>
</div>
<!--End interjections-->

<!--Nouns-->
<div class="mb-5" *ngIf="section === 'what-are-nouns'">
  <div class="container-fluid hero-modfy">
    <app-header></app-header>

    <div class="container modify-container">
      <div class="row">
        <div class="col-12 head-top">
          <nav aria-label="breadcrumb" class="mb-1">
            <ol class="breadcrumb">
              <li class="breadcrumb-item">
                <a [routerLink]="['/']">Home</a>
              </li>
              <li class="breadcrumb-item">
                <a [routerLink]="['/handbook']">Handbook</a>
              </li>
              <li class="breadcrumb-item">
                <a [routerLink]="['/handbook/grammar']">Grammar</a>
              </li>
              <li class="breadcrumb-item activebread">
                <a [routerLink]="['/what-are-nouns']">What Are Nouns</a>
              </li>
            </ol>
          </nav>

          <h1 class="mb-2 heading">What Are Nouns</h1>
          <p class="py-3 head-details">
            A noun is a word that names something: either a person, place,
            feeling or tangible and intangible thing. In a sentence, nouns can
            play the role of subject, direct object, indirect object, subject
            complement, object complement, appositive, or adjective.
          </p>
        </div>
      </div>
    </div>
  </div>
  <div class="container-fluid">
    <div class="container">
      <div class="row justify-content-center">
        <div class="col-12">
          <h2>Types of Nouns</h2>
          <br />
          <br />
          <h2>1. Proper Nouns:</h2>
          <p>
            A proper noun is a specific name of a person, place, or thing, and
            is always
            <a
              class="aTag"
              href="https://www.grammarin.com/what-is-capitalization"
            >
              capitalized</a
            >.
          </p>
          <br />
          <p class="examplFnt">Examples:</p>
          <div class="tips">
            <ul class="example">
              <li>
                Does <i style="font-weight: bold"> Tina </i> have much homework
                to do this evening?
              </li>
            </ul>
            <p>
              <i style="font-weight: bold"> Tina </i> is the name of a specific
              person.
            </p>
          </div>
          <br />
          <h2>2. Common Nouns:</h2>
          <p>
            Common Noun is sometimes known as a generic noun. A common noun is
            the generic name of an item in a class or group and is not
            capitalized, unless appearing at the beginning of a sentence or in a
            title.
          </p>
          <br />
          <p class="examplFnt">Examples:</p>
          <div class="tips">
            <ul class="example">
              <li>
                The <i style="font-weight: bold"> girl </i> crossed the river.
              </li>
              <li>
                A <i style="font-weight: bold"> mosquito </i> causes Malaria.
              </li>
            </ul>
          </div>
        </div>
        <div class="col-12 mt-5">
          <h2>Types of Common Nouns</h2>
          <p>
            Common or generic nouns can be broken down into three subtypes:
            concrete nouns, abstract nouns, and collective nouns.
          </p>
          <br />
          <br />
          <h2>1. Concrete Noun:</h2>
          <p>
            A concrete noun is something that is perceived by the senses;
            something that is physical or real.
          </p>
          <br />
          <p class="examplFnt">Examples:</p>
          <ul class="example">
            <li>I heard the <i style="font-weight: bold"> doorbell. </i></li>
            <li>My <i style="font-weight: bold"> keyboard </i> is sticky.</li>
          </ul>
          <br />
          <h2>2. Abstract Noun:</h2>
          <p>
            An abstract noun is something that cannot be perceived by the
            senses. Generally, referring to ideas, conditions and qualities.
          </p>
          <br />
          <p class="examplFnt">Example:</p>
          <ul class="example">
            <li>
              It needs <i style="font-weight: bold"> courage </i> to confront
              the wrong.
            </li>
          </ul>
          <br />
          <h2>3. Collective Noun:</h2>
          <p>
            A collective noun denotes a group or collection of people or things.
          </p>
          <br />
          <p class="examplFnt">Example:</p>
          <ul class="example">
            <li>
              That <i style="font-weight: bold"> fleet </i> of ships is
              magnificent.
            </li>
            <li>
              A <i style="font-weight: bold"> flock </i> of birds flew away.
            </li>
          </ul>
          <p>
            Collective nouns take a
            <a class="aTag" href="https://www.grammarin.com/what-is-a-verb"
              >singular verb
            </a>
            as if they are one entity – in this case, the singular verb is.
          </p>
        </div>

        <div class="col-12 mt-5">
          <h2>Nouns as Subjects</h2>
          <p>
            Every sentence must have a subject, and a noun is a subject. The
            subject of a sentence is the person, place, or thing that is doing
            or performing an action in that sentence.
          </p>
          <br />
          <p class="examplFnt">Examples:</p>
          <ul class="example">
            <li><i style="font-weight: bold"> Birds </i> are flying.</li>
          </ul>
          <p>
            <i style="font-weight: bold"> ‘Birds’ </i> is the subject of the
            sentence.
          </p>
        </div>

        <div class="col-12 mt-5">
          <h2>Nouns as Objects</h2>
          <p>
            Nouns can also be objects of a verb in a sentence. An object can be
            either a direct object (a noun that receives the action performed by
            the subject) or an indirect object (a noun that is the recipient of
            a direct object).
          </p>
          <br />
          <p class="examplFnt">Examples:</p>
          <ul class="example">
            <li>
              Share the <i style="font-weight: bold"> notes </i> with
              <i style="font-weight: bold"> him. </i>
            </li>
          </ul>
          <p>
            <i style="font-weight: bold"> Notes </i> is a direct object (what is
            shared) and <i style="font-weight: bold"> him </i> is the indirect
            object (whom the notes are given).
          </p>
        </div>

        <div class="col-12 mt-5">
          <h2>Nouns as Subject and Object Complements</h2>
          <p>Another type of noun use is called a subject complement.</p>
          <br />
          <p class="examplFnt">Examples:</p>
          <ul class="example">
            <li>
              Harry is a
              <i style="font-weight: bold">
                mechanic. (Mechanic is a subject complement.)
              </i>
            </li>
          </ul>
          <p>A related usage of nouns is called an object complement.</p>
          <br />
          <p class="examplFnt">Examples:</p>
          <ul class="example">
            <li>
              I now pronounce you
              <i style="font-weight: bold"> husband </i> and
              <i style="font-weight: bold">wife. </i>
            </li>
          </ul>
          <p>
            <i style="font-weight: bold"> Husband </i> and
            <i style="font-weight: bold"> wife </i> are nouns used as object
            complements in this sentence. Verbs that denote making, naming, or
            creating are often followed by object complements.
          </p>
        </div>

        <div class="col-12 mt-5">
          <h2>Appositive Nouns and Nouns as Modifiers</h2>
          <p>
            An appositive noun is a noun which immediately follows another noun
            in order to further define or identify it.
          </p>
          <br />
          <p class="examplFnt">Examples:</p>
          <ul class="example">
            <li>
              My sister, <i style="font-weight: bold"> Simona, </i> is sixteen
              years old.
            </li>
          </ul>
          <p>
            <i style="font-weight: bold"> Simona </i> is an appositive here,
            further identifying the subject of the sentence, my sister.
          </p>
          <br />
          <p>Sometimes, nouns can be used adjectivally as well.</p>
          <br />
          <p class="examplFnt">Examples:</p>
          <ul class="example">
            <li>He is a <i style="font-weight: bold"> speed </i> demon.</li>
          </ul>
          <p>
            <i style="font-weight: bold"> Speed </i> is normally a noun, but
            here it is acting as an
            <a
              class="aTag"
              href="https://www.grammarin.com/what-are-adjectives"
            >
              adjective</a
            >
            to modify demon.
          </p>
        </div>

        <div class="col-12 mt-5">
          <h2>Plural Nouns</h2>
          <p>
            Plural nouns, unlike collective nouns, require plural verbs. Many
            English plural nouns can be formed by adding -s or -es to the
            singular form, although there are many exceptions.
          </p>
          <br />
          <p class="examplFnt">Examples:</p>
          <ul class="example">
            <li>dog— <i style="font-weight: bold"> dogs </i></li>
            <li>These two dogs are both black.</li>
            <li>Note the plural verb are.</li>
            <li>box— <i style="font-weight: bold"> boxes </i></li>
            <li>ax— <i style="font-weight: bold"> axes </i></li>
          </ul>
        </div>

        <div class="col-12 mt-5">
          <h2>Countable Nouns</h2>
          <p>
            Countable nouns are nouns which can be counted, even if the number
            might be extraordinarily high (like counting all the people in the
            world).
          </p>
          <p>
            Countable nouns can be used with
            <i style="font-weight: bold">
              a/an, the, some, any, a few, and many.
            </i>
          </p>

          <br />
          <p class="examplFnt">Examples:</p>
          <ul class="example">
            <li>
              Here is <i style="font-weight: bold"> a </i> rat. (Rat is singular
              and—countable).
            </li>
            <li>Here are <i style="font-weight: bold"> a few </i> rats.</li>
            <li>Here are <i style="font-weight: bold"> some </i> rats.</li>
          </ul>
        </div>

        <div class="col-12 mt-5">
          <h2 class="update">Uncountable Nouns</h2>
          <p>
            Uncountable nouns are nouns that impossible to count; liquids are
            uncountable, and things that act like liquids (sand, air). They are
            always considered singular, and can be used with some, any, a
            little, and much.
          </p>

          <br />
          <p class="examplFnt">Examples:</p>
          <ul class="example">
            <li>
              Private schools give so
              <i style="font-weight: bold"> much </i> homework that children do
              not have time to relax.
            </li>
          </ul>
          <p>
            This example refers to an unspecified, unquantifiable amount of
            homework, so homework is an uncountable noun.
          </p>
        </div>

        <div class="col-12 mt-5">
          <h2 class="update">Possessive Nouns</h2>
          <p>
            Possessive nouns show the possession or ownership of something. A
            possessive noun can be identified by
            <a
              class="aTag"
              href="https://www.grammarin.com/what-are-apostrophes"
            >
              apostrophe</a
            >
            and s.
          </p>
          <br />
          <p class="examplFnt">Examples:</p>
          <ul class="example">
            <li>
              The <i style="font-weight: bold"> child’s car seat </i> was
              broken.
            </li>
          </ul>

          <br />
          <p>
            When a singular noun ends in the letter s or z, the same format
            often applies.
          </p>
          <p class="examplFnt">Examples:</p>
          <ul class="example">
            <li>
              I have been appreciated by the
              <i style="font-weight: bold"> boss’s </i> PA last Friday.
            </li>
            <li>
              Mrs. <i style="font-weight: bold"> Sanchez’s hat </i> is still
              hanging on the peg.
            </li>
          </ul>
          <br />
          <p>
            Plural nouns ending in s take only an apostrophe to form a
            possessive.
          </p>
          <p class="examplFnt">Examples:</p>
          <ul class="example">
            <li>
              My <i style="font-weight: bold"> nieces’ </i> prom dresses were
              exquisite.
            </li>
          </ul>
        </div>
      </div>
    </div>
  </div>
</div>
<!--End nouns-->
<!--Prepositions-->
<div class="mb-5" *ngIf="section === 'what-are-prepositions'">
  <div class="container-fluid hero-Adjectives">
    <app-header></app-header>

    <div class="container modify-container">
      <div class="row">
        <div class="col-12 head-top">
          <nav aria-label="breadcrumb" class="mb-1">
            <ol class="breadcrumb">
              <li class="breadcrumb-item">
                <a [routerLink]="['/']">Home</a>
              </li>
              <li class="breadcrumb-item">
                <a [routerLink]="['/handbook']">Handbook</a>
              </li>
              <li class="breadcrumb-item">
                <a [routerLink]="['/handbook/grammar']">Grammar</a>
              </li>
              <li class="breadcrumb-item activebread">
                <a [routerLink]="['/what-are-prepositions']"
                  >What Are Prepositions</a
                >
              </li>
            </ol>
          </nav>

          <h1 class="mb-2 heading">What Are Prepositions</h1>
          <p class="py-3 head-details">
            Prepositions indicate relationships between other words in a
            sentence. Many prepositions tell where something is or when
            something happened. The meaning changes quite a bit in different
            contexts.
          </p>
        </div>
      </div>
    </div>
  </div>
  <div class="container-fluid">
    <div class="container">
      <div class="row justify-content-center">
        <div class="col-12">
          <p class="examplFnt">Examples:</p>
          <div class="tips">
            <ul class="example">
              <li>
                The book is <i style="font-weight: bold"> on </i> the table.
                (Preposition on tells where is the book)
              </li>
              <li>
                He will arrive <i style="font-weight: bold"> at </i> six o clock
                (preposition at tells when he will arrive)
              </li>
            </ul>
          </div>
          <br />
          <p>
            They can also indicate more abstract ideas; such as purpose or
            contrast.
          </p>
          <p class="examplFnt">Examples:</p>
          <div class="tips">
            <ul class="example">
              <li>
                We went <i style="font-weight: bold"> for </i> a walk
                <i style="font-weight: bold"> despite </i> the rain.
              </li>
            </ul>
          </div>
        </div>
        <div class="col-12 mt-5">
          <h2 class="update">Types of Prepositions</h2>

          <p>
            <a
              class="aTag"
              href="https://www.grammarin.com/what-are-prepositions"
            >
              Prepositions</a
            >
            indicate direction, time, location, and spatial relationships, as
            well as other abstract types of relationships.
          </p>
          <p>
            <i style="font-weight: bold">1. Direction: </i> Look
            <i style="font-weight: bold">to </i> the left and you’ll see our
            destination.
          </p>
          <p>
            <i style="font-weight: bold">2. Time: </i> We’ve been working
            <i style="font-weight: bold">since </i>
            this morning.
          </p>
          <p>
            <i style="font-weight: bold">3. Location: </i> We saw a movie
            <i style="font-weight: bold">at </i> the theatre.
          </p>
          <p>
            <i style="font-weight: bold">4. Space: </i> The dog hid
            <i style="font-weight: bold">under </i> the table.
          </p>

          <br />
          <br />

          <h2 class="update">Preposition Examples</h2>
          <br />
          <ul class="example">
            <li>
              I should rewrite the analysis
              <i style="font-weight: bold"> of </i> my report.
            </li>
            <li>
              Simona picked her jacket
              <i style="font-weight: bold"> from </i> the store.
            </li>
            <li>
              Did you receive the gift
              <i style="font-weight: bold"> from </i> your friend?
            </li>
            <li>
              We are making bed <i style="font-weight: bold"> for </i> ten
              guests tonight.
            </li>
          </ul>
        </div>
        <div class="col-12 mt-5">
          <h2>Unnecessary Prepositions</h2>
          <p>Too many prepositions can be a sign of flabby writing.</p>

          <br />
          <p class="examplFnt">Examples:</p>
          <ul class="example">
            <li>
              Alex hit the baseball <i style="font-weight: bold"> up </i> over
              the fence.
            </li>
            <li>
              <i style="font-weight: bold">
                Alex hit the baseball over the fence.
              </i>
            </li>
            <li>
              Where is your brother <i style="font-weight: bold"> at? </i>
            </li>
            <li>
              <i style="font-weight: bold"> Where is your brother? </i>
            </li>
            <li>
              The meeting is scheduled for
              <i style="font-weight: bold"> at</i> 3 p.m.
            </li>
            <li>
              <i style="font-weight: bold"
                >The meeting is scheduled for 3 p.m.
              </i>
            </li>
            <!-- <li>
              <p>Too many prepositions can be a sign of flabby writing.</p>
            </li> -->
          </ul>
          <br />
          <p class="examplFnt">Examples:</p>
          <ul class="example">
            <li>
              <i style="font-weight: bold">For </i> many people, the reality
              <i style="font-weight: bold"> of </i> an entry
              <i style="font-weight: bold"> into </i> a new area
              <i style="font-weight: bold"> of </i> employment is cause
              <i style="font-weight: bold"> for </i> a host
              <i style="font-weight: bold"> of </i> anxieties.
            </li>
            <li>Shorter, more direct, and easier sentence:</li>
            <li>
              <i style="font-weight: bold">
                Changing careers make many people anxious.
              </i>
            </li>
            <li>Alex hit the baseball up over the fence.</li>
            <li>Get rid of the up. You don’t need it:</li>
            <li>
              <i style="font-weight: bold"
                >Alex hit the baseball over the fence.</i
              >
            </li>
          </ul>
        </div>
      </div>
    </div>
  </div>
</div>
<!--End prepositions-->
<!--pronouns-->
<div class="mb-5" *ngIf="section === 'what-are-pronouns'">
  <div class="container-fluid hero-short">
    <app-header></app-header>

    <div class="container modify-container">
      <div class="row">
        <div class="col-12 head-top">
          <nav aria-label="breadcrumb" class="mb-1">
            <ol class="breadcrumb">
              <li class="breadcrumb-item">
                <a [routerLink]="['/']">Home</a>
              </li>
              <li class="breadcrumb-item">
                <a [routerLink]="['/handbook']">Handbook</a>
              </li>
              <li class="breadcrumb-item">
                <a [routerLink]="['/handbook/grammar']">Grammar</a>
              </li>
              <li class="breadcrumb-item activebread">
                <a [routerLink]="['/what-are-pronouns']">What Are Pronouns</a>
              </li>
            </ol>
          </nav>

          <h1 class="mb-2 heading">What Are Pronouns</h1>
          <p class="py-3 head-details">
            Pronouns substitute other nouns. Also, these are very effective
            cohesive device.
          </p>
        </div>
      </div>
    </div>
  </div>
  <div class="container-fluid">
    <div class="container">
      <div class="row justify-content-center">
        <div class="col-12">
          <p>
            If a story is about a mother Simona, the story will sound repetitive
            if name ‘Simona’ is repeated again and again.
          </p>
          <br />
          <p class="examplFnt">Examples:</p>
          <div class="tips">
            <ul class="example">
              <li>
                Simona is a great mom.
                <i style="font-weight: bold"> Simona </i> puts
                <i style="font-weight: bold"> Simona’s </i> children as
                <i style="font-weight: bold"> Simona’s </i> first priority.
                Although, sometimes
                <i style="font-weight: bold"> Simona </i> finds it hard to
                balance <i style="font-weight: bold"> Simona’s </i> parental and
                work responsibilities; yet,
                <i style="font-weight: bold"> Simona </i> manages
                <i style="font-weight: bold"> Simona’s </i> life well.
              </li>
            </ul>

            <br />
            <p>
              The passage sounds very repetitive and it lacks coherence and
              flow. Also, it sounds like we are not talking about one person but
              more than one who have similar name. However, in the beginning of
              the passage, it is appropriate to use a
              <a class="aTag" href="https://www.grammarin.com/what-are-nouns">
                noun</a
              >
              so reader knows whom writer is talking about.
            </p>
            <br />
            <p>
              If name is replaced with pronoun, it will make more sense,
              coherence and flow.
            </p>
            <br />
            <p>it will be like this:</p>

            <br />
            <ul class="example">
              <li>
                Simona is a great mom.
                <i style="font-weight: bold"> She </i> puts
                <i style="font-weight: bold"> her </i> children as her first
                priority. Although, sometimes
                <i style="font-weight: bold"> she </i> finds it hard to balance
                <i style="font-weight: bold"> her </i> parental and work
                responsibilities; yet,
                <i style="font-weight: bold"> she </i> manages
                <i style="font-weight: bold"> her </i> life well.
              </li>
            </ul>
          </div>
        </div>
        <div class="col-12 mt-5">
          <h2>Personal Pronouns</h2>

          <p>
            The personal pronouns are <i style="font-weight: bold"> She </i> and
            <i style="font-weight: bold"> her, </i>
            <i style="font-weight: bold"> I </i> and
            <i style="font-weight: bold"> me, </i> you,
            <i style="font-weight: bold"> he </i> and
            <i style="font-weight: bold"> him, it, we </i> and
            <i style="font-weight: bold"> us, they </i> and
            <i style="font-weight: bold"> them. </i>
          </p>

          <br />
          <p class="examplFnt">Examples:</p>
          <div class="tips">
            <ul class="example">
              <li>
                Please mail it to
                <i style="font-weight: bold"> I. (Wrong) </i>
              </li>
              <li>
                Please mail it to
                <i style="font-weight: bold"> me. (Correct) </i>
              </li>
              <li>
                Ms. Queeneth observed
                <i style="font-weight: bold"> they </i> working hard.
                <i style="font-weight: bold"> (Wrong) </i>
              </li>
              <li>
                Ms. Queeneth observed
                <i style="font-weight: bold"> them </i> working hard.
                <i style="font-weight: bold"> (Correct)</i>
              </li>
              <li>
                Is this treat for
                <i style="font-weight: bold"> we? (Wrong) </i>
              </li>
              <li>
                Is this treat for
                <i style="font-weight: bold"> us? (Correct) </i>
              </li>
            </ul>
          </div>
        </div>
        <div class="col-12 mt-5">
          <h2>Relative Pronouns</h2>
          <p>
            Relative pronouns are used to connect relative clauses to
            independent clauses. Often, they introduce additional information
            about something mentioned in the sentence.
          </p>
          <p>
            Relative pronouns include
            <i style="font-weight: bold"> that, what, which, who, whose </i> and
            <i style="font-weight: bold"> whom.</i> Traditionally,
            <i style="font-weight: bold"> who </i> refers to people; whereas
            <i style="font-weight: bold"> which </i> and
            <i style="font-weight: bold"> that </i> refer to animals or things.
          </p>
          <br />
          <p class="examplFnt">Examples:</p>
          <ul class="example">
            <li>
              The man <i style="font-weight: bold"> who </i> drove the car was
              not identified.
            </li>
            <li>
              All the cats <i style="font-weight: bold"> that </i> were adopted
              today will be loved.
            </li>
            <li>
              My lipstick, <i style="font-weight: bold"> which </i> is nearly a
              year old, still runs well.
            </li>
          </ul>
          <p>
            Whether you need
            <a class="aTag" href="https://www.grammarin.com/what-is-a-comma"
              >commas
            </a>
            with <i style="font-weight: bold"> who, which, </i> and
            <i style="font-weight: bold"> that </i> depends on whether the
            clause is restrictive or non-restrictive.
          </p>
        </div>

        <div class="col-12 mt-5">
          <h2>Who / Whom—Subject and Object Pronouns</h2>
          <p>
            <i style="font-weight: bold"> Who </i> and
            <i style="font-weight: bold"> whom </i> are most confused pronouns.
            <i style="font-weight: bold"> Who </i> is a subject pronoun, like
            <i style="font-weight: bold"> I, he, she, we, </i> and
            <i style="font-weight: bold"> they </i> .<i
              style="font-weight: bold"
              >Whom
            </i>
            is an object
            <a class="aTag" href="https://www.grammarin.com/what-are-pronouns">
              pronoun</a
            >
            , like <i style="font-weight: bold"> me, him, her, us </i> and
            <i style="font-weight: bold"> them. </i> When the pronoun is the
            <a class="aTag" href="https://www.grammarin.com/what-is-a-verb">
              object of a verb</a
            >
            or
            <a
              class="aTag"
              href="https://www.grammarin.com/what-are-prepositions"
            >
              preposition</a
            >
            , the object form (whom) is used.
          </p>
          <p>
            <i style="font-weight: bold"> Whom </i> is trickier, because it
            usually comes before the verb or prepositions that modifies it.
          </p>
          <br />
          <p class="examplFnt">Examples:</p>
          <ul class="example">
            <li>
              <i style="font-weight: bold"> Whom </i> did you speak to earlier?
            </li>
            <li>
              A lady, <i style="font-weight: bold"> whom </i> I have never met
              before, was talking about you.
            </li>
            <li>
              <i style="font-weight: bold"> Whom </i> should I tell is calling?
            </li>
          </ul>
        </div>
        <div class="col-12 mt-5">
          <h2>Tip to use who/whom</h2>
          <p>
            Substitute who/whom with personal pronoun to see which one goes in a
            specific sentence.
          </p>
          <p>
            Find the place where the personal pronoun would normally go and see
            whether the subject or object form makes more sense.
          </p>

          <br />
          <p class="examplFnt">Examples:</p>
          <ul class="example">
            <li>
              <p>Who/whom did you speak to earlier?</p>
            </li>
          </ul>
          <p>
            Replace <i style="font-weight: bold"> who/whom </i> with
            <i style="font-weight: bold"> he/him </i>
            earlier?
          </p>

          <br />
          <p>
            Observe if object pronoun (him) goes well in the sentence then use
            (whom)
          </p>
          <p class="examplFnt">Examples:</p>
          <ul class="example">
            <li>Did you speak to him?</li>
            <li>Whom did you speak?</li>
          </ul>
        </div>

        <div class="col-12 mt-5">
          <h2>Use of pronoun I</h2>
          <p>
            There is always a confusion to use pronoun I. Remember
            <i style="font-weight: bold"> I </i> is a subject and
            <i style="font-weight: bold"> me </i> is an object pronoun. See the
            difference in the following examples.
          </p>

          <br />
          <p class="examplFnt">Examples:</p>
          <ul class="example">
            <li>
              Joe is celebrating with Simona and
              <i style="font-weight: bold"> I </i> this afternoon.
              <i style="font-weight: bold"> (Wrong) </i>
            </li>

            <li>
              Joe is celebrating with Simona and
              <i style="font-weight: bold"> me </i> this afternoon.
              <i style="font-weight: bold"> (Correct) </i>
            </li>
            <li>
              There are no secrets between you and
              <i style="font-weight: bold"> I.(Wrong) </i>
            </li>
            <li>
              There are no secrets between you and
              <i style="font-weight: bold"> me. (Correct) </i>
            </li>
          </ul>
          <br />
          <p>
            The correct pronoun is <i style="font-weight: bold"> me </i> instead
            of <i style="font-weight: bold"> I. </i> It can be checked if you
            remove other name.
          </p>
          <br />
        </div>
        <div class="col-12 mt-5">
          <h2>Demonstrative Pronouns</h2>
          <p>
            <i style="font-weight: bold"> That, this, these </i> and
            <i style="font-weight: bold"> those </i> are demonstrative pronouns.
            They take the place of a noun or noun phrase that has already been
            mentioned.
          </p>
          <p>
            <i style="font-weight: bold">This </i> is used for singular items
            that are nearby.
          </p>
          <p>
            <i style="font-weight: bold">These </i> is used for multiple items
            that are nearby. The distance can be physical or
            <a class="aTag" href="https://www.grammarin.com/what-are-metaphors">
              metaphorical</a
            >
            .
          </p>

          <br />

          <p class="examplFnt">Examples:</p>
          <ul class="example">
            <li>
              Here is a report. Who could have submitted
              <i style="font-weight: bold"> this? </i>
            </li>
            <li>
              What a wonderful idea!
              <i style="font-weight: bold"> This </i> is the best thing I have
              heard all day.
            </li>
          </ul>
          <br />
          <p>
            <i style="font-weight: bold"> That </i> is used for singular items
            that are far away.
          </p>

          <p>
            <i style="font-weight: bold">Those </i> is used for multiple items
            that are far away. Again, the distance can be physical or
            metaphorical.
          </p>
          <br />
          <p class="examplFnt">Examples:</p>
          <ul class="example">
            <li>
              <i style="font-weight: bold"> That </i> Swan in the pond swims so
              gracefully.
            </li>
            <li>
              The fashion brand has introduced some new lines last week. Did you
              try <i style="font-weight: bold"> those? </i>
            </li>
          </ul>
        </div>

        <div class="col-12 mt-5">
          <h2>Indefinite Pronouns</h2>
          <p>
            Indefinite pronouns are used for a person or thing that is not
            specifically identified. Some common indefinite pronouns are
            <i style="font-weight: bold">
              one, other, none, some, anybody, everybody,
            </i>
            and <i style="font-weight: bold"> no one. </i>
          </p>

          <br />
          <p class="examplFnt">Examples:</p>
          <ul class="example">
            <li>
              <i style="font-weight: bold"> Everybody </i> was happy to attend
              New Year party.
            </li>
            <li>
              It matters nothing to <i style="font-weight: bold"> some. </i>
            </li>
            <li>
              <i style="font-weight: bold"> Nobody </i> knows the secret I knew.
            </li>
          </ul>
        </div>

        <div class="col-12 mt-5">
          <h2>Reflexive and Intensive Pronouns</h2>
          <p>
            Reflexive pronouns end in
            <i style="font-weight: bold"> -self </i> or
            <i style="font-weight: bold">
              -selves: myself, yourself, himself, herself, itself, ourselves,
              yourselves, themselves.</i
            >
          </p>
          <p>
            Reflexive pronoun is used when both the subject and object of a verb
            refer to the same person or thing. These are also used to emphasize.
          </p>
          <br />
          <p class="examplFnt">Examples:</p>
          <ul class="example">
            <li>
              Joe patted <i style="font-weight: bold">herself </i> for the
              courage she showed.
            </li>
            <li>
              They booked <i style="font-weight: bold"> themselves </i> a room
              at the resort.
            </li>
            <li>
              I built this laptop <i style="font-weight: bold"> myself. </i>
            </li>
          </ul>
          <p>
            <li>
              “I built this laptop” and “I built this laptop myself” mean almost
              the same thing. But “myself” emphasizes that I personally built
              the laptop—I didn’t engage or hire someone else to do it for me.
            </li>
          </p>
        </div>

        <div class="col-12 mt-5">
          <h2>Possessive Pronouns</h2>
          <p>
            Possessive pronouns come in two categories: limiting and absolute.
          </p>
          <p>
            Limiting pronouns are:
            <i style="font-weight: bold">
              My, your, its, his, her, our, their and whose.</i
            >
            They are used to show that something belongs to an antecedent.
          </p>
          <br />
          <p class="examplFnt">Examples:</p>
          <ul class="example">
            <li>
              Simona is a great mom. She puts
              <i style="font-weight: bold"> her </i> children as
              <i style="font-weight: bold"> her </i> first priority.
              <i style="font-weight: bold"> Her </i> children also give
              <i style="font-weight: bold"> their </i> best to please
              <i style="font-weight: bold"> their </i> mom.
            </li>
          </ul>
          <br />
          <p>
            The absolute possessive pronouns are
            <i style="font-weight: bold">
              mine, yours, his, hers, theirs, and ours.
            </i>
          </p>
          <p>
            The absolute forms substitute for the thing that belongs to the
            antecedent.
          </p>
          <br />
          <p class="examplFnt">Examples:</p>
          <ul class="example">
            <li>
              Are you finished with your work? Joe already finished
              <i style="font-weight: bold"> hers. </i>
            </li>
            <li>The blue bike is <i style="font-weight: bold"> mine. </i></li>
          </ul>

          <br />
          <p>
            Some possessive pronouns are easy to mix up with similar-looking
            <a
              class="aTag"
              href="https://www.grammarin.com/what-are-contractions"
            >
              contractions</a
            >.
          </p>

          <p class="examplFnt">Examples:</p>
          <ul class="example">
            <li>
              Such as <i style="font-weight: bold"> its </i> and
              <i style="font-weight: bold"> it’s. </i> They both have different
              meaning.
            </li>
          </ul>
          <br />
          <p>
            Keep in mind, possessive personal pronouns do not include
            <a
              class="aTag"
              href="https://www.grammarin.com/what-are-apostrophes"
            >
              apostrophes</a
            >.
          </p>
        </div>

        <div class="col-12 mt-5">
          <h2>Interrogative Pronouns</h2>
          <p>
            Interrogative pronouns are used in questions. The interrogative
            pronouns are
            <i style="font-weight: bold"> who, what, whom, whoever, which, </i>
            and
            <i style="font-weight: bold"> whose. </i>
          </p>

          <br />
          <p class="examplFnt">Examples:</p>
          <ul class="example">
            <li><i style="font-weight: bold"> Who </i> wants Dior Perfume?</li>
            <li><i style="font-weight: bold"> What </i> is your name?</li>
            <li>
              <i style="font-weight: bold"> Which </i> colour do you like the
              most?
            </li>
            <li><i style="font-weight: bold"> Whose </i> pencil is this?</li>
          </ul>
        </div>

        <div class="col-12 mt-5">
          <h2>Antecedents</h2>
          <p>
            An antecedent is a noun or noun phrase that you mention at the
            beginning of a sentence or story and later replace with a pronoun.
            Pronoun
            <i style="font-weight: bold"> it </i> refers to anything, feelings,
            and places. Therefore, antecedent helps the reader to know for whom
            the pronoun is used.
          </p>
          <br />
          <p class="examplFnt">Examples:</p>
          <ul class="example">
            <li>
              Simona and Zaki are twins.
              <i style="font-weight: bold"> He </i> likes to play hockey and
              <i style="font-weight: bold"> she </i> likes to play with dolls.
            </li>
          </ul>
          <p>
            Antecedent (Simona and Zaki) makes it clear for the reader that
            pronoun <i style="font-weight: bold"> he </i> is used for Zaki (boy)
            and <i style="font-weight: bold"> she </i> is used for Simona (girl)
          </p>
        </div>
      </div>
    </div>
  </div>
</div>
<!--End pronouns-->
<!--Verbs-->
<div class="mb-5" *ngIf="section === 'what-is-a-verb'">
  <div class="container-fluid hero-short">
    <app-header></app-header>

    <div class="container modify-container">
      <div class="row">
        <div class="col-12 head-top">
          <nav aria-label="breadcrumb" class="mb-1">
            <ol class="breadcrumb">
              <li class="breadcrumb-item">
                <a [routerLink]="['/']">Home</a>
              </li>
              <li class="breadcrumb-item">
                <a [routerLink]="['/handbook']">Handbook</a>
              </li>
              <li class="breadcrumb-item">
                <a [routerLink]="['/handbook/grammar']">Grammar</a>
              </li>
              <li class="breadcrumb-item activebread">
                <a [routerLink]="['/what-is-a-verb']">What Is a Verb</a>
              </li>
            </ol>
          </nav>
          <h1 class="mb-2 heading">What Is a Verb</h1>
          <p class="py-3 head-details">
            A verb is a word that expresses action. The action can be physical,
            mental or state of being.
          </p>
        </div>
      </div>
    </div>
  </div>
  <div class="container-fluid">
    <div class="container">
      <div class="row justify-content-center">
        <div class="col-12">
          <p class="examplFnt">Examples:</p>
          <div class="tips">
            <ul class="example">
              <li>
                Swim, write, climb, think, guess, consider, be, exist, appear
              </li>
            </ul>
          </div>
        </div>
        <div class="col-12 mt-5">
          <h2>Types of Verb</h2>
          <br />
          <br />
          <h2>Action (Dynamic) Verbs</h2>
          <p>
            Action verbs express actions. The action must not be physical only.
          </p>

          <br />
          <p class="examplFnt">Examples:</p>
          <div class="tips">
            <ul class="example">
              <li>Run, Dance, Slide, Jump, Go, Do, Smile, Listen</li>
              <li>He does it well.</li>
              <li>I run slower than him.</li>
            </ul>
          </div>
        </div>
        <div class="col-12 mt-5">
          <h2 class="update">Stative (state of being) Verbs</h2>
          <p>
            Stative verbs express state or feeling including likes and dislikes.
            They can’t be used in continuous tense form. They stick to the
            simple tense form or occasionally used in perfect form.
          </p>

          <br />
          <p class="examplFnt">Examples:</p>
          <ul class="example">
            <li>
              Want, need, prefer, love, seem, believe, involve, realize (Some
              verbs can be dynamic and stative both. When these verbs are used
              for specific, voluntary actions/events, they can be dynamic and
              can be used in continuous tense form.)
            </li>
          </ul>
          <br />
          <p class="examplFnt">Examples:</p>
          <ul class="example">
            <li>Perception words: see, hear, taste, smell, feel</li>
            <li>I can’t see in sunlight.</li>
            <li>I haven’t been seeing well in sunlight.</li>
            <li>The cake of her birthday tastes great.</li>
            <li>They were tasting the cake of her birthday.</li>
          </ul>
        </div>

        <div class="col-12 mt-5">
          <h2 class="update">Auxiliary Verbs</h2>
          <p>
            Auxiliary verbs are used to change the voice, tense or mood of the
            sentence. They are always used with the main verb to represent main
            action. They must be used correctly.
          </p>

          <br />
          <p class="examplFnt">Examples:</p>
          <ul class="example">
            <li>I have eaten this ice cream many times.</li>
            <li>This ice cream was eaten by me.</li>
            <li>Did you eat that ice cream?</li>
          </ul>
        </div>
        <div class="col-12 mt-5">
          <h2 class="update">Modal Verbs</h2>
          <p>
            Some auxiliary verbs express possibility, capability or necessity.
            They are not the main verbs but they do change the meaning of the
            sentence.
          </p>

          <br />
          <p class="examplFnt">Examples:</p>
          <ul class="example">
            <li>Can, could, may, might, should, would, must, ought</li>
          </ul>
        </div>

        <div class="col-12 mt-5">
          <h2 class="update">Phrasal Verbs</h2>
          <p>
            Phrasal verbs are phrases that act individual combining two or more
            words to change their meanings. Mostly
            <a
              class="aTag"
              href="https://www.grammarin.com/what-are-prepositions"
            >
              prepositions</a
            >
            are added with verbs to form phrasal verbs.
          </p>

          <br />
          <p class="examplFnt">Examples:</p>
          <ul class="example">
            <li>Get by, look into, brought up</li>
          </ul>
        </div>
        <div class="col-12 mt-5">
          <h2 class="update">Verb Categories</h2>
          <br />
          <br />
          <h2 class="update">Transitive Verbs</h2>
          <p>A transitive verb is one that is followed by a direct object.</p>

          <br />
          <p class="examplFnt">Examples:</p>
          <ul class="example">
            <li>
              <p>Ali often takes a nap in the afternoon.</p>
            </li>
          </ul>
        </div>

        <div class="col-12 mt-5">
          <h2 class="update">Intransitive Verbs</h2>
          <p>
            An intransitive verb is one that is not followed by either a direct
            or an indirect object.
          </p>

          <br />

          <p class="examplFnt">Examples:</p>
          <ul class="example">
            <li>Ali often sleeps in the afternoon.</li>
          </ul>
          <p>
            <i style="font-weight: bold"
              >(An intransitive verb may be followed by adjectives, adverbs,
              prepositional phrases but it is not followed by a noun or a
              pronoun functioning as direct object.)
            </i>
          </p>
        </div>

        <div class="col-12 mt-5">
          <h2 class="update">Ditransitive Verbs</h2>
          <p>
            A ditransitive verb is one that is followed by both direct and
            indirect objects. Though they don’t always need indirect object, but
            they have the option.
          </p>

          <br />
          <p class="examplFnt">Examples:</p>
          <ul class="example">
            <li>Throw, make, buy, sell, give, lend, bring, read</li>
          </ul>
        </div>

        <div class="col-12 mt-5">
          <h2 class="update">Verb Forms</h2>
          <p>
            There are up to five forms for each verb: root, third-person
            singular, present participle, past, and past participle.
          </p>

          <br />
          <br />
          <h2 class="update">Root Form of the Verb</h2>
          <p>
            The root form of a verb is the base form of the word. Roots do not
            include prefixes or suffixes.
          </p>
          <br />
          <p class="examplFnt">Examples:</p>
          <ul class="example">
            <li>run, think, sleep, meditate</li>
          </ul>

          <br />
          <p>
            The root form of the verb is the same as the infinitive form. The
            difference is with infinitive form requires “to” before the root
            form of verb.
          </p>
          <br />
          <p class="examplFnt">Examples:</p>
          <ul class="example">
            <li>Feel – to feel</li>
            <li>Walk – to walk</li>
            <li>Run – to run</li>
          </ul>
        </div>

        <div class="col-12 mt-5">
          <h2 class="update">Third Person Singular Form of a Verb</h2>
          <p>
            For the third person singular (he/she/it/one) form of verb, the root
            verb ends in s (or sometimes es).
          </p>
          <br />
          <p class="examplFnt">Examples:</p>
          <ul class="example">
            <li>He runs</li>
            <li>She cooks</li>
            <li>It flies</li>
            <li>One loathes</li>
          </ul>
        </div>

        <div class="col-12 mt-5">
          <h2 class="update">Participle Form of a Verb</h2>
          <p>
            The participle verb form is created by adding -ing to the root word.
            It is used in the past, present, and future progressive and perfect
            continuous verb tenses.
          </p>
          <br />
          <p class="examplFnt">Examples:</p>
          <ul class="example">
            <li>
              We are <i style="font-weight: bold">leaving </i> the party at
              four. (leave – leaving)
            </li>
            <li>
              Children have been <i style="font-weight: bold">playing </i> since
              morning. (play– playing)
            </li>
            <li>
              We were <i style="font-weight: bold"> preparing </i> for party
              last week. (prepare ─ preparing)
            </li>
            <li>
              He will be <i style="font-weight: bold"> asking </i> for support
              for his new business. (ask ─ asking)
            </li>
          </ul>
        </div>

        <div class="col-12 mt-5">
          <h2 class="update">Past Form of the Verb</h2>
          <p>
            The past verb form for regular verbs is the root word + ed. It is
            only used with the past tenses.
          </p>
          <br />
          <p class="examplFnt">Examples:</p>
          <ul class="example">
            <li>
              We <i style="font-weight: bold"> played </i> for hours on Sunday
              afternoon. (play – played)
            </li>
            <li>
              The books were <i style="font-weight: bold"> packed </i> on the
              shelf. (pack – packed)
            </li>
          </ul>
          <p>
            For irregular verbs past form of verb is different from root form of
            verb.
          </p>
          <br />
          <p class="examplFnt">Examples:</p>
          <ul class="example">
            <li>
              Children <i style="font-weight: bold"> ate </i> pizza. (eat – ate)
            </li>
            <li>
              I <i style="font-weight: bold"> drank </i> water. (drink— drank)
            </li>
          </ul>
        </div>

        <div class="col-12 mt-5">
          <h2 class="update">Past Participle Forms of the Verb</h2>
          <p>
            The past participle form of verb is used in present, past and future
            perfect sentences. They are used with
            <i style="font-weight: bold"> has, have </i> and
            <i style="font-weight: bold"> had.</i> Past participle form of verb
            is also used in passive voice sentences.
          </p>
          <p>
            Like past form of verb, regular verbs become past participle form of
            verb by adding –ed to root verb. For irregular verbs it is
            different.
          </p>
          <br />
          <p class="examplFnt">Examples:</p>
          <ul class="example">
            <li>
              Children have <i style="font-weight: bold"> eaten </i> pizza by
              12. (eat — eaten)
            </li>
            <li>
              I have <i style="font-weight: bold"> drunk </i> water in break.
              (drink— drunk)
            </li>
          </ul>
          <br />
          <p class="examplFnt">Examples:</p>
          <ul class="example">
            <li>Children ate pizza. (eat – ate)</li>
            <li>I drank water. (drink— drank)</li>
          </ul>
          <br />
          <h2>Few Examples of Irregular form of verbs</h2>
          <table style="width: 50%">
            <tr style="background-color: #08ba99; color: white">
              <th style="text-align: center">Root</th>
              <th style="text-align: center">Simple Past</th>
              <th style="text-align: center">Past Participle</th>
            </tr>
            <tr>
              <td>Sing</td>
              <td>Sang</td>
              <td>Sung</td>
            </tr>
            <tr>
              <td>See</td>
              <td>Saw</td>
              <td>Seen</td>
            </tr>
            <tr>
              <td>Fall</td>
              <td>Fell</td>
              <td>Fallen</td>
            </tr>
            <tr>
              <td>Give</td>
              <td>Gave</td>
              <td>Given</td>
            </tr>
            <tr>
              <td>Go</td>
              <td>Went</td>
              <td>Gone</td>
            </tr>
          </table>
        </div>

        <div class="col-12 mt-5">
          <h2 class="update">Infinitives and gerunds</h2>
          <p>
            An infinitive adds the preposition ‘to’ in front of a verb’s root
            form.
          </p>
          <br />
          <p class="examplFnt">Examples:</p>
          <ul class="example">
            <li>Jim always forgets to drink.</li>
            <li>You promised to buy me a new dress.</li>
            <li>
              To travel around the world requires a lot of money and time.
            </li>
            <li>Ahmad has the ability to succeed.</li>
            <li>Do you want to call the police?</li>
            <li>Doctor convinced me to eat vegetables.</li>
          </ul>
          <br />
          <p>
            A gerund is a verb in the progressive (present participle) form that
            functions as a
            <a class="aTag" href="https://www.grammarin.com/what-are-nouns">
              noun</a
            >, naming an activity.
          </p>
          <br />
          <p class="examplFnt">Examples:</p>
          <ul class="example">
            <li>Jogging is a hobby of mine.</li>
            <li>Aslam quit smoking a year ago.</li>
            <li>She looks forward to helping you paint the room.</li>
            <li>She avoids using chemicals on the plants she grows.</li>
          </ul>
          <p>
            <i style="font-weight: bold"
              >(Gerund and Infinitives can replace a noun in a sentence.)</i
            >
          </p>
        </div>
      </div>
    </div>
  </div>
</div>
<!--end verbs-->
<!--apostrophe-->
<div class="mb-5" *ngIf="section === 'what-are-apostrophes'">
  <div class="container-fluid hero-short">
    <app-header></app-header>

    <div class="container modify-container">
      <div class="row">
        <div class="col-12 head-top">
          <nav aria-label="breadcrumb" class="mb-1">
            <ol class="breadcrumb">
              <li class="breadcrumb-item">
                <a [routerLink]="['/']">Home</a>
              </li>
              <li class="breadcrumb-item">
                <a [routerLink]="['/handbook']">Handbook</a>
              </li>
              <li class="breadcrumb-item">
                <a [routerLink]="['/handbook/punctuation']">Punctuation</a>
              </li>
              <li class="breadcrumb-item activebread">
                <a [routerLink]="['/what-are-apostrophes']"
                  >What Are Apostrophes</a
                >
              </li>
            </ol>
          </nav>
          <h1 class="mb-2 heading">What Are Apostrophes</h1>
          <p class="py-3 head-details">
            Apostrophes form possessives and contractions.
          </p>
        </div>
      </div>
    </div>
  </div>
  <div class="container-fluid">
    <div class="container">
      <div class="row justify-content-center">
        <div class="col-12">
          <h2 class="update">1. Apostrophe Use</h2>
          <br />
          <br />
          <h2 class="update">Contraction and Omission</h2>
          <p>
            A contraction is a shortened form of a word (or group of words) that
            omits certain letters or sounds. In a contraction, an apostrophe
            represents missing letters.
          </p>
          <p>
            The
            <a
              class="aTag"
              href="https://www.grammarin.com/what-are-contractions"
            >
              contraction</a
            >
            can be formed/made when
            <a class="aTag" href="https://www.grammarin.com/what-is-a-verb">
              verbs</a
            >, auxiliaries, or modals are attached to other words:
          </p>

          <br />
          <p class="examplFnt">Examples:</p>
          <div class="tips">
            <ul class="example">
              <li>
                He would=<i style="font-weight: bold">He’d.</i> I have=<i
                  style="font-weight: bold"
                  >I’ve.</i
                >
                They are=<i style="font-weight: bold">They’re. </i> You
                cannot=<i style="font-weight: bold">You can’t. </i>
              </li>
              <li>
                Some writers use contractions. For example,
                <i style="font-weight: bold"> somethin’ </i> represent the way
                people often don’t pronounce the final g of “something” in
                speech. Similarly,
                <i style="font-weight: bold"> e’er </i> (instead of ever) in
                poetry.
              </li>
              <li>
                Decade names are often contracted as well: the
                <i style="font-weight: bold"> ’90s </i> (the 1990s).
              </li>
            </ul>
            <table id="newone" style="width: 70%">
              <tr style="background-color: #08ba99; color: white">
                <th style="text-align: center">Contracted Form</th>
                <th style="text-align: center">Uncontracted</th>
                <th style="text-align: center">Examples</th>
              </tr>
              <tr>
                <td>-n’t</td>
                <td>Not</td>
                <td>Isn’t (is not), hasn’t (has not)</td>
              </tr>
              <tr>
                <td>-’re</td>
                <td>Are</td>
                <td>They’re (they are), we’re (we are), you’re (you are)</td>
              </tr>
              <tr>
                <td>-’d</td>
                <td>had, would</td>
                <td>She’d (she had, she would), I’d (I had, I would)</td>
              </tr>
              <tr>
                <td>-’ll</td>
                <td>Will</td>
                <td>We’ll (we will), you’ll (you will)</td>
              </tr>
              <tr>
                <td>-’s</td>
                <td>Is</td>
                <td>He’s (he is), it’s (it is)</td>
              </tr>
              <tr>
                <td>I’m</td>
                <td>I am</td>
                <td>—</td>
              </tr>
              <tr>
                <td>let’s</td>
                <td>let us</td>
                <td>—</td>
              </tr>
            </table>
            <br />
            <p>
              In formal writing contraction should be avoided. Only exception is
              o’clock, where the full phrase (of the clock) truly is rare.
            </p>
          </div>
        </div>
        <div class="col-12 mt-5">
          <h2 class="update">Apostrophes and Possessive Nouns</h2>
          <p>
            The rules about forming possessives vary, depending on what
            <a class="aTag" href="https://www.grammarin.com/what-are-nouns">
              type of noun</a
            >
            is forming a possessive. The thumb rules are:
          </p>

          <p>1. For most singular nouns, add apostrophe +s:</p>
          <br />
          <p class="examplFnt">Examples:</p>
          <ul class="example">
            <li>
              The <i style="font-weight: bold"> cat’s </i> basket, The
              <i style="font-weight: bold"> teacher’s </i> bag, The
              <i style="font-weight: bold"> star’s </i> shine
            </li>
          </ul>

          <p>2. For most plural nouns, add only an apostrophe after s:</p>
          <br />
          <p class="examplFnt">Examples:</p>
          <ul class="example">
            <li>
              The <i style="font-weight: bold"> cats’ </i> basket (multiple
              cats) The <i style="font-weight: bold"> teachers’ </i> bags
              (multiple bags) The
              <i style="font-weight: bold"> stars’ </i> shine (multiple stars)
            </li>
          </ul>

          <p>3. For plural nouns that do not end in s, add apostrophe +s:</p>
          <br />
          <p class="examplFnt">Examples:</p>
          <ul class="example">
            <li>
              The <i style="font-weight: bold"> oxen’s </i> horns, the
              <i style="font-weight: bold"> mice’s </i> hidden hole.
            </li>
          </ul>
          <p>4. For singular proper noun that ends in s.</p>
          <p>Some recommend adding only an apostrophe:</p>
          <br />
          <p class="examplFnt">Examples:</p>
          <ul class="example">
            <li>
              <i style="font-weight: bold"> Charles Dickens’ </i> novels,
              <i style="font-weight: bold"> Kansas’ </i>
              main airport
            </li>
          </ul>
          <br />
          <p class="examplFnt">Examples:</p>
          <ul class="example">
            <li>
              <i style="font-weight: bold"> Charles Dickens’ </i> novels,
              <i style="font-weight: bold"> Kansas’ </i>
              main airport
            </li>
          </ul>
          <p>5. Others say to add apostrophe +s:</p>
          <br />
          <p class="examplFnt">Examples:</p>
          <ul class="example">
            <li>
              <i style="font-weight: bold"> Charles Dickens’s </i> novels
              <i style="font-weight: bold"> Kansas’s </i>
              main airport
            </li>
          </ul>

          <p>
            6. Plural proper nouns that end in s only apostrophe is added after
            s:
          </p>
          <br />
          <p class="examplFnt">Examples:</p>
          <ul class="example">
            <li>
              The <i style="font-weight: bold"> Harrises’ </i> house, The
              <i style="font-weight: bold"> Smiths’ </i>
              vacation
            </li>
          </ul>
          <p>
            7. Apostrophes and
            <a class="aTag" href="https://www.grammarin.com/what-are-pronouns">
              Possessive Pronouns</a
            >
          </p>
          <p>Apostrophe is not used with pronouns.</p>
          <p>
            Absolute pronouns such as
            <i style="font-weight: bold"> theirs, yours, hers, ours </i> are
            used without apostrophe.
          </p>
          <br />
          <table id="newone" style="width: 60%">
            <tr style="background-color: #08ba99; color: white">
              <th style="text-align: center">Pronoun</th>
              <th style="text-align: center">Possessive Pronoun</th>
              <th style="text-align: center">Absolute (Independent) Form</th>
            </tr>
            <tr>
              <td>I</td>
              <td>My</td>
              <td>Mine</td>
            </tr>
            <tr>
              <td>You</td>
              <td>Your</td>
              <td>Yours</td>
            </tr>
            <tr>
              <td>He</td>
              <td>His</td>
              <td>His</td>
            </tr>
            <tr>
              <td>She</td>
              <td>Her</td>
              <td>Hers</td>
            </tr>
            <tr>
              <td>It</td>
              <td>Its</td>
              <td>—</td>
            </tr>
            <tr>
              <td>We</td>
              <td>Our</td>
              <td>Ours</td>
            </tr>
            <tr>
              <td>They</td>
              <td>Their</td>
              <td>Theirs</td>
            </tr>
            <tr>
              <td>Who</td>
              <td>Whose</td>
              <td>—</td>
            </tr>
          </table>
        </div>

        <div class="col-12 mt-5">
          <h2 class="update">Apostrophes in Joint Possession</h2>

          <p>
            When one thing belongs to more than one persons, use apostrophe only
            with the final name.
          </p>
          <br />

          <p class="examplFnt">Examples:</p>
          <div class="tips">
            <ul class="example">
              <li>
                Beatrice and
                <i style="font-weight: bold"> Jack’s meat </i> shop (Beatrice
                and Jack co-own the same meat shop)
              </li>
              <li>
                Ronald, Jaseen, and
                <i style="font-weight: bold"> Elan’s project </i> (All three
                share the same project)
              </li>
            </ul>
            <br />
            <p>
              However, if different people possess different things then use
              apostrophe with all names:
            </p>
            <br />
            <p class="examplFnt">Examples:</p>
            <div class="tips">
              <ul class="example">
                <li>
                  <i style="font-weight: bold"> Beatrice’s </i> and
                  <i style="font-weight: bold"> Jack’s </i> meat shops (Beatrice
                  owns one meat shop and Jack owns a different one)
                </li>
              </ul>
              <br />
              <p>
                Ronald’s, Jaseen’s, and Elan’s parents (Each has different
                parents)
              </p>
            </div>
          </div>
        </div>

        <div class="col-12 mt-5">
          <h2 class="update">Apostrophes with Surrounding Punctuation</h2>

          <p>
            An apostrophe should not be separated by any other
            <a class="aTag" href="https://www.grammarin.com/handbook/punctuation"> punctuation</a> mark, such as a
            <a class="aTag" href="https://www.grammarin.com/what-are-parentheses">parenthesis </a> ,
            <a class="aTag" href="https://www.grammarin.com/what-is-a-comma">comma </a> ,<a class="aTag" href="https://www.grammarin.com/what-is-an-ellipsis">ellipsis </a>
             or <a class="aTag" href="https://www.grammarin.com/how-to-do-upside-down-question-mark"> question mark</a> . Because the
            apostrophe is part of the word, with which it is used. You can also
            use our <a class="aTag" href="https://www.grammarin.com/punctuation-checker">punctuation checker </a>  to get rid
            of all these difficulties and fix all your punctuation issues with
            only one click.
          </p>

          <br />
          <p class="examplFnt">Examples:</p>
          <div class="tips">
            <ul class="example">
              <li>
                Can I ask you <i style="font-weight: bold"> somethin’? </i>
              </li>
              <li>
                <i style="font-weight: bold"> “’Twas </i> the night before
                Christmas,” he said.
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

<!--end apostrophe-->
<!--colon-->
<div class="mb-5" *ngIf="section === 'what-is-a-colon'">
  <div class="container-fluid hero-Adjectives">
    <app-header></app-header>

    <div class="container modify-container">
      <div class="row">
        <div class="col-12 head-top">
          <nav aria-label="breadcrumb" class="mb-1">
            <ol class="breadcrumb">
              <li class="breadcrumb-item">
                <a [routerLink]="['/']">Home</a>
              </li>
              <li class="breadcrumb-item">
                <a [routerLink]="['/handbook']">Handbook</a>
              </li>
              <li class="breadcrumb-item">
                <a [routerLink]="['/handbook/punctuation']">Punctuation</a>
              </li>
              <li class="breadcrumb-item activebread">
                <a [routerLink]="['/what-is-a-colon']">What Is a Colon</a>
              </li>
            </ol>
          </nav>
          <h1 class="mb-2 heading">What Is a Colon</h1>
          <p class="py-3 head-details">
            A colon is used in a sentence to further demonstrate or exemplify
            the information. Colon is a silent message of “as follows,” “which
            is/are,” or “thus”.
          </p>
        </div>
      </div>
    </div>
  </div>
  <div class="container-fluid">
    <div class="container">
      <div class="row justify-content-center">
        <div class="col-12">
          <p class="examplFnt">Examples:</p>
          <div class="tips">
            <ul class="example">
              <li>
                There are five human senses: hear, touch, see, smell, taste
              </li>
            </ul>
          </div>
          <br />
          <p>Colon can also be used for further clarification:</p>
          <p class="examplFnt">Examples:</p>
          <div class="tips">
            <ul class="example">
              <li>
                We have two options here: stay and fight, or run like the wind.
              </li>
            </ul>
          </div>
          <br />
          <p>Colon can also introduce a quotation:</p>
          <p class="examplFnt">Examples:</p>
          <div class="tips">
            <ul class="example">
              <li>
                The host made an announcement: "You are all staying for dinner."
              </li>
            </ul>
          </div>
        </div>
        <div class="col-12 mt-5">
          <h2 class="update">Capitalization after Colon</h2>

          <p>
            A capital letter generally does not introduce a word, phrase, or
            incomplete sentence following a colon.
          </p>

          <br />

          <p class="examplFnt">Examples:</p>
          <div class="tips">
            <ul class="example">
              <li>
                He got what he worked for:
                <i style="font-weight: bold"> a </i> promotion
              </li>
            </ul>
          </div>
        </div>
        <div class="col-12 mt-5">
          <h2 class="update">Misuse of Colon</h2>
          <p>
            Avoid using a colon before a list if it directly follows a verb or
            preposition that would ordinarily need no punctuation in that
            sentence.
          </p>

          <ul class="example">
            <li>
              I want: butter, sugar, and flour.
              <i style="font-weight: bold"> (Wrong) </i>
            </li>
            <li>
              I want butter, sugar, and flour.<i style="font-weight: bold">
                (Correct)
              </i>
            </li>
            <li>
              During my next vacation, I want to travel to: Sri Lanka, Maldives,
              and Goa. <i style="font-weight: bold"> (Wrong) </i>
            </li>
            <li>
              During my next vacation, I want to travel to Sri Lanka, Maldives,
              and Goa. <i style="font-weight: bold"> (Correct) </i>
            </li>
          </ul>
          <p>
            Always Remember! A colon should not separate a noun from its verb, a
            verb from its object or subject complement, a preposition from its
            object, or a subject from its predicate.
          </p>
        </div>
      </div>
    </div>
  </div>
</div>
<!--end colon-->
<!--ellipsis-->
<div class="mb-5" *ngIf="section === 'what-is-an-ellipsis'">
  <div class="container-fluid hero-Adjectives">
    <app-header></app-header>

    <div class="container modify-container">
      <div class="row">
        <div class="col-12 head-top">
          <nav aria-label="breadcrumb" class="mb-1">
            <ol class="breadcrumb">
              <li class="breadcrumb-item">
                <a [routerLink]="['/']">Home</a>
              </li>
              <li class="breadcrumb-item">
                <a [routerLink]="['/handbook']">Handbook</a>
              </li>
              <li class="breadcrumb-item">
                <a [routerLink]="['/handbook/punctuation']">Punctuation</a>
              </li>
              <li class="breadcrumb-item activebread">
                <a [routerLink]="['/what-is-an-ellipsis']"
                  >What Is an Ellipsis</a
                >
              </li>
            </ol>
          </nav>
          <h1 class="mb-2 heading">What Is an Ellipsis (…)</h1>
          <p class="py-3 head-details">
            Three little dots (…) are called an ellipsis (plural: ellipses). The
            term ellipsis comes from the Greek word meaning “omission,” and that
            is just what an ellipsis does. It shows that something has been left
            out.
          </p>
        </div>
      </div>
    </div>
  </div>
  <div class="container-fluid">
    <div class="container">
      <div class="row justify-content-center">
        <div class="col-12">
          <h2>1. Omitted words</h2>
          <p>
            When quoting someone, an ellipsis is used to show that some of the
            words are omitted from the conversation.
          </p>
          <br />
          <p class="examplFnt">Examples:</p>
          <div class="tips">
            <ul class="example">
              <li>
                It must be obvious,
                <i style="font-weight: bold"> from the very start, </i> that
                there is a contradiction in wanting to be perfectly secure in a
                universe whose very nature is momentariness and fluidity.
                <i style="font-weight: bold"> (ORIGINAL QUOTE) </i>
              </li>
              <li>
                It must be obvious (. . .)that there is a contradiction in
                wanting to be perfectly secure in a universe whose very nature
                is momentariness and fluidity.
                <i style="font-weight: bold"> (QUOTE WITH AN ELLIPSIS)</i>
              </li>
            </ul>

            <br />
            <p>
              When using an ellipsis to omit part of a quote, choose your spot
              carefully to ensure the remaining sentence remains grammatically
              correct. For instance, omitting text between two commas keeps the
              sentence intact.
            </p>
          </div>
          <br />

          <h2>2. Trailing off into silence</h2>
          <p>
            When quoting someone, an ellipsis is used to show that some of the
            words are omitted from the conversation.
          </p>
          <br />
          <p class="examplFnt">Examples:</p>

          <ul class="example">
            <li>
              Andrew, can you, um . . . never mind, I forgot what I was saying.
              So, do you think we should...?
            </li>
          </ul>
          <br />
          <h2>3. Pause for Dramatic Effect or Suspense</h2>
          <p>
            An ellipsis is used to create a deliberate pause before an important
            revelation, statement, or event. This technique builds anticipation,
            heightens curiosity, or emphasizes the gravity of what comes next.
          </p>
          <br />
          <p class="examplFnt">Examples:</p>
          <br />
          <ul class="example">
            <li>
              He unlocked the ancient chest, holding his breath, and inside he
              found . . . a map to a hidden treasure.<i
                style="font-weight: bold"
              >
                (Suspense)
              </i>
            </li>
            <li>
              And the winner is . . . Maria Lopez!<i style="font-weight: bold">
                (Dramatic Effect)
              </i>
            </li>
          </ul>

          <br />
          <h2>How Many Dots in an Ellipsis?</h2>
          <p>
            Ellipsis is formed by three dots(…). However, the number of dots can
            vary based on their position in a sentence and its surrounding
            punctuation. Here's how to use ellipses correctly in different
            contexts:
          </p>
          <br />
          <h2>1. Standard Ellipsis (Three Dots)</h2>
          <p>
            An ellipsis is formed with
            <i style="font-weight: bold"> exactly three dots </i> when it
            appears in the middle of an incomplete sentence or a quotation.
          </p>
          <br />
          <p class="examplFnt">Examples:</p>
          <br />
          <ul class="example">
            <li>To be, or not to be . . . that is the question.</li>
          </ul>

          <br />
          <h2>2. Ellipsis After a Complete Sentence (Four Dots)</h2>
          <p>
            If the ellipsis comes immediately after a grammatically complete
            sentence, that sentence still needs its own period. So, you would
            end up with a period, plus an ellipsis, which looks like four dots
            in a row.
          </p>
          <br />
          <p class="examplFnt">Examples:</p>
          <br />
          <ul class="example">
            <li>
              Call me Jonah. My parents did, or nearly did. They called me
              John.<i style="font-weight: bold"> (Original) </i>
            </li>
            <li>
              Call me Jonah. . . . They called me John.<i
                style="font-weight: bold"
              >
                (Shortened)
              </i>
            </li>
          </ul>
        </div>
      </div>
    </div>
  </div>
</div>
<!--end ellipsis-->

<!--mark-->
<div class="mb-5" *ngIf="section === 'what-does-exclamation-mark-mean'">
  <div class="container-fluid hero-long">
    <app-header></app-header>

    <div class="container modify-container">
      <div class="row">
        <div class="col-12 head-top">
          <nav aria-label="breadcrumb" class="mb-1">
            <ol class="breadcrumb">
              <li class="breadcrumb-item">
                <a [routerLink]="['/']">Home</a>
              </li>
              <li class="breadcrumb-item">
                <a [routerLink]="['/handbook']">Handbook</a>
              </li>
              <li class="breadcrumb-item">
                <a [routerLink]="['/handbook/punctuation']">Punctuation</a>
              </li>
              <li class="breadcrumb-item activebread">
                <a [routerLink]="['/what-does-exclamation-mark-mean']"
                  >What Is an Exclamation Mark</a
                >
              </li>
            </ol>
          </nav>
          <h1 class="mb-2 heading">What Is an Exclamation Mark (!)?</h1>
          <p class="py-3 head-details">
            Period (.) goes at the end of declarative sentences; question mark
            (?) goes at the end of interrogative sentences; and exclamation mark
            (!) goes at the end of exclamatory sentences. An exclamatory
            sentence is one that expresses a strong or forceful emotion, such as
            anger, surprise, or joy. In short, exclamation mark is used to
            convey emotion and intent that can be expressed through the tone if
            spoken. However, it should not be used in formal and business
            writing; rather vivid vocabulary should be used to express emotions.
          </p>
        </div>
      </div>
    </div>
  </div>
  <div class="container-fluid">
    <div class="container">
      <div class="row justify-content-center">
        <div class="col-12">
          <p class="examplFnt">Examples:</p>
          <div class="tips">
            <ul class="example">
              <li>What a car you have!</li>
              <li>Get out of my sight!</li>
              <li>How rude!</li>
              <li>Careful! That spider is poisonous.</li>
            </ul>
            <p>
              Put the exclamation mark inside the closing quotation marks and
              parenthesis, if it applies to the words enclosed by the quotation
              marks and parenthesis.
            </p>
          </div>
          <br />
          <p class="examplFnt">Examples:</p>
          <div class="tips">
            <ul class="example">
              <li>“There’s a cockroach on my leg!” cried Janet.</li>
              <li>
                Janet didn’t find out until later what kind of creepy insect it
                was (a big cockroach!).
              </li>

              <li>
                If the exclamation point applies to the sentence as a whole,
                then place it at the very end.
              </li>
            </ul>
          </div>
          <br />
          <p class="examplFnt">Examples:</p>
          <div class="tips">
            <ul class="example">
              <li>
                And then mother tried to tell Janet it was “only a cockroach”!
              </li>
              <li>His prayers answered and he won the lottery (now)!</li>
            </ul>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
<!--end mark-->

<!--parentheses-->
<div class="mb-5" *ngIf="section === 'what-are-parentheses'">
  <div class="container-fluid hero-Adjectives">
    <app-header></app-header>

    <div class="container modify-container">
      <div class="row">
        <div class="col-12 head-top">
          <nav aria-label="breadcrumb" class="mb-1">
            <ol class="breadcrumb">
              <li class="breadcrumb-item">
                <a [routerLink]="['/']">Home</a>
              </li>
              <li class="breadcrumb-item">
                <a [routerLink]="['/handbook']">Handbook</a>
              </li>
              <li class="breadcrumb-item">
                <a [routerLink]="['/handbook/punctuation']">Punctuation</a>
              </li>
              <li class="breadcrumb-item activebread">
                <a [routerLink]="['/what-are-parentheses']"
                  >What are Parentheses</a
                >
              </li>
            </ol>
          </nav>
          <h1 class="mb-2 heading">What are Parentheses ()</h1>
          <p class="py-3 head-details">
            Parentheses are punctuation marks that are used to set off
            information within a text or paragraph. Parentheses always come in
            pairs. They can enclose a single word, a phrase, or even an entire
            sentence. Usually, the words inside the parentheses provide extra
            information about something else in the sentence.
          </p>
        </div>
      </div>
    </div>
  </div>
  <div class="container-fluid">
    <div class="container">
      <div class="row justify-content-center">
        <div class="col-12">
          <p class="examplFnt">Examples:</p>
          <div class="tips">
            <ul class="example">
              <li>
                Curators from the American Museum of Natural History (AMNH) have
                announced a new dinosaur exhibit. While walking down the street
                (paying more attention to her phone than to her feet), Leila
                bumped into the police officer and was embarrassed.
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
<!--end parentheses-->
<!--periods-->
<div class="mb-5" *ngIf="section === 'what-is-a-period'">
  <div class="container-fluid hero-short">
    <app-header></app-header>

    <div class="container modify-container">
      <div class="row">
        <div class="col-12 head-top">
          <nav aria-label="breadcrumb" class="mb-1">
            <ol class="breadcrumb">
              <li class="breadcrumb-item">
                <a [routerLink]="['/']">Home</a>
              </li>
              <li class="breadcrumb-item">
                <a [routerLink]="['/handbook']">Handbook</a>
              </li>
              <li class="breadcrumb-item">
                <a [routerLink]="['/handbook/punctuation']">Punctuation</a>
              </li>
              <li class="breadcrumb-item activebread">
                <a [routerLink]="['/what-is-a-period']">What Is a Period</a>
              </li>
            </ol>
          </nav>
          <h1 class="mb-2 heading">What Is a Period (.)</h1>
          <p class="py-3 head-details">
            The most common use of the period is to end a declarative sentence.
          </p>
        </div>
      </div>
    </div>
  </div>
  <div class="container-fluid">
    <div class="container">
      <div class="row justify-content-center">
        <div class="col-12">
          <p class="examplFnt">Examples:</p>
          <div class="tips">
            <ul class="example">
              <li>I am a doctor. I live in Africa.</li>
              <li>
                Period is placed inside the quotation mark if it is at the end
                of sentence.
              </li>
            </ul>
          </div>
          <br />
          <p class="examplFnt">Examples:</p>
          <div class="tips">
            <ul class="example">
              <li>
                My mother loved to remind me of the old saying
                <i style="font-weight: bold"> “waste not, want not.” </i>
              </li>
              <li>
                Phillip said, “I can’t remember where I heard about the banjo
                concert, but I surely want to go.”
              </li>
            </ul>
          </div>
        </div>

        <div class="col-12 mt-5">
          <h2 class="update">Periods and Parentheses?</h2>
          <p>
            When a complete, independent sentence is entirely enclosed by
            parentheses, the period goes inside the closing parenthesis.
          </p>
          <br />
          <p class="examplFnt">Examples:</p>
          <div class="tips">
            <ul class="example">
              <li>
                Charlie scarfed up every Cheeto that fell out of the bag.
                <i style="font-weight: bold">
                  (I was not fast enough to stop him.)
                </i>
                At least we won’t have to sweep the floor.
              </li>
            </ul>
          </div>
          <br />
          <p>
            However, if the parenthetical material is nested inside another
            sentence, the period should go on the outside.
          </p>

          <br />
          <div class="tips">
            <ul class="example">
              <li>
                Charlie barked wildly when he caught the scent of fresh meat
                <i style="font-weight: bold"> (his favourite). </i>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
<!--end period-->
<!--what-is-brackets   -->
<div class="mb-5" *ngIf="section === 'what-is-brackets'">
  <div class="container-fluid hero-short">
    <app-header></app-header>

    <div class="container modify-container">
      <div class="row">
        <div class="col-12 head-top">
          <nav aria-label="breadcrumb" class="mb-1">
            <ol class="breadcrumb">
              <li class="breadcrumb-item">
                <a [routerLink]="['/']">Home</a>
              </li>
              <li class="breadcrumb-item">
                <a [routerLink]="['/handbook']">Handbook</a>
              </li>
              <li class="breadcrumb-item">
                <a [routerLink]="['/handbook/punctuation']">Punctuation</a>
              </li>
              <li class="breadcrumb-item activebread">
                <a [routerLink]="['/what-is-a-period']">What Is Brackets</a>
              </li>
            </ol>
          </nav>
          <h1 class="mb-2 heading">What Is Brackets []</h1>
          <p class="py-3 head-details">
            Sometimes called square brackets, are most often used to show that
            words have been added to a direct quotation.
          </p>
        </div>
      </div>
    </div>
  </div>
  <div class="container-fluid">
    <div class="container">
      <div class="row justify-content-center">
        <div class="col-12">
          <p>
            Sometimes, when quoting a person or document, adding a word or two
            is necessary to provide enough context for the quote to make sense.
          </p>
          <br />
          <p class="examplFnt">Examples:</p>
          <div class="tips">
            <ul class="example">
              <li>“We went and had a great time.”</li>
            </ul>
          </div>
          <br />
          <p>To add further information to the above it can be written as:</p>
          <br />
          <p class="examplFnt">Examples:</p>
          <div class="tips">
            <ul class="example">
              <li>
                “We went
                <i style="font-weight: bold">[to the new motor exhibition] </i>
                and had a great time.”
              </li>
            </ul>
          </div>
        </div>

        <div class="col-12 mt-5">
          <h2 class="update">
            Parentheses or Brackets with Surrounding Punctuation:
          </h2>
          <p>
            Periods, question marks, and exclamation points should be paced in
            the parenthesis or bracket only if they belong to the words inside
            the parentheses or brackets. If the punctuation belongs to the
            surrounding sentence, put them outside the parentheses or brackets.
          </p>
          <br />
          <p>Never put a comma immediately before a closing parenthesis</p>
          <br />
          <p class="examplFnt">Examples:</p>
          <div class="tips">
            <ul class="example">
              <li>
                After dinner (an enormous, healthy desert,) Posey treated
                herself to ice cream.
                <i style="font-weight: bold"> (Wrong) </i>
              </li>
              <li>
                After dinner, (an enormous, healthy desert) Posey treated
                herself to ice cream.
                <i style="font-weight: bold"> (Wrong) </i>
              </li>
              <li>
                After dinner (an enormous, healthy desert), Posey treated
                herself to ice cream.
                <i style="font-weight: bold"> (Correct) </i>
              </li>
            </ul>
          </div>
          <br />
        </div>
      </div>
    </div>
  </div>
</div>
<!--what-is-brackets   -->
<!--dash-->
<div class="mb-5" *ngIf="section === 'what-are-dashes'">
  <div class="container-fluid hero-Adjectives">
    <app-header></app-header>

    <div class="container modify-container">
      <div class="row">
        <div class="col-12 head-top">
          <nav aria-label="breadcrumb" class="mb-1">
            <ol class="breadcrumb">
              <li class="breadcrumb-item">
                <a [routerLink]="['/']">Home</a>
              </li>
              <li class="breadcrumb-item">
                <a [routerLink]="['/handbook']">Handbook</a>
              </li>
              <li class="breadcrumb-item">
                <a [routerLink]="['/handbook/punctuation']">Punctuation</a>
              </li>
              <li class="breadcrumb-item activebread">
                <a [routerLink]="['/what-are-dashes']">What Are Dashes</a>
              </li>
            </ol>
          </nav>
          <h1 class="mb-2 heading">What Are Dashes (-, _, ─)</h1>
          <p class="py-3 head-details">
            A dash is a little horizontal line that is placed in the middle of a
            line of text (not at the bottom: that is an underscore). Dashes are
            used to separate groups of words, not to separate parts of words
            like those that a hyphen does.
          </p>
        </div>
      </div>
    </div>
  </div>
  <div class="container-fluid">
    <div class="container">
      <div class="row justify-content-center">
        <div class="col-12">
          <p>
            There are three forms of dashes:
            <i style="font-weight: bold"> em, en, </i> and the
            <i style="font-weight: bold"> double hyphen. </i>
          </p>
          <p>
            The most common types of dashes are the
            <i style="font-weight: bold"> en dash (–) </i> and the
            <i style="font-weight: bold"> em dash (—). </i> A good way to
            remember the difference between these two dashes is to visualize the
            en dash as the length of the letter N and the em dash as the length
            of the letter M. These dashes not only differ in length; they also
            serve different functions within a sentence.
          </p>
        </div>

        <div class="col-12 mt-5">
          <h2 class="update">Em Dashes (—)</h2>
          <p>
            The <i style="font-weight: bold"> em dash (—) </i> sets off a word
            or clause and adds emphasis. Or, it can signal an interruption or
            amplification of an idea. It is also the longest of the dashes
            (e.g., hyphen, en dash).
          </p>
          <br />
          <h2>1. In place of a comma (,)</h2>

          <p>
            Many writers have adapted the em dash to suit their own purposes.
            James Joyce—rebel that he was—used the em dash (rather than
            quotation marks) throughout Ulysses. Emily Dickinson used em dashes
            (rather than commas) in most of her poetry. These uses are mainly
            personal style choices.
          </p>
          <p>
            A set of em dashes can enclose information that would otherwise be
            set off by commas. They can subtly change the sentence’s meaning.
          </p>
          <br />
          <p class="examplFnt">Examples:</p>
          <div class="tips">
            <ul class="example">
              <li>
                You are the friend, the only friend, who came to my party.
                <i style="font-weight: bold"> (Without em dash) </i>
              </li>
              <li>
                You are the friend—the only friend—who came to my party.
                <i style="font-weight: bold"> (Comma replaced by em dash) </i>
              </li>
            </ul>
          </div>
          <br />
          <h2>2. In Place of Ellipsis (…)</h2>
          <p>
            em dash replace ellipsis to create a tone and style writer wished to
            achieve in their writing.
          </p>
          <br />
          <p class="examplFnt">Examples:</p>
          <div class="tips">
            <ul class="example">
              <li>
                Can you call me back … oh, never mind?
                <i style="font-weight: bold"> (Without em dash) </i>
              </li>
              <li>
                Can you call me back—oh, never mind.
                <i style="font-weight: bold">
                  (Ellipsis replaced by em dash)
                </i>
              </li>
            </ul>
          </div>
          <br />
          <h2>3. In place of semicolon (;)</h2>
          <p>
            The em dash can join two independent clauses in place of a
            semicolon. It provides a more casual tone and look.
          </p>
          <br />
          <p class="examplFnt">Examples:</p>
          <div class="tips">
            <ul class="example">
              <li>
                An example from The Adventures of Huckleberry Finn: “Well,
                nobody could think of anything to do—everybody was stumped, and
                set still.”
              </li>
              <li>
                It is too early to go to the laundromat; they open at 8 am.
                <i style="font-weight: bold"> (With semi colon) </i>
              </li>
              <li>
                It is too early to go to the laundromat—they open at 8 am.
                <i style="font-weight: bold">
                  (Semi colon replaced by em dash)
                </i>
              </li>
              <li>
                The boys want to visit the zoo; Amelia wants to go bowling.
                <i style="font-weight: bold"> (With semi colon) </i>
              </li>
              <li>
                The boys want to visit the zoo— Amelia wants to go bowling.
                <i style="font-weight: bold">
                  (Semi colon replaced by em dash)
                </i>
              </li>
            </ul>
          </div>
          <br />
          <h2>4. In place of colon (:)</h2>
          <p>
            It can also replace a colon when introducing phrases, clauses, or
            examples. This can either soften the sentence or add colour.
          </p>
          <br />
          <p class="examplFnt">Examples:</p>
          <div class="tips">
            <ul class="example">
              <li>
                An example from The Tragedy of Pudd’nhead Wilson: “Each person
                is born to one possession which out-values all his others—his
                last breath.”
              </li>
              <li>
                Hector knows exactly where he wants to go for lunch: the new
                Greek restaurant! <i style="font-weight: bold"> (Colon) </i>
              </li>
              <li>
                Hector knows exactly where he wants to go for lunch—the new
                Greek restaurant!
                <i style="font-weight: bold"> (Colon replaced with em dash) </i>
              </li>
              <li>
                I have been waiting my whole life for this moment: I am
                graduating from medical school.
                <i style="font-weight: bold"> (Colon) </i>
              </li>
              <li>
                I have been waiting my whole life for this moment—I am
                graduating from medical school.
                <i style="font-weight: bold"> (Colon replaced with em dash) </i>
              </li>
            </ul>
          </div>
          <br />
          <h2>5. In place of parentheses ( )</h2>
          <p>
            Em dashes are also used as interrupters in sentences, mostly in
            blogs and digital content. This adds a casual and conversational
            tone that readers enjoy, especially when reading online. You can use
            em dashes to insert commentary on what is written, to add a small
            joke or witty comment, or to add an example to make what is written
            more relatable.
          </p>
          <br />
          <p class="examplFnt">Examples:</p>
          <div class="tips">
            <ul class="example">
              <li>
                I’d never been to a farm before—well, unless you count my
                cousin’s backyard chicken coop, which I certainly don’t—and I
                was excited to learn more about the care of the animals.
              </li>
              <li>
                Jasmine left the store without buying anything—she’d be back one
                day, after she was a famous songwriter, and would buy the most
                expensive guitar they had—and took the subway home.
              </li>
            </ul>
          </div>
        </div>

        <div class="col-12 mt-5">
          <h2 class="update">En Dashes</h2>
          <p>
            En dashes are slightly shorter in length than em dashes. En dashes
            may look similar to em dashes, but they function in a much different
            way.
          </p>
          <br />
          <h2>1. En Dash Indicates Spans of Time or Ranges of Numbers</h2>

          <p>
            The en dash is often used to indicate spans of time or ranges of
            numbers. In this context, the dash should be interpreted as meaning
            either “to” or “through.”
          </p>

          <br />
          <p class="examplFnt">Examples:</p>
          <div class="tips">
            <ul class="example">
              <li>
                The teacher assigned pages
                <i style="font-weight: bold"> 101–181 </i> for tonight’s reading
                material.
              </li>
              <li>
                The scheduled window for the cable installation is
                <i style="font-weight: bold"> 1:00–3:00pm. </i>
              </li>
              <li>
                The <i style="font-weight: bold"> 2015–2016 </i> fiscal year was
                the most profitable year for the new business.
              </li>
            </ul>
          </div>
          <br />
          <h2>2. Using the En Dash to Denote a Connection</h2>
          <p>
            The en dash may also be used to indicate a connection between two
            words. Use an en dash when you need to connect terms that are
            already hyphenated or when you are using a two-word phrase as a
            modifier. When the dash is used in this way, it creates a compound
            adjective.
          </p>
          <br />
          <p class="examplFnt">Examples:</p>
          <div class="tips">
            <ul class="example">
              <li>
                The
                <i style="font-weight: bold"> pro-choice–pro-life </i>
                argument is always a heated one.
              </li>
              <li>
                The
                <i style="font-weight: bold"> Nobel Prize–winning </i> author
                will be reading from her book at the library tonight.
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>
  </div>

  <br />
  <div class="container-fluid">
    <div class="container">
      <div class="row justify-content-center">
        <div class="col-12">
          <h2>Hyphen (-)</h2>
          <p>
            A hyphen (-) is a punctuation mark that is used to join words or
            parts of words. It is not interchangeable with other types of
            dashes.
          </p>
          <br />
          <h2 class="mb-3">1. Hyphen with Compound Modifiers:</h2>
          <p>
            Use a hyphen in a compound modifier when the modifier comes before
            the word it’s modifying.
          </p>
          <br />
          <br />
          <h2>Two-Word Adjectives Before Nouns:</h2>

          <p>
            A compound modifier is made up of two words that work together to
            function like one adjective. Generally, the hyphen is placed only if
            the two words are functioning together as an adjective before the
            noun they are describing. If the noun comes first, leave the hyphen
            out.
          </p>

          <br />
          <p class="examplFnt">Examples:</p>
          <div class="tips">
            <ul class="example">
              <li>
                Visit to Amazon forest is a
                <i style="font-weight: bold"> never-to-be-forgotten </i>
                experience. <i style="font-weight: bold"> (Correct) </i>
              </li>
              <li>
                Visit to Amazon forest experience is
                <i style="font-weight: bold">
                  never to be forgotten. (Wrong)
                </i>
              </li>
              <li>
                We prefer a <i style="font-weight: bold">pet-friendly</i> hotel
                to stay.
                <i style="font-weight: bold"> (Correct) </i>
              </li>
              <li>
                Is this hotel
                <i style="font-weight: bold"> pet friendly? (Wrong) </i>
              </li>
            </ul>
          </div>
          <br />
          <h2 class="update">Two-Word Adverb and Adjective</h2>
          <p>
            A hyphen is not used when modifier is made up of an adverb and an
            adjective.
          </p>
          <br />
          <p class="examplFnt">Examples:</p>
          <div class="tips">
            <ul class="example">
              <li>
                I do not trust this clearly-unbelievable story.
                <i style="font-weight: bold"> (Wrong) </i>
              </li>
              <li>
                I do not trust this clearly unbelievable story.
                <i style="font-weight: bold"> (Correct) </i>
              </li>
            </ul>
          </div>
          <br />
          <p>
            Don’t use a hyphen when you are combining an adverb and a
            participle.
          </p>
          <br />

          <p class="examplFnt">Examples:</p>
          <div class="tips">
            <ul class="example">
              <li>
                The room was like a heavily-decorated chocolate box.
                <i style="font-weight: bold"> (Wrong) </i>
              </li>
              <li>
                The room was like a heavily decorated chocolate box.
                <i style="font-weight: bold"> (Correct) </i>
              </li>
            </ul>
          </div>
          <br />
          <br />
          <h2 class="update">
            Two-Word Compound Modifier with Present And Past Participle
          </h2>
          <p>
            Compound modifiers that include present or past participles follow
            the same rules as any other compound modifier.
          </p>
          <br />
          <p class="examplFnt">Examples:</p>
          <div class="tips">
            <ul class="example">
              <li>
                He is <i style="font-weight: bold"> self-taught </i> driver.
              </li>
              <li>
                She is <i style="font-weight: bold"> self-made </i> woman.
              </li>
              <li>
                There are some
                <i style="font-weight: bold"> beautiful-looking </i> flowers in
                the garden.
              </li>
              <li>
                <i style="font-weight: bold">Fast-acting</i> medication can be
                useful when one has a headache.
              </li>
            </ul>
          </div>
        </div>

        <div class="col-12 mt-5">
          <h2 class="update">Hyphenated Compound Words</h2>
          <p>
            Hyphenated compound words are the ones (obviously) with a hyphen
            between the words. Over time, many hyphenated compounds become
            closed compounds—teen-ager became teenager Here are a few examples
            of common hyphenated compound words:
          </p>
          <br />
          <p class="examplFnt">Examples:</p>
          <div class="tips">
            <ul class="example">
              <li>Mother-in-law</li>
              <li>Master-at-arms</li>
              <li>Editor-in-chief</li>
              <li>Ten-year-old</li>
              <li>Factory-made</li>
              <li>Twelve-pack</li>
            </ul>
          </div>
        </div>

        <div class="col-12 mt-5">
          <h2 class="update">Closed Compound Words</h2>
          <p>
            Hyphenated words tend to become closed compounds (single words with
            no hyphens) over time. Email instead of e-mail, for example, is
            increasingly common.
          </p>
          <br />
          <p class="examplFnt">Examples:</p>
          <div class="tips">
            <ul class="example">
              <li>Notebook</li>
              <li>Superman</li>
              <li>Waistcoat</li>
              <li>Bookstore</li>
              <li>Fireman</li>
            </ul>
          </div>
        </div>

        <div class="col-12 mt-5">
          <h2 class="update">Open Compound Words</h2>
          <p>
            Open compounds are typically made up of two nouns that are used
            together to represent a single idea. “Open” means that there is a
            space between the two words and no hyphen. A good dictionary is the
            best place to check whether a compound is open or not.
          </p>
          <br />
          <p class="examplFnt">Examples:</p>
          <div class="tips">
            <ul class="example">
              <li>Living room</li>
              <li>Real estate</li>
              <li>Dinner table</li>
              <li>Coffee mug</li>
            </ul>
          </div>
        </div>

        <div class="col-12 mt-5">
          <h2 class="update">Hyphens and Numbers</h2>
          <p>
            Numbers between twenty-one and ninety-nine should be hyphenated when
            they’re spelled out.
            <br />
          </p>
          <p class="examplFnt">Examples:</p>
          <div class="tips">
            <ul class="example">
              <li>
                <i style="font-weight: bold"> Thirty-six </i> shades in palette.
              </li>
              <li>
                A hundred and
                <i style="font-weight: bold"> twenty-four </i> pair of shoes.
              </li>
            </ul>
          </div>
        </div>

        <div class="col-12 mt-5">
          <h2 class="update">Hyphen in Compound Adjective with Numbers</h2>
          <p>
            When numbers are used as the first part of a compound adjective, use
            a hyphen to connect them to the noun that follows them. The reader
            knows that both words function like a unit to modify another noun,
            in this way. This applies whether the number is written in words or
            in digits.
          </p>
          <br />
          <p class="examplFnt">Examples:</p>
          <div class="tips">
            <ul class="example">
              <li>
                The president of the company gave a
                <i style="font-weight: bold"> 10-minute </i> speech to the
                employees.
              </li>
              <li>
                He is knowledgeable in
                <i style="font-weight: bold"> thirteenth-century </i>
                politics.
              </li>
              <li>
                The boy threw a stone at the
                <i style="font-weight: bold"> second-storey </i> window.
              </li>
            </ul>
          </div>
          <br />
          <p>
            However, a hyphen is not required if the number is the second word
            in the compound adjective.
          </p>
          <br />
          <p class="examplFnt">Examples:</p>
          <div class="tips">
            <ul class="example">
              <li>
                He is a victim of
                <i style="font-weight: bold"> Type 2 </i> diabetes.
              </li>
              <li>
                This elevator does not go down to
                <i style="font-weight: bold"> Basement 3.</i>
              </li>
            </ul>
          </div>
        </div>

        <div class="col-12 mt-5">
          <h2 class="update">Hyphen in Compound Adjective with Fractions</h2>
          <p>
            When using a fraction (e.g. half or quarter) as part of a compound
            adjective, it should be hyphenated so the reader understands which
            fraction is modifying which noun.
          </p>
          <br />
          <p class="examplFnt">Examples:</p>
          <div class="tips">
            <ul class="example">
              <li>
                A <i style="font-weight: bold"> quarter-million </i> dollars is
                not a large amount of money indeed.
              </li>
              <li>
                You will need <i style="font-weight: bold"> one-third </i> of a
                cup of flour and an egg.
              </li>
              <li>
                That is a <i style="font-weight: bold"> half-baked </i> pizza if
                I ever seen one!
              </li>
            </ul>
          </div>
        </div>

        <div class="col-12 mt-5">
          <h2 class="update">Hyphen with Prefixes: Ex-, Self-, All-.</h2>
          <p>Use a hyphen with the prefix ex- (meaning former).</p>
          <br />
          <p class="examplFnt">Examples:</p>
          <div class="tips">
            <ul class="example">
              <li>
                Adam is Cloe’s
                <i style="font-weight: bold"> ex-president. </i>
              </li>
              <li>
                <i style="font-weight: bold"> Ex-mayor </i> still attends
                council meetings.
              </li>
            </ul>
          </div>
          <br />
          <p>Use a hyphen with the reflexive prefix self-.</p>
          <br />
          <p class="examplFnt">Examples:</p>
          <div class="tips">
            <ul class="example">
              <li>
                They are <i style="font-weight: bold"> self-sufficient </i> in
                daily supplies.
              </li>
              <li>
                The cat looked extremely
                <i style="font-weight: bold"> self-satisfied. </i>
              </li>
            </ul>
          </div>
          <br />
          <p>
            Make sure you don’t confuse the prefix self- with the noun self.
          </p>
          <br />
          <p class="examplFnt">Examples:</p>
          <div class="tips">
            <ul class="example">
              <li>
                The <i style="font-weight: bold"> self </i> serves no other.
              </li>
            </ul>
          </div>
          <br />
          <p>When using all as a prefix, add a hyphen.</p>
          <br />
          <p class="examplFnt">Examples:</p>
          <div class="tips">
            <ul class="example">
              <li>
                A bad leader thinks of himself as
                <i style="font-weight: bold"> all-powerful. </i>
              </li>
            </ul>
          </div>
        </div>

        <div class="col-12 mt-5">
          <h2 class="update">Hyphens with High or Low</h2>
          <p>
            When using high or low as part of a compound adjective, use a hyphen
            when the compound comes before the noun it’s modifying.
          </p>
          <br />
          <p class="examplFnt">Examples:</p>
          <div class="tips">
            <ul class="example">
              <li>
                <i style="font-weight: bold"> High-level/low-level </i>
              </li>
              <li>
                <i style="font-weight: bold"> High-impact/low-impact </i>
              </li>
              <li>
                <i style="font-weight: bold">Low-flying </i> airplanes
                contribute to the noise pollution in the area.
              </li>
              <li>
                This car runs best on
                <i style="font-weight: bold"> high-octane </i> gasoline.
              </li>
              <li>
                <i style="font-weight: bold">Low-income </i> families often face
                more hardships than their
                <i style="font-weight: bold"> higher-income </i> counterparts.
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
<!--end dash-->
<!--hyphen-->
<!-- <div class="mb-5" *ngIf="section === 'what-is-hyphen'">
  <div class="container-fluid hero-Adjectives">
    <app-header></app-header>

    <div class="container modify-container">
      <div class="row">
        <div class="col-12 head-top">
          <nav aria-label="breadcrumb" class="mb-1">
            <ol class="breadcrumb">
              <li class="breadcrumb-item">
                <a [routerLink]="['/']">Home</a>
              </li>
              <li class="breadcrumb-item ">
                <a [routerLink]="['/handbook']">Handbook</a>
              </li>
              <li class="breadcrumb-item">
                <a [routerLink]="['/handbook/punctuation']">Punctuation</a>
              </li>
              <li class="breadcrumb-item activebread">
                <a [routerLink]="['/what-is-hyphen']">What Is Hyphen</a>
              </li>
            </ol>
          </nav>
          <h1 class="mb-2 heading"> What Is Hyphen (-)</h1>
          <p class="py-3 head-details">
            A hyphen (-) is a punctuation mark that is used to join words or
            parts of words. It is not interchangeable with other types of
            dashes.
          </p>
        </div>
      </div>
    </div>
  </div>
  <div class="container-fluid">
    <div class="container">
      <div class="row justify-content-center">
        <div class="col-12">
          <h2 class="mb-3">1. Hyphen with Compound Modifiers:</h2>
          <p>
            Use a hyphen in a compound modifier when the modifier comes before
            the word it’s modifying.
          </p>
          <br />
          <br />
          <h2>Two-Word Adjectives Before Nouns:</h2>

          <p>
            A compound modifier is made up of two words that work together to
            function like one adjective. Generally, the hyphen is placed only if
            the two words are functioning together as an adjective before the
            noun they are describing. If the noun comes first, leave the hyphen
            out.
          </p>

          <br />
          <p class="examplFnt">Examples:</p>
          <div class="tips">
            <ul class="example">
              <li>

                Visit to Amazon forest is a
                <i style="font-weight: bold"> never-to-be-forgotten </i>
                experience. <i style="font-weight: bold"> (Correct) </i>

              </li>
              <li>
                Visit to Amazon forest experience is
                <i style="font-weight: bold"> never to be forgotten. (Wrong)
                </i>

              </li>
              <li>

                We prefer a <i style="font-weight: bold">pet-friendly</i> hotel to stay.
                <i style="font-weight: bold"> (Correct) </i>

              </li>
              <li>

                Is this hotel <i style="font-weight: bold"> pet friendly? (Wrong) </i>

              </li>
            </ul>
          </div>
          <br />
          <h2 class="update">Two-Word Adverb and Adjective</h2>
          <p>
            A hyphen is not used when modifier is made up of an adverb and an
            adjective.
          </p>
          <br />
          <p class="examplFnt">Examples:</p>
          <div class="tips">
            <ul class="example">
              <li>

                I do not trust this clearly-unbelievable story.
                <i style="font-weight: bold"> (Wrong) </i>

              </li>
              <li>

                I do not trust this clearly unbelievable story.
                <i style="font-weight: bold"> (Correct) </i>

              </li>

            </ul>
          </div>
          <br />
          <p>Don’t use a hyphen when you are combining an adverb and a
            participle.</p>
          <br>

          <p class="examplFnt">Examples:</p>
          <div class="tips">
            <ul class="example">
              <li>

                The room was like a heavily-decorated chocolate box.
                <i style="font-weight: bold"> (Wrong) </i>

              </li>
              <li>

                The room was like a heavily decorated chocolate box.
                <i style="font-weight: bold"> (Correct) </i>

              </li>
            </ul>
          </div>
          <br />
          <br />
          <h2 class="update">
            Two-Word Compound Modifier with Present And Past Participle
          </h2>
          <p>
            Compound modifiers that include present or past participles follow
            the same rules as any other compound modifier.
          </p>
          <br />
          <p class="examplFnt">Examples:</p>
          <div class="tips">
            <ul class="example">
              <li>

                He is <i style="font-weight: bold"> self-taught </i> driver.

              </li>
              <li>

                She is <i style="font-weight: bold"> self-made </i> woman.

              </li>
              <li>

                There are some
                <i style="font-weight: bold"> beautiful-looking </i> flowers
                in the garden.

              </li>
              <li>

                <i style="font-weight: bold">Fast-acting</i> medication can be useful when one has a headache.

              </li>
            </ul>
          </div>
        </div>

        <div class="col-12 mt-5">
          <h2 class="update">Hyphenated Compound Words</h2>
          <p>
            Hyphenated compound words are the ones (obviously) with a hyphen
            between the words. Over time, many hyphenated compounds become
            closed compounds—teen-ager became teenager Here are a few examples
            of common hyphenated compound words:
          </p>
          <br />
          <p class="examplFnt">Examples:</p>
          <div class="tips">
            <ul class="example">
              <li>
                Mother-in-law
              </li>
              <li>
                Master-at-arms
              </li>
              <li>
                Editor-in-chief
              </li>
              <li>
                Ten-year-old
              </li>
              <li>
                Factory-made
              </li>
              <li>
                Twelve-pack
              </li>
            </ul>
          </div>
        </div>

        <div class="col-12 mt-5">
          <h2 class="update">Closed Compound Words</h2>
          <p>
            Hyphenated words tend to become closed compounds (single words with
            no hyphens) over time. Email instead of e-mail, for example, is
            increasingly common.
          </p>
          <br />
          <p class="examplFnt">Examples:</p>
          <div class="tips">
            <ul class="example">
              <li>
                Notebook
              </li>
              <li>
                Superman
              </li>
              <li>
                Waistcoat
              </li>
              <li>
                Bookstore
              </li>
              <li>
                Fireman
              </li>
            </ul>
          </div>
        </div>

        <div class="col-12 mt-5">
          <h2 class="update">Open Compound Words</h2>
          <p>
            Open compounds are typically made up of two nouns that are used
            together to represent a single idea. “Open” means that there is a
            space between the two words and no hyphen. A good dictionary is the
            best place to check whether a compound is open or not.
          </p>
          <br />
          <p class="examplFnt">Examples:</p>
          <div class="tips">
            <ul class="example">
              <li>
                Living room
              </li>
              <li>
                Real estate
              </li>
              <li>
                Dinner table
              </li>
              <li>
                Coffee mug
              </li>
            </ul>
          </div>
        </div>

        <div class="col-12 mt-5">
          <h2 class="update">Hyphens and Numbers</h2>
          <p>
            Numbers between twenty-one and ninety-nine should be hyphenated when
            they’re spelled out.
            <br />
          </p>
          <p class="examplFnt">Examples:</p>
          <div class="tips">
            <ul class="example">
              <li>
                <i style="font-weight: bold"> Thirty-six </i> shades in
                palette.

              </li>
              <li>
                A hundred and
                <i style="font-weight: bold"> twenty-four </i> pair of shoes.

              </li>
            </ul>
          </div>
        </div>

        <div class="col-12 mt-5">
          <h2 class="update">Hyphen in Compound Adjective with Numbers</h2>
          <p>
            When numbers are used as the first part of a compound adjective, use
            a hyphen to connect them to the noun that follows them. The reader
            knows that both words function like a unit to modify another noun,
            in this way. This applies whether the number is written in words or
            in digits.
          </p>
          <br />
          <p class="examplFnt">Examples:</p>
          <div class="tips">
            <ul class="example">
              <li>

                The president of the company gave a
                <i style="font-weight: bold"> 10-minute </i> speech to the
                employees.

              </li>
              <li>

                He is knowledgeable in
                <i style="font-weight: bold"> thirteenth-century </i>
                politics.

              </li>
              <li>

                The boy threw a stone at the
                <i style="font-weight: bold"> second-storey </i> window.

              </li>

            </ul>
          </div>
          <br />
          <p> However, a hyphen is not required if the number is the second
            word in the compound adjective.</p>
          <br>
          <p class="examplFnt">Examples:</p>
          <div class="tips">
            <ul class="example">
              <li>

                He is a victim of
                <i style="font-weight: bold"> Type 2 </i> diabetes.

              </li>
              <li>

                This elevator does not go down to
                <i style="font-weight: bold"> Basement 3.</i>

              </li>
            </ul>
          </div>
        </div>

        <div class="col-12 mt-5">
          <h2 class="update">Hyphen in Compound Adjective with Fractions</h2>
          <p>
            When using a fraction (e.g. half or quarter) as part of a compound
            adjective, it should be hyphenated so the reader understands which
            fraction is modifying which noun.
          </p>
          <br />
          <p class="examplFnt">Examples:</p>
          <div class="tips">
            <ul class="example">
              <li>

                A <i style="font-weight: bold"> quarter-million </i> dollars
                is not a large amount of money indeed.

              </li>
              <li>

                You will need <i style="font-weight: bold"> one-third </i> of
                a cup of flour and an egg.

              </li>
              <li>

                That is a <i style="font-weight: bold"> half-baked </i> pizza
                if I ever seen one!

              </li>
            </ul>
          </div>
        </div>

        <div class="col-12 mt-5">
          <h2 class="update">Hyphen with Prefixes: Ex-, Self-, All-.</h2>
          <p>Use a hyphen with the prefix ex- (meaning former).</p>
          <br />
          <p class="examplFnt">Examples:</p>
          <div class="tips">
            <ul class="example">
              <li>

                Adam is Cloe’s
                <i style="font-weight: bold"> ex-president. </i>

              </li>
              <li>

                <i style="font-weight: bold"> Ex-mayor </i> still attends
                council meetings.

              </li>
            </ul>
          </div>
          <br />
          <p> Use a hyphen with the reflexive prefix self-.</p>
          <br>
          <p class="examplFnt">Examples:</p>
          <div class="tips">
            <ul class="example">
              <li>

                They are <i style="font-weight: bold"> self-sufficient </i> in
                daily supplies.

              </li>
              <li>

                The cat looked extremely
                <i style="font-weight: bold"> self-satisfied. </i>

              </li>

            </ul>
          </div>
          <br />
          <p>    Make sure you don’t confuse the prefix self- with the noun
            self.</p>
          <br>
          <p class="examplFnt">Examples:</p>
          <div class="tips">
            <ul class="example">
              <li>

                The <i style="font-weight: bold"> self </i> serves no other.

              </li>

            </ul>
          </div>
          <br />
          <p>When using all as a prefix, add a hyphen.</p>
          <br>
          <p class="examplFnt">Examples:</p>
          <div class="tips">

            <ul class="example">
              <li>

                A bad leader thinks of himself as
                <i style="font-weight: bold"> all-powerful. </i>

              </li>
            </ul>
          </div>
        </div>

        <div class="col-12 mt-5">
          <h2 class="update">Hyphens with High or Low</h2>
          <p>
            When using high or low as part of a compound adjective, use a hyphen
            when the compound comes before the noun it’s modifying.
          </p>
          <br />
          <p class="examplFnt">Examples:</p>
          <div class="tips">
            <ul class="example">
              <li>

                <i style="font-weight: bold"> High-level/low-level </i>

              </li>
              <li>
                <i style="font-weight: bold"> High-impact/low-impact </i>
              </li>
              <li>

                <i style="font-weight: bold">Low-flying </i> airplanes
                contribute to the noise pollution in the area.

              </li>
              <li>

                This car runs best on
                <i style="font-weight: bold"> high-octane </i> gasoline.

              </li>
              <li>

                <i style="font-weight: bold">Low-income </i> families often
                face more hardships than their
                <i style="font-weight: bold"> higher-income </i> counterparts.

              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>
  </div>
</div> -->

<!--end hyphen-->
<!--comma-->
<div class="mb-5" *ngIf="section === 'what-is-a-comma'">
  <div class="container-fluid hero-Adjectives">
    <app-header></app-header>

    <div class="container modify-container">
      <div class="row">
        <div class="col-12 head-top">
          <nav aria-label="breadcrumb" class="mb-1">
            <ol class="breadcrumb">
              <li class="breadcrumb-item">
                <a [routerLink]="['/']">Home</a>
              </li>
              <li class="breadcrumb-item">
                <a [routerLink]="['/handbook']">Handbook</a>
              </li>
              <li class="breadcrumb-item">
                <a [routerLink]="['/handbook/punctuation']">Punctuation</a>
              </li>
              <li class="breadcrumb-item activebread">
                <a [routerLink]="['/what-is-a-comma']">What Is a Comma</a>
              </li>
            </ol>
          </nav>
          <h1 class="mb-2 heading">What Is a Comma (,)</h1>
          <p class="py-3 head-details">
            While a period ends a sentence, a comma indicates a smaller break.
            Some writers think of a comma as a soft pause—a punctuation mark
            that separates words, clauses, or ideas within a sentence.
          </p>
        </div>
      </div>
    </div>
  </div>
  <div class="container-fluid">
    <div class="container">
      <div class="row justify-content-center">
        <div class="col-12">
          <h2 class="update">Comma with Subjects and Verbs</h2>

          <div class="tips">
            <ul class="example">
              <li>
                My sister Simona, is an executive at JPMorgan.
                <i style="font-weight: bold"> (Wrong)</i>
              </li>
              <li>
                My sister Simona is an executive at JPMorgan.
                <i style="font-weight: bold"> (Correct)</i>
              </li>
              <li>
                The things that ends well, can also offer lots of suffering.
                <i style="font-weight: bold"> (Wrong)</i>
              </li>
              <li>
                The things that ends well can also offer lots of suffering.
                <i style="font-weight: bold"> (Correct)</i>
              </li>

              <li>
                Driving through snow, sleet, wind, and darkness, is a miserable
                way to travel.
                <i style="font-weight: bold"> (Wrong)</i>
              </li>
              <li>
                Driving through snow, sleet, wind, and darkness is a miserable
                way to travel.
                <i style="font-weight: bold"> (Correct)</i>
              </li>
            </ul>
          </div>
          <br />
          <h2 class="update">
            Comma Between Two Nouns in a Compound Subject or Object
          </h2>

          <div class="tips">
            <p>
              Don’t separate two nouns that appear together as a compound
              subject or compound object.
            </p>
            <br />
            <ul class="example">
              <li>
                Simona, and her team will be planning a dinner next Sunday.
                <i style="font-weight: bold"> (Wrong)</i>
              </li>
              <li>
                Simona and her team will be planning a dinner next Sunday.
                <i style="font-weight: bold"> (Correct)</i>
              </li>
              <li>
                Simona will prepare a salad bowl, and pasta for dinner.
                <i style="font-weight: bold"> (Wrong)</i>
              </li>
              <li>
                Simona will prepare a salad bowl and pasta for dinner.
                <i style="font-weight: bold"> (Correct) </i>
              </li>
            </ul>
          </div>
        </div>

        <div class="col-12 mt-5">
          <h2 class="update">Listings</h2>
          <p>
            Comma is not required when listing two items. If there are more than
            two items, then comma is required to separate items.
          </p>

          <div class="tips">
            <ul class="example">
              <li>
                She bought apples, bananas.
                <i style="font-weight: bold"> (Wrong) </i>
              </li>
              <li>
                She bought apples and bananas.
                <i style="font-weight: bold"> (Correct) </i>
              </li>
            </ul>
          </div>
        </div>

        <div class="col-12 mt-5">
          <h2 class="update">
            Comma Between Two Verbs in a Compound Predicate
          </h2>
          <div class="tips">
            <p>
              Don’t separate two verbs in a compound predicate with a comma.
            </p>
            <p>
              You get a compound predicate when the subject of a sentence is
              doing more than one thing.
            </p>
            <br />
            <ul class="example">
              <li>
                Simona will run, and drive the car.
                <i style="font-weight: bold"> (Wrong)</i>
              </li>
              <li>
                Simona will run and drive the car.
                <i style="font-weight: bold"> (Correct)</i>
              </li>
            </ul>
          </div>
          <p>
            This mistake is most common when the predicate is made up of long
            verb phrases.
          </p>

          <div class="tips">
            <ul class="example">
              <li>
                I meant to buy tickets for Simona’s show, but ran out of time.
                <i style="font-weight: bold"> (Wrong)</i>
              </li>
              <li>
                I meant to buy tickets for Simona’s show but ran out of time.
                <i style="font-weight: bold"> (Correct) </i>
              </li>
            </ul>
          </div>
          <p>
            However, to make action clear that who performed it, comma can be
            used.
          </p>
          <br />
          <p class="examplFnt">Examples:</p>
          <div class="tips">
            <ul class="example">
              <li>Simona spotted the man who entered the dinner, and waved.</li>
            </ul>
            <p>
              In the sentence above, you need the comma to make clear that it
              was Simona who waved, not the man.
            </p>
          </div>
        </div>

        <div class="col-12 mt-5">
          <h2 class="update">Comma Splices</h2>
          <p>
            When two independent clauses are joined with comma instead of a
            conjunction or a semicolon; this fault is called Comma splice
          </p>
          <p>
            This fault can be fixed by adding a conjunction or changing the
            comma to a semicolon.
          </p>
          <br />
          <p class="examplFnt">Examples:</p>
          <div class="tips">
            <ul class="example">
              <li>
                We were out of milk; I went to the store.
                <i style="font-weight: bold"> (Wrong)</i>
              </li>
              <li>
                We were out of milk, so, I went to the store.
                <i style="font-weight: bold"> (add conjunction)</i>
              </li>
              <li>
                We were out of milk; I went to the store.
                <i style="font-weight: bold"> (add semicolon)</i>
              </li>
            </ul>
          </div>
          <p><i style="font-weight: bold">Or</i></p>
          <div class="tips">
            <ul class="example">
              <li>
                We were out of milk. I went to the store.
                <i style="font-weight: bold">
                  (add period and construct new sentence)
                </i>
              </li>
            </ul>
          </div>
        </div>

        <div class="col-12 mt-5">
          <h2 class="update">Comma After Introductory Phrase</h2>
          <p>
            A comma normally follows participle phrases and prepositional
            phrases that introduce a sentence.
          </p>
          <br />
          <p class="examplFnt">Examples:</p>
          <div class="tips">
            <ul class="example">
              <li>Grabbing her umbrella, Kate raced out of the house.</li>
              <li>
                Confused by her sister’s sudden change in mood, Jill stayed
                quiet.
              </li>
              <li>
                Confused by her sister’s sudden change in mood, Jill stayed
                quiet.
              </li>
              <li>After the show, Cleo will be signing autographs.</li>
            </ul>
          </div>
          <br />
          <p>Comma is also used to clear the confusion and avoid ambiguity.</p>
          <br />
          <p class="examplFnt">Examples:</p>
          <div class="tips">
            <ul class="example">
              <li>
                Before going the family said bye.<i style="font-weight: bold">
                  (unclear)
                </i>
              </li>
              <li>
                Before going, the family said bye.<i style="font-weight: bold">
                  (clear)
                </i>
              </li>
              <li>
                Let’s eat grandpa.<i style="font-weight: bold"> (unclear) </i>
              </li>
              <li>
                Let’s eat, grandpa.<i style="font-weight: bold"> (clear) </i>
              </li>
            </ul>
          </div>
        </div>

        <div class="col-12 mt-5">
          <h2 class="update">Comma Within a Comparison</h2>
          <p>
            Comma is not used before
            <i style="font-weight: bold"> than </i> when making a comparison.
          </p>
          <br />
          <p class="examplFnt">Examples:</p>
          <div class="tips">
            <ul class="example">
              <li>
                This tin is heavier,
                <i style="font-weight: bold"> than </i> that tin.
                <i style="font-weight: bold"> (Wrong) </i>
              </li>
              <li>
                This tin is heavier
                <i style="font-weight: bold"> than </i> that tin.
                <i style="font-weight: bold"> (Correct) </i>
              </li>
              <li>
                Hardcover books are more expensive,
                <i style="font-weight: bold"> than </i> paperback books.
                <i style="font-weight: bold"> (Wrong)</i>
              </li>
              <li>
                Hardcover books are more expensive
                <i style="font-weight: bold"> than </i> paperback books.
                <i style="font-weight: bold"> (Correct) </i>
              </li>
            </ul>
          </div>
        </div>

        <div class="col-12 mt-5">
          <h2 class="update">
            Commas with Interrupters and Parenthetical Elements
          </h2>
          <p>
            Interrupters are little thoughts that pop up in the middle of a
            sentence to show emotion, tone, or emphasis. A parenthetical element
            is a phrase that adds extra information to the sentence but could be
            removed without changing the meaning of the sentence. Both
            interrupters and parenthetical elements should be set off with
            commas.
          </p>
          <br />
          <p class="examplFnt">Examples:</p>
          <div class="tips">
            <ul class="example">
              <li>
                The rainy weather
                <i style="font-weight: bold"> I was amused to see </i> was
                beginning to clear. <i style="font-weight: bold"> (Wrong)</i>
              </li>
              <li>
                The rainy weather,
                <i style="font-weight: bold"> I was amused to see, </i> was
                beginning to clear.
                <i style="font-weight: bold"> (Correct)</i>
              </li>
              <li>
                Harry’s painting skills
                <i style="font-weight: bold"> if you can call them skills </i>
                left something to be desired.
                <i style="font-weight: bold"> (Wrong)</i>
              </li>
              <li>
                Harry’s painting skills,
                <i style="font-weight: bold"> if you can call them skills, </i>
                left something to be desired.
                <i style="font-weight: bold"> (Correct)</i>
              </li>
            </ul>
          </div>
        </div>

        <div class="col-12 mt-5">
          <h2 class="update">Comma with a Tag Question</h2>
          <p>
            A tag question is a short phrase or even a single word that is added
            to the end of a statement to turn it into a question. Writers often
            use question tags to encourage readers to agree with them. A tag
            question should be preceded by a comma.
          </p>
          <br />
          <p class="examplFnt">Examples:</p>
          <div class="tips">
            <ul class="example">
              <li>
                These rose plants are beautiful,
                <i style="font-weight: bold"> aren’t they?</i>
              </li>
              <li>
                You didn’t actually write a 600-page action thrilled novel,
                <i style="font-weight: bold"> did you? </i>
              </li>
            </ul>
          </div>
        </div>

        <div class="col-12 mt-5">
          <h2 class="update">Comma with Direct Address</h2>
          <p>
            When addressing another person by name, set off the name with
            commas.
          </p>
          <br />
          <p class="examplFnt">Examples:</p>
          <div class="tips">
            <ul class="example">
              <li>
                <i style="font-weight: bold"> Mom, I </i> can’t find my shoes!
              </li>
              <li>
                <i style="font-weight: bold">Clara, </i> there’s message for
                you.
              </li>
              <li><i style="font-weight: bold">Hello, </i> Chester.</li>
            </ul>
          </div>
        </div>

        <div class="col-12 mt-5">
          <h2 class="update">Comma with an Appositive</h2>
          <p>
            An appositive is a word or phrase that refers to the same thing as
            another noun in the same sentence. Often, the appositive provides
            additional information about the noun or helps to distinguish it in
            some way. If you could remove the appositive without changing the
            meaning of the sentence, it is said to be non-essential and should
            be set off with commas. If the appositive is necessary, it is said
            to be essential and it should not be set off with commas.
          </p>
          <br />
          <p class="examplFnt">Examples:</p>
          <br />
          <br />
          <h2>1. Nonessential appositives:</h2>
          <div class="tips">
            <ul class="example">
              <li>
                My dad, <i style="font-weight: bold"> Sylem, </i> is an amazing
                businessperson.
              </li>
              <li>
                The painter,
                <i style="font-weight: bold">
                  one of the city’s most promising young artists,
                </i>
                began showing his work in art galleries before he was sixteen.
              </li>
            </ul>
          </div>
          <br />

          <br />
          <h2>2. Essential appositives:</h2>

          <div class="tips">
            <ul class="example">
              <li>
                Edgar Allan Poe’s poem
                <i style="font-weight: bold"> The Raven </i> is a classic.
              </li>
              <li>
                Alec Baldwin’s brother
                <i style="font-weight: bold"> Stephen </i> is the most
                underrated Baldwin.
              </li>
            </ul>
          </div>
        </div>

        <div class="col-12 mt-5">
          <h2 class="update">Commas in Dates</h2>
          <p>
            When writing a date in month-day-year format, set off the year with
            commas.
          </p>
          <br />
          <p class="examplFnt">Examples:</p>
          <div class="tips">
            <ul class="example">
              <li>
                <p>July 4, 1776, was an important day in American history.</p>
              </li>
              <li>
                I was born on Sunday,
                <i style="font-weight: bold"> May 12, 1968. </i>
              </li>
            </ul>
          </div>
          <br />
          <p>In the day-month-year format, however, commas are unnecessary.</p>
          <br />
          <p class="examplFnt">Examples:</p>
          <div class="tips">
            <ul class="example">
              <li>Applications are due by 31 December 2016.</li>
            </ul>
          </div>
          <br />
          <p>If referencing a day of the week and a date, use a comma.</p>
          <br />
          <p class="examplFnt">Examples:</p>
          <div class="tips">
            <ul class="example">
              <li>
                On Tuesday, April 13, at three o’clock, there will be a meeting
                for all staff.
              </li>
              <li>
                Please join us on Saturday, June 14, 2010, for the marriage of
                Annie and Michael.
              </li>
            </ul>
          </div>
          <br />
          <p>When referencing only a month and year, you don’t need a comma.</p>
          <br />
          <p class="examplFnt">Examples:</p>
          <div class="tips">
            <ul class="example">
              <li>The region experienced record rainfall in March 1999.</li>
            </ul>
          </div>
        </div>

        <div class="col-12 mt-5">
          <h2 class="update">Comma Before but</h2>
          <p>
            Use a comma before the word but if it is joining two independent
            clauses.
          </p>
          <br />
          <p class="examplFnt">Examples:</p>
          <div class="tips">
            <ul class="example">
              <li>
                Cleo is a good singer but she is an even better dancer.
                <i style="font-weight: bold"> (Wrong) </i>
              </li>
              <li>
                Cleo is a good singer, but she is an even better dancer.
                <i style="font-weight: bold"> (Correct)</i>
              </li>
            </ul>
          </div>
          <p>
            If but is not joining two independent clauses, leave the comma out.
          </p>
          <br />
          <p class="examplFnt">Examples:</p>
          <div class="tips">
            <ul class="example">
              <li>
                My teacher is tough, but fair.
                <i style="font-weight: bold"> (Wrong) </i>
              </li>
              <li>
                My teacher is tough but fair.
                <i style="font-weight: bold"> (Correct) </i>
              </li>
              <li>
                Life is, but a dream.
                <i style="font-weight: bold"> (Wrong) </i>
              </li>
              <li>
                Life is but a dream.
                <i style="font-weight: bold"> (Correct) </i>
              </li>
            </ul>
          </div>
        </div>

        <div class="col-12 mt-5">
          <h2 class="update">Comma Before and</h2>
          <p>
            When a list contains only two items, do not use a comma before the
            <i style="font-weight: bold"> and. </i>
          </p>
          <br />
          <p class="examplFnt">Examples:</p>
          <div class="tips">
            <ul class="example">
              <li>
                My dog Charlie is cute, and smart.
                <i style="font-weight: bold"> (Wrong) </i>
              </li>
              <li>
                My dog Charlie is cute and smart.
                <i style="font-weight: bold"> (Correct)</i>
              </li>
              <li>
                Cleo’s favourite activities are singing on stage, and relaxing
                in the sunshine. <i style="font-weight: bold"> (Wrong)</i>
              </li>
              <li>
                Cleo’s favourite activities are singing on stage and relaxing in
                the sunshine. <i style="font-weight: bold"> (Correct)</i>
              </li>
            </ul>
          </div>
        </div>

        <div class="col-12 mt-5">
          <h2 class="update">Commas with Lists</h2>
          <p>
            When a list contains more than two elements, use commas to separate
            them.
          </p>
          <br />
          <p class="examplFnt">Examples:</p>
          <div class="tips">
            <ul class="example">
              <li>
                Julie loves ice cream books and kittens.
                <i style="font-weight: bold"> (Wrong) </i>
              </li>
              <li>
                Julie loves ice cream, books, and kittens.
                <i style="font-weight: bold"> (Correct) </i>
              </li>
            </ul>
          </div>
          <br />
          <p>List might be made up of nouns, verbs, adjectives, or clauses.</p>
          <br />
          <p class="examplFnt">Examples:</p>
          <div class="tips">
            <ul class="example">
              <li>Cleaning the house and garage</li>
              <li>Raking the lawn</li>
              <li>Taking out the garbage</li>
              <li>
                To list these three chores in a sentence, it can be written as:
              </li>
              <li>
                I cleaned the
                <i style="font-weight: bold">
                  house and garage, raked the lawn,
                </i>
                and <i style="font-weight: bold"> took out the garbage.</i>
              </li>
            </ul>
            <br />
            <p>
              To list these three chores in a sentence, it can be written as:
            </p>
            <br />
            <ul class="example">
              <li>
                I cleaned the
                <i style="font-weight: bold">
                  house and garage, raked the lawn,
                </i>
                and <i style="font-weight: bold"> took out the garbage.</i>
              </li>
            </ul>
          </div>
        </div>

        <div class="col-12 mt-5">
          <h2 class="update">Serial Comma (Oxford Comma)</h2>
          <p>
            When there are three or more items in the list, commas should
            separate each element of the list. However, the final comma—the one
            that comes before and — is optional. This comma is called the serial
            comma or the Oxford comma.
          </p>
          <p>
            Use of serial comma is a style choice. In your own writing, you can
            decide for yourself whether to use it or not—just be consistent.
          </p>
          <br />
          <p class="examplFnt">Examples:</p>
          <div class="tips">
            <ul class="example">
              <li>
                Mary needs bread, milk, and butter at the grocery store.
                <i style="font-weight: bold"> (With serial comma)</i>
              </li>
              <li>
                Mary needs bread, milk, and butter at the grocery store.
                <i style="font-weight: bold"> (With serial comma)</i>
              </li>
              <li>
                I still have to buy a gift, pack the suitcases, and arrange for
                someone to water the plants while we are at the wedding.
                <i style="font-weight: bold"> (With serial comma)</i>
              </li>
              <li>
                I still have to buy a gift, pack the suitcases and arrange for
                someone to water the plants while we’re at the wedding.
                <i style="font-weight: bold"> (Without serial comma)</i>
              </li>
            </ul>
          </div>
          <br />
          <p>
            Keep in mind, though, that occasionally the serial comma is
            necessary for clarity.
          </p>
          <br />
          <p class="examplFnt">Examples:</p>
          <div class="tips">
            <ul class="example">
              <li>
                I dedicate this award to my parents, Jane Austen and Albert
                Einstein.
                <i style="font-weight: bold"> (Without serial comma) </i>
              </li>
              <li>
                I dedicate this award to my parents, Jane Austen, and Albert
                Einstein.
                <i style="font-weight: bold"> (With serial comma) </i>
              </li>
            </ul>
            <p>
              In the sentence above, it looks like “Jane Austen and Albert
              Einstein” is an appositive, rather than two more elements in a
              list. The writer seems to be saying that her parents are Jane
              Austen and Albert Einstein. However, writing the same sentence
              with serial comma makes it clear that they are separate elements.
            </p>

            <br />
            <p>
              A serial comma eliminates the possibility of misreading, so use it
              where there is a chance of misreading the sentence.
            </p>
          </div>
        </div>

        <div class="col-12 mt-5">
          <h2 class="update">Comma Separating a Verb and Its Object</h2>
          <br />
          <p>
            Do not separate a transitive verb from its direct object with a
            comma.
          </p>
          <br />
          <p class="examplFnt">Examples:</p>
          <div class="tips">
            <ul class="example">
              <li>
                I am glad I trained, Charlie not to beg for scraps.
                <i style="font-weight: bold"> (Wrong) </i>
              </li>
              <li>
                I am glad I trained Charlie not to beg for scraps.
                <i style="font-weight: bold"> (Correct) </i>
              </li>
              <li>
                Mary said, she likes chocolate.
                <i style="font-weight: bold"> (Wrong)</i>
              </li>
              <li>
                Mary said she likes chocolate.
                <i style="font-weight: bold"> (Correct) </i>
              </li>
            </ul>
          </div>
        </div>

        <div class="col-12 mt-5">
          <h2 class="update">Comma with Non-restrictive Clause</h2>
          <p>
            A non-restrictive clause offers extra information about something
            mentioned in a sentence, but the information is not essential, as
            sentence gives complete idea of the thing. Non-restrictive clauses
            are usually introduced by
            <i style="font-weight: bold"> which </i> or
            <i style="font-weight: bold"> who </i> and should be set off by
            commas.
          </p>
          <br />
          <p class="examplFnt">Examples:</p>
          <p>
            The clause “which Chester recommended” is non-restrictive because
            “Posey’s Cafe” is already specific. Identifying it as the restaurant
            recommended by Chester add any necessary information required to
            complete the message.
          </p>
          <div class="tips">
            <ul class="example">
              <li>
                Posey’s Cafe, which Chester recommended, is a fantastic
                restaurant.
              </li>

              <li>My wife, whom I love dearly, is a brilliant physicist.</li>
              <li>
                The clause “whom I love dearly” is non-restrictive because as it
                would still be clear that it is the same person—“my wife” is
                already specific.
              </li>
            </ul>
          </div>
          <br />
          <p class="examplFnt">Examples:</p>
          <p>
            The clause “whom I love dearly” is non-restrictive because as it
            would still be clear that it is the same person—“my wife” is already
            specific.
          </p>
          <div class="tips">
            <ul class="example">
              <li>My wife, whom I love dearly, is a brilliant physicist.</li>
            </ul>
          </div>
          <br />
          <h2 class="update">Comma with Restrictive Clauses</h2>
          <p>
            A restrictive clause adds necessary information about something that
            is mentioned in a sentence. Restrictive clauses are often introduced
            by
            <i style="font-weight: bold"> that </i> or
            <i style="font-weight: bold"> who </i> and should never be set off
            by commas.
          </p>
          <br />
          <p class="examplFnt">Examples:</p>
          <p>
            The clause “that Chester recommended” is essential information in
            the above example. If it is removed, there would be no way to tell
            which restaurant is recommended by Chester.
          </p>
          <div class="tips">
            <ul class="example">
              <li>
                The cafe, that Chester recommended, is a fantastic restaurant.
                <i style="font-weight: bold"> (Wrong) </i>
              </li>
              <li>
                The cafe that Chester recommended is a fantastic restaurant.
                <i style="font-weight: bold"> (Correct) </i>
              </li>
            </ul>
          </div>
        </div>

        <div class="col-12 mt-5">
          <h2 class="update">Comma Between Correlative Conjunctions</h2>
          <p>
                Correlative conjunctions are conjunctions that come in pairs
            (such as
            <i style="font-weight: bold"> either/or, neither/nor, </i> and not
            only/but also) and connect words or phrases in a sentence to form a
            complete thought. Typically, commas are unnecessary with correlative
            conjunctions.
          </p>
          <br />
          <p class="examplFnt">Examples:</p>
          <div class="tips">
            <ul class="example">
              <li>
                Either the blue shirt, or the red sweater will look good with
                your jeans. <i style="font-weight: bold"> (Wrong)</i>
              </li>
              <li>
                Either the blue shirt or the red sweater will look good with
                your jeans. <i style="font-weight: bold"> (Correct)</i>
              </li>
              <li>
                You can wear a pashmina not only for warmth, but also for
                fashion.
                <i style="font-weight: bold"> (Wrong)</i>
              </li>
              <li>
                You can wear a pashmina not only for warmth but also for
                fashion.
                <i style="font-weight: bold"> (Correct) </i>
              </li>
            </ul>
          </div>
        </div>

        <div class="col-12 mt-5">
          <h2 class="update">Comma Between Direct Quote and Attributive Tag</h2>
          <p>
            An attributive tag is a phrase like “he said” or “she claimed” that
            identifies the speaker of a quote or piece of dialogue. Attributive
            tags can come before, after, or even in the middle of a quote. Use
            commas to separate attributive tags from quotations.
          </p>
          <br />
          <p class="examplFnt">Examples:</p>
          <div class="tips">
            <ul class="example">
              <li>
                <i style="font-weight: bold"> The professor remarked, </i>
                “How attentive you have been today!”
              </li>
              <li>
                “Once you know the solution,”
                <i style="font-weight: bold"> Tiffany said, </i> “the whole
                problem seems very simple.”
              </li>
              <li>
                “You have ice cream on your nose,”
                <i style="font-weight: bold"> my friend snickered. </i>
              </li>
              <li>
                “When you leave the house,”
                <i style="font-weight: bold"> my mother yelled, </i> “don’t slam
                the door!”
              </li>
            </ul>
          </div>
          <br />
          <p>
            If a quotation before attributive tag ends in a question mark or
            exclamation point, however, there is no need for a comma.
          </p>
          <br />
          <p class="examplFnt">Examples:</p>
          <div class="tips">
            <ul class="example">
              <li>
                “You have a spider on your nose!”, my friend yelled.
                <i style="font-weight: bold"> (Wrong) </i>
              </li>
              <li>
                “You have a spider on your nose!” my friend yelled.
                <i style="font-weight: bold"> (Correct) </i>
              </li>
              <li>
                “Where did that spider come from?”, I asked.
                <i style="font-weight: bold"> (Wrong) </i>
              </li>
              <li>
                “Where did that spider come from?” I asked.
                <i style="font-weight: bold"> (Correct)</i>
              </li>
            </ul>
          </div>
        </div>

        <div class="col-12 mt-5">
          <h2 class="update">Comma inside Quotation Marks</h2>
          <p>Commas are placed before closing quotation marks.</p>
          <br />
          <p class="examplFnt">Examples:</p>
          <div class="tips">
            <ul class="example">
              <li>“Pass me that thesaurus,” said Matthew.</li>
              <li>
                “We’re going down to the soup kitchen to help serve dinner,” her
                mother called.
              </li>
            </ul>
          </div>
          <br />
          <h2 class="update">Comma Before Parenthesis</h2>
          <p>
            Parentheses are used to give additional information to the reader
            which otherwise interrupt the flow of the sentence. Commas should be
            placed if required as a part of sentence and after closing
            parenthesis.
          </p>
          <br />
          <p class="examplFnt">Examples:</p>
          <div class="tips">
            <ul class="example">
              <li>
                After opening the new cookie tin, (and eating several of the
                cookies), Chester had a hard time replacing the lid.
                <i style="font-weight: bold"> (Wrong) </i>
              </li>
              <li>
                “After opening the new cookie tin (and eating several of the
                cookies,) Chester had a hard time replacing the lid.
                <i style="font-weight: bold"> (Wrong) </i>
              </li>
              <li>
                After opening the new cookie tin (and eating several of the
                cookies), Chester had a hard time replacing the lid.
                <i style="font-weight: bold"> (Correct)</i>
              </li>
            </ul>
          </div>
        </div>

        <div class="col-12 mt-5">
          <h2 class="update">Comma Between an Article and Noun</h2>
          <p>Do not use a comma between an article and a noun.</p>
          <br />
          <p class="examplFnt">Examples:</p>
          <div class="tips">
            <ul class="example">
              <li>
                < The company managers accidentally scheduled
                <i style="font-weight: bold"> the, weekly </i> meeting for
                Saturday. <i style="font-weight: bold"> (Wrong) </i>
              </li>
              <li>
                The company managers accidentally scheduled the weekly meeting
                for Saturday. <i style="font-weight: bold"> (Correct) </i>
              </li>
            </ul>
          </div>
        </div>

        <div class="col-12 mt-5">
          <h2 class="update">Comma with ‘As Well As’</h2>
          <p>
            The phrase “as well as” usually does not require commas unless it is
            part of a non-restrictive clause.
          </p>
          <br />
          <p class="examplFnt">Examples:</p>
          <div class="tips">
            <ul class="example">
              <li>
                Please proofread for grammatical errors
                <i style="font-weight: bold"> as well as </i> spelling mistakes.
              </li>
              <li>
                Spelling mistakes,
                <i style="font-weight: bold"> as well as </i> grammatical
                errors, are distracting to readers.
              </li>
            </ul>
          </div>
        </div>

        <div class="col-12 mt-5">
          <h2 class="update">Comma with ‘Such As’</h2>
          <p>
            The phrase <i style="font-weight: bold"> “such as” </i> requires
            commas if it introduces a non-restrictive clause.
          </p>
          <br />
          <p class="examplFnt">Examples:</p>
          <div class="tips">
            <ul class="example">
              <li>
                Coniferous trees, such as pine and spruce, do not drop their
                needles in the winter.
              </li>
            </ul>
          </div>
        </div>
        <br />
        <p>
          If <i style="font-weight: bold"> “such as” </i> introduces a
          restrictive clause, omit the commas.
        </p>
        <br />
        <p class="examplFnt">Examples:</p>
        <div class="tips">
          <ul class="example">
            <li>
              Trees such as pine and spruce do not drop their needles in the
              winter.
            </li>
          </ul>
        </div>
      </div>
      <div class="col-12 mt-5">
        <h2 class="update">Comma Before Too</h2>
        <p>Using a comma before “too” is optional.</p>
        <br />
        <p class="examplFnt">Examples:</p>
        <div class="tips">
          <ul class="example">
            <li>
              I like mangoes too. I
              <i style="font-weight: bold"> too </i> like mangoes.
            </li>
            <li>
              I like mangoes, too.
              <i style="font-weight: bold"> I, too, </i> like mangoes.
            </li>
          </ul>
        </div>
      </div>
    </div>
  </div>
</div>
<!-- </div> -->
<!--end comma-->
<!--question-mark-->
<div class="mb-5" *ngIf="section === 'how-to-do-upside-down-question-mark'">
  <div class="container-fluid hero-long">
    <app-header></app-header>

    <div class="container modify-container">
      <div class="row">
        <div class="col-12 head-top">
          <nav aria-label="breadcrumb" class="mb-1">
            <ol class="breadcrumb">
              <li class="breadcrumb-item">
                <a [routerLink]="['/']">Home</a>
              </li>
              <li class="breadcrumb-item">
                <a [routerLink]="['/handbook']">Handbook</a>
              </li>
              <li class="breadcrumb-item">
                <a [routerLink]="['/handbook/punctuation']">Punctuation</a>
              </li>
              <li class="breadcrumb-item activebread">
                <a [routerLink]="['/how-to-do-upside-down-question-mark']"
                  >What Is a Question Mark</a
                >
              </li>
            </ol>
          </nav>
          <h1 class="mb-2 heading">What Is a Question Mark (?)</h1>
          <p class="py-3 head-details">
            The main purpose of a question mark is to indicate that a sentence
            is a question. Direct questions often (but not always) begin with a
            wh- word (who, what, when, where, why).
          </p>
        </div>
      </div>
    </div>
  </div>
  <div class="container-fluid">
    <div class="container">
      <div class="row justify-content-center">
        <div class="col-12">
          <p class="examplFnt">Examples:</p>
          <div class="tips">
            <ul class="example">
              <li>
                <i style="font-weight: bold"> Why </i> did the chicken cross the
                road<i style="font-weight: bold">?</i>
              </li>
              <li>
                <i style="font-weight: bold"> Who </i> wants to know<i
                  style="font-weight: bold"
                  >?</i
                >
              </li>
              <li>
                <i style="font-weight: bold"> Where </i> is Spain on the map<i
                  style="font-weight: bold"
                  >?</i
                >
              </li>
            </ul>
          </div>
          <br />
          <p>
            In addition, a question sentence can be constructed by beginning the
            sentence with auxiliary or modal verb.
          </p>
          <br />
          <p class="examplFnt">Examples:</p>
          <div class="tips">
            <ul class="example">
              <li>
                <i style="font-weight: bold"> Is </i> it raining outside<i
                  style="font-weight: bold"
                  >?</i
                >
              </li>
              <li>
                <i style="font-weight: bold">Are </i> they happy with their
                achievements<i style="font-weight: bold">?</i>
              </li>
              <li>
                <i style="font-weight: bold">Should </i> you offer coupon on
                buying above £50/-<i style="font-weight: bold">?</i>
              </li>
            </ul>
          </div>
          <br />
          <p>
            Sometimes we have an enquiring tone while saying declarative
            sentence. In writing, question mark at the end of declarative
            sentence sets the same tone of question in the statement. This is
            the way to express surprise, doubt and disbelief.
          </p>
          <br />
          <p class="examplFnt">Examples:</p>
          <div class="tips">
            <ul class="example">
              <li>
                You came all this way to ask me about a chicken<i
                  style="font-weight: bold"
                  >?
                </i>
              </li>
              <li>Cross the road<i style="font-weight: bold">?</i> Never!</li>
            </ul>
          </div>
        </div>
        <div class="col-12 mt-5">
          <h2 class="update">
            Question Marks /Quotation Marks/parenthesis/brackets
          </h2>

          <p>
            When a sentence is a question, the question mark goes at the very
            end and serves as the terminal punctuation mark. However, when it is
            used with other punctuation marks such as quotation marks,
            parenthesis or brackets it is used where it applies. This means, if
            the information enclosed in these punctuation marks is additional
            information and not a question itself then it will be placed at the
            end of sentence not inside them. However, if the information
            enclosed within the parenthesis or brackets itself is a question
            then question mark will be placed in them.
          </p>

          <br />
          <p class="examplFnt">Examples:</p>
          <div class="tips">
            <ul class="example">
              <li>
                Do they
                <i style="font-weight: bold">(Anna and George)</i> believe in
                such myths?
              </li>
              <li>
                Mother feels scared about her children
                <i style="font-weight: bold"
                  >(What if they are not safe with their new friend?)
                </i>
                so she did not allow them to go out with the new friend.
              </li>
              <li>
                Haven’t you ever heard the expression
                <i style="font-weight: bold">“It’s a free country”?</i>
              </li>
              <li>
                The chicken asked,
                <i style="font-weight: bold">
                  “Why is everyone so concerned about where I’m walking?”</i
                >
              </li>
            </ul>
          </div>

          <br />
          <p>
            When you have a question mark that applies to both the quoted phrase
            and the rest of the sentence, just use one question mark.
          </p>
          <br />
          <p class="examplFnt">Examples:</p>
          <div class="tips">
            <ul class="example">
              <li>
                Who said,
                <i style="font-weight: bold">
                  “Why did the chicken cross the road?”
                </i>
              </li>
            </ul>
          </div>
        </div>
        <div class="col-12 mt-5">
          <h2 class="update">Indirect Questions</h2>
          <p>
            Indirect questions never take question mark and period is used at
            the end of the sentence. Indirect questions are asked as declarative
            sentences.
          </p>
          <br />
          <p class="examplFnt">Examples:</p>
          <ul class="example">
            <li>
              Alice asked if anyone wanted to go for shopping with her. We all
              wondered why she was so obsessed with the shopping all the time.
            </li>
          </ul>
        </div>
        <div class="col-12 mt-5">
          <h2 class="update">Question Mark (?) with Exclamation mark(!)</h2>
          <p>
            Sometimes question has an element of surprise, shock or excitement
            and in writing to convey this tone in question, exclamation mark can
            be used.
          </p>
          <br />
          <p class="examplFnt">Examples:</p>
          <ul class="example">
            <li>Are you saying the chicken is a millionaire?!</li>
            <li>What?! Really! she got world distinction.</li>
          </ul>
        </div>
      </div>
    </div>
  </div>
</div>
<!--end question-mark-->
<!--	Quotation Marks (“ ”) and Dialogue-->
<div class="mb-5" *ngIf="section === 'when-to-use-quotation-marks'">
  <div class="container-fluid hero-long">
    <app-header></app-header>

    <div class="container modify-container">
      <div class="row">
        <div class="col-12 head-top">
          <nav aria-label="breadcrumb" class="mb-1">
            <ol class="breadcrumb">
              <li class="breadcrumb-item">
                <a [routerLink]="['/']">Home</a>
              </li>
              <li class="breadcrumb-item">
                <a [routerLink]="['/handbook']">Handbook</a>
              </li>
              <li class="breadcrumb-item">
                <a [routerLink]="['/handbook/punctuation']">Punctuation</a>
              </li>
              <li class="breadcrumb-item activebread">
                <a [routerLink]="['/when-to-use-quotation-marks']"
                  >What Are Quotation Marks</a
                >
              </li>
            </ol>
          </nav>
          <h1 class="mb-2 heading">What Are Quotation Marks (“ ”)</h1>
          <p class="py-3 head-details">
            Quotation marks are used to identify words that someone has said.
            You’ll often find them in fiction, where they signify dialogue, the
            words spoken by the characters. In newspapers, journalists use
            quotation marks to signify that something is a direct quote from a
            person in the article. In academic papers, quotation marks can
            signify that you are quoting material that was written by someone
            else. Quotation marks always come in pairs; the first set opens the
            quote and the second set closes the quote.
          </p>
        </div>
      </div>
    </div>
  </div>
  <div class="container-fluid">
    <div class="container">
      <div class="row justify-content-center">
        <div class="col-12">
          <h2 class="update">American vs. British Quotation Marks</h2>

          <p>
            American English and British English differ in the way they use
            quotation marks. American English uses double quotation marks (“ ”)
            for quotes and reserves single quotation marks (‘ ’) for quotes
            within quotes. In British English, the convention is the opposite.
            Another difference is that in American English, periods and commas
            go before closing quotation marks. In British English, they go after
            the closing quotation mark. The guidelines below apply to American
            English.
          </p>
        </div>
        <div class="col-12 mt-5">
          <h2 class="update">Dialogue</h2>
          <p>
            When writers become confused about quotation marks, it usually has
            to do with where to put other nearby punctuation. Below is an
            example of a conversation between two characters, with their
            dialogue correctly punctuated.
          </p>
          <br />
          <p class="examplFnt">Examples:</p>
          <ul class="example">
            <li>
              Sam said,
              <i style="font-weight: bold">
                “I’ll drop the parcel at Janet’s house by tomorrow.”
              </i>
            </li>
            <li>
              <i style="font-weight: bold"> “I don’t believe it!”</i> cried
              proud father.
            </li>
            <li>
              <i style="font-weight: bold"> “Oh, but I am,” </i> Mike replied.
            </li>
            <li>
              <i style="font-weight: bold"> “How will you get there?” </i>
              Father asked.
            </li>
            <li>
              <i style="font-weight: bold"> “I thought I’d take the bus.”</i>
            </li>
            <li>
              <i style="font-weight: bold"> “And,” </i> Fauntleroy continued,
              <i style="font-weight: bold">
                “exactly by what time ‘tomorrow’?”</i
              >
            </li>
            <li>
              <i style="font-weight: bold">
                “Probably around nine in the morning.”</i
              >
            </li>
            <li>
              <i style="font-weight: bold"> “Well . . . fine.”</i>
            </li>
          </ul>
        </div>
        <div class="col-12 mt-5">
          <h2 class="update">Non-Dialogue Quotations</h2>
          <p>
            In nonfiction or academic contexts, you may want to quote someone
            without styling it as dialogue.
          </p>
          <br />
          <p class="examplFnt">Examples:</p>
          <ul class="example">
            <li>
              The mayor said his two golden retrievers were
              <i style="font-weight: bold"> “the best dogs in the world” </i>
              and added that he was not a cat person.<i
                style="font-weight: bold"
              >
                (Correct)
              </i>
            </li>
            <li>
              The mayor said his two golden retrievers were
              <i style="font-weight: bold">
                “the best dogs in the world. I’m not a cat person.” (Wrong)</i
              >
            </li>
            <li>
              In the second example, the sentence begins in the third person and
              past tense but abruptly switches to the first person and present
              tense halfway through the quote. The result is jarring for the
              reader, and sometimes hard to follow.
            </li>
          </ul>
        </div>
        <div class="col-12 mt-5">
          <h2 class="update">Scare Quotes</h2>
          <p>
            Occasionally, writers enclose certain terms they wish to distance
            themselves from in quotation marks. Quotation marks used this way
            are commonly called scare quotes or shudder quotes. It’s a way of
            implying that you’re using a term in an unusual way or that you
            don’t necessarily approve of it.
          </p>

          <br />
          <p class="examplFnt">Examples:</p>
          <ul class="example">
            <li>
              Silicon Valley has fully embraced the
              <i style="font-weight: bold"> “sharing economy.” </i>
            </li>
            <li>
              The scare quotes around
              <i style="font-weight: bold"> sharing economy </i> suggest that
              it’s not a fully accepted term. Perhaps the writer feels that it’s
              jargon or just doesn’t like it. Overusing scare quotes will
              quickly annoy readers, so reserve them for terms that truly
              require them.
            </li>
          </ul>
          <br />
          <p class="examplFnt">Examples:</p>
          <ul class="example">
            <li>
              For too many people,
              <i style="font-weight: bold"> “computer security” </i> is an
              oxymoron.
            </li>
            <li>
              In the sentence above, the scare quotes are needed to indicate
              that the writer is not talking about computer security in general,
              but rather the term itself.
            </li>
            <li>
              Scare quotes usually suggest a sniff of disapproval or sarcasm
              from the writer. Therefore, it should never be used purely for
              emphasis or decoration.
            </li>
          </ul>
          <br />
          <p class="examplFnt">Examples:</p>
          <ul class="example">
            <li>
              A sign outside a restaurant that proclaims Best
              <i style="font-weight: bold"> “Flapjacks” </i> in Town will make
              people stop and wonder why the flapjacks need the scare quotes.
              Are they really flapjacks? Or are they some kind of inferior
              imitation?
            </li>
            <li>
              Likewise, if you write someone a note that says I “love” you, the
              recipient will probably assume that you meant the exact opposite!
            </li>
          </ul>
        </div>
      </div>
    </div>
  </div>
</div>
<!--end 	Quotation Marks (“ ”) and Dialogue-->

<!-- semicolon-->
<div class="mb-5" *ngIf="section === 'what-is-a-semicolon'">
  <div class="container-fluid hero-Adjectives">
    <app-header></app-header>

    <div class="container modify-container">
      <div class="row">
        <div class="col-12 head-top">
          <nav aria-label="breadcrumb" class="mb-1">
            <ol class="breadcrumb">
              <li class="breadcrumb-item">
                <a [routerLink]="['/']">Home</a>
              </li>
              <li class="breadcrumb-item">
                <a [routerLink]="['/handbook']">Handbook</a>
              </li>
              <li class="breadcrumb-item">
                <a [routerLink]="['/handbook/punctuation']">Punctuation</a>
              </li>
              <li class="breadcrumb-item activebread">
                <a [routerLink]="['/what-is-a-semicolon']"
                  >What Is a Semicolon</a
                >
              </li>
            </ol>
          </nav>
          <h1 class="mb-2 heading">What Is a Semicolon (;)</h1>
          <p class="py-3 head-details">
            The most common use of the semicolon is to join two independent
            clauses without using a conjunction like and. However, semicolons
            are not interchangeable with commas or periods. Capital letter is
            not used after semicolon except the word is a proper noun or an
            acronym.
          </p>
        </div>
      </div>
    </div>
  </div>
  <div class="container-fluid">
    <div class="container">
      <div class="row justify-content-center">
        <div class="col-12">
          <p class="examplFnt">Examples:</p>
          <ul class="example">
            <li>
              We will go to the aquarium on Wednesday; it will be fun watching
              various species of sea creatures.
            </li>
            <li>I cannot plan outing on Monday; Anna comes for cleaning.</li>
            <li>Here are the rules for using semicolons correctly.</li>
          </ul>
        </div>
        <div class="col-12 mt-5">
          <h2>1. Semicolons Connect Related Independent Clauses</h2>

          <p>
            You can use a semicolon to join two closely related independent
            clauses. A sentence that comes before the semicolon and the sentence
            that comes after the semicolon should share a close, logical
            connection.
          </p>
          <br />
          <p class="examplFnt">Examples:</p>
          <ul class="example">
            <li>
              I ordered a cheeseburger for lunch; life’s too short for counting
              calories.
            </li>
            <li>
              Money is the root of all evil; I don’t believe the reverse is
              necessarily true.
            </li>
            <li>
              Martha has gone to the library; Andrew has gone to play soccer.
            </li>
          </ul>
        </div>
        <div class="col-12 mt-5">
          <h2>2. Delete the Conjunction When You Use a Semicolon</h2>

          <p>
            A semicolon is not the only thing that can link two independent
            clauses. Conjunctions can do that too. However, a semicolon and a
            conjunction should not be used together. That means semicolons is
            used in place of conjunctions (and, or, but), so both cannot come
            together.
          </p>
          <br />
          <p class="examplFnt">Examples:</p>
          <ul class="example">
            <li>
              I saw a magnificent albatross,
              <i style="font-weight: bold"> and </i> it was eating a mouse.
            </li>
            <li>I saw a magnificent albatross; it was eating a mouse.</li>
          </ul>
        </div>
        <div class="col-12 mt-5">
          <h2>3. Use Semicolons in a Serial List</h2>

          <p>
            You can use semicolons to divide the items of a list if the items
            are long or contain internal punctuation. In these cases, the
            semicolon helps readers keep track of the divisions between the
            items.
          </p>
          <br />
          <p class="examplFnt">Examples:</p>
          <ul class="example">
            <li>
              I need the weather statistics for the following cities: London,
              England; Ontario, Canada; Paris, France; Perth, Australia;
              Edinburgh, Scotland.
            </li>
            <li>
              My plan included taking him to a nice—though not necessarily
              expensive—dinner; going to the park to look at the stars, which,
              by the way, are amazing this time of year; and serenading him with
              my accordion.
            </li>
          </ul>
        </div>
        <div class="col-12 mt-5">
          <h2>4. Use Semicolons with Conjunctive Adverbs</h2>

          <p>
            When you have a conjunctive adverb linking two independent clauses,
            you should use a semicolon. Some common conjunctive adverbs include
            <i style="font-weight: bold">
              moreover, nevertheless, however, otherwise, therefore, then,
              finally, likewise,
            </i>
            and <i style="font-weight: bold"> consequently. </i>
          </p>
          <br />
          <p class="examplFnt">Examples:</p>
          <ul class="example">
            <li>
              I needed to go for a walk and get some fresh air; also, I needed
              to buy milk. Reports of the damage caused by the hurricane were
              greatly exaggerated; indeed, the storm was not a “hurricane” at
              all.
            </li>
            <li>
              The students had been advised against walking alone at night;
              however, Cathy decided walking wasn’t dangerous if it was early in
              the evening.
            </li>
            <li>
              I’m not all that fond of the colours of tiger lilies; moreover,
              they don’t smell very good.
            </li>
          </ul>
        </div>
      </div>
    </div>
  </div>
</div>
<!--end semicolon-->

<!-- Slashes-->
<div class="mb-5" *ngIf="section === 'what-are-slashes'">
  <div class="container-fluid hero-long">
    <app-header></app-header>

    <div class="container modify-container">
      <div class="row">
        <div class="col-12 head-top">
          <nav aria-label="breadcrumb" class="mb-1">
            <ol class="breadcrumb">
              <li class="breadcrumb-item">
                <a [routerLink]="['/']">Home</a>
              </li>
              <li class="breadcrumb-item">
                <a [routerLink]="['/handbook']">Handbook</a>
              </li>
              <li class="breadcrumb-item">
                <a [routerLink]="['/handbook/punctuation']">Punctuation</a>
              </li>
              <li class="breadcrumb-item activebread">
                <a [routerLink]="['/what-are-slashes']">Slashes</a>
              </li>
            </ol>
          </nav>
          <h1 class="mb-2 heading">What Are Slashes (/)</h1>
          <p class="head-details">There are two types of slashes:</p>
          <span class="bold-text head-details"> backslash (\) </span>
          <span class="bold-text head-details"> forward slash (/)</span>
          <br />
          <p class="head-details">
            The backslash is used only for computer coding.The forward slash
            referred as a slash; is a punctuation mark used in English.
          </p>
        </div>
      </div>
    </div>
  </div>
  <div class="container-fluid">
    <div class="container">
      <div class="row justify-content-center">
        <div class="col-12">
          <h2 class="update">Use of slash:</h2>
          <br />
          <br />
          <h2>1. To Separate Lines in Prose</h2>
          <p>
            A slash can show a line break in a poem, song, or play, usually if
            several short lines are being written together on one long line.
          </p>
          <br />
          <p class="examplFnt">Examples:</p>
          <ul class="example">
            <li>
              Mary had a little lamb/ little lamb, little lamb/ Mary had a
              little lamb/ whose fleece was white as snow.
            </li>
            <li>Note that there is a space after each slash.</li>
          </ul>
        </div>
        <div class="col-12 mt-5">
          <h2>2. To Indicate Or</h2>

          <p>
            Often, when a slash is used in a formal or informal text, it is
            meant to indicate the word or.
          </p>
          <br />
          <p class="examplFnt">Examples:</p>
          <ul class="example">
            <li>
              When leaving the classroom, the teacher noticed that a student had
              left <i style="font-weight: bold"> his/her </i> backpack.
            </li>
            <li>
              College freshmen should bring a mattress and/or cot to sleep on
              during orientation.
            </li>
            <li>
              <i style="font-weight: bold">If/when </i> Mary ever shows up, we
              can all head out to the party together.
            </li>
          </ul>
        </div>
        <div class="col-12 mt-5">
          <h2>3. To Form Abbreviations</h2>

          <p>
            Slashes can also be used to form some abbreviations or shortened
            forms of words or phrases, although these should not be used in
            formal writing.
          </p>
          <br />
          <p class="examplFnt">Examples:</p>
          <ul class="example">
            <li><i style="font-weight: bold"> w/o </i> = without</li>
            <li>
              <i style="font-weight: bold">c/o </i> = care of (used when posting
              a letter or parcel)
            </li>
            <li><i style="font-weight: bold">a/c </i> = air conditioning</li>
            <li>
              Notice that in these cases, no space is necessary after the slash.
            </li>
          </ul>
        </div>
        <div class="col-12 mt-5">
          <h2>4. To Indicate Connecting and Conflicting Relationships</h2>

          <p>
            Slashes can also be used to note that there is a connection or
            conflict between two words or phrases in a sentence.
          </p>
          <br />
          <p class="examplFnt">Examples:</p>
          <ul class="example">
            <li>
              The
              <i style="font-weight: bold"> pro-life/pro-choice </i> debate is a
              hot-button issue for many voters this election.
            </li>
            <li>
              The designer often works in his bonus
              <i style="font-weight: bold"> room/home </i> office.
            </li>
          </ul>
        </div>
        <div class="col-12 mt-5">
          <h2>5. To Denote Dates and Fractions</h2>

          <p>
            One of the most commonly recognized usages of the forward slash is
            to indicate dates and fractions:
          </p>
          <br />
          <p class="examplFnt">Examples:</p>
          <ul class="example">
            <li><i style="font-weight: bold"> 1/2 </i> (one half)</li>
            <li><i style="font-weight: bold">2/3 </i> (two thirds)</li>
            <li><i style="font-weight: bold">9/10 </i> (nine tenths)</li>
            <li>
              On credit card: Expires end
              <i style="font-weight: bold"> 10/15 </i> (October 2015)
            </li>
            <li>
              He was born on <i style="font-weight: bold"> 30/11/2007</i>. (30th
              November 2007 – Br. Eng.)
            </li>
            <li>
              It was invented on <i style="font-weight: bold"> 11/30/2007</i>.
              (November 30th, 2007 – Am. Eng.)
            </li>
          </ul>
        </div>
        <div class="col-12 mt-5">
          <h2>6. To indicate ‘per’</h2>

          <p>
            Use a slash to indicate "per" in measurements of speed, prices etc.:
          </p>
          <br />
          <p class="examplFnt">Examples:</p>
          <ul class="example">
            <li>
              The speed limit is 100
              <i style="font-weight: bold"> km/h. </i> (kilometres per hour)
            </li>
            <li>
              He can type at 75 <i style="font-weight: bold"> w/m. </i> (words
              per minute)
            </li>
            <li>
              The eggs cost <i style="font-weight: bold"> $3/dozen. </i> ($3 per
              dozen)
            </li>
          </ul>
        </div>
        <div class="col-12 mt-5">
          <h2>7. To separate parts of website address:</h2>

          <p>
            The slash is used to separate parts of a website address (URL) on
            the Internet, and to separate folders on some computer systems.
          </p>
          <br />
          <p class="examplFnt">Examples:</p>
          <ul class="example">
            <li>www.example.com/writing/slash.htm</li>
            <li>file:///Users/mac/tara/photos/image.jpg</li>
          </ul>
        </div>
        <div class="col-12 mt-5">
          <h2>8. Space Before and After Slash</h2>

          <p>
            Spaces before and after slashes should be avoided. The only time it
            is acceptable to use a space after a slash is when breaking up lines
            of a poem, song, or play.
          </p>
          <p class="examplFnt">Examples:</p>
          <ul class="example">
            <li>www.example.com/writing/slash.htm</li>
            <li>file:///Users/mac/tara/photos/image.jpg</li>
            <li>The eggs cost $3/dozen. ($3 per dozen)</li>
          </ul>
        </div>
      </div>
    </div>
  </div>
</div>

<!--end Slashes-->

<!-- abbreviation-->
<div class="mb-5" *ngIf="section === 'what-is-abbreviation'">
  <div class="container-fluid hero-long">
    <app-header></app-header>

    <div class="container modify-container">
      <div class="row">
        <div class="col-12 head-top">
          <nav aria-label="breadcrumb" class="mb-1">
            <ol class="breadcrumb">
              <li class="breadcrumb-item">
                <a [routerLink]="['/']">Home</a>
              </li>
              <li class="breadcrumb-item">
                <a [routerLink]="['/handbook']">Handbook</a>
              </li>
              <li class="breadcrumb-item">
                <a [routerLink]="['/handbook/mechanics']">Mechanics</a>
              </li>
              <li class="breadcrumb-item activebread">
                <a [routerLink]="['/what-is-abbreviation']"
                  >What Is an Abbreviation</a
                >
              </li>
            </ol>
          </nav>
          <h1 class="mb-2 heading">What Is an Abbreviation</h1>
          <p class="py-3 head-details">
            An abbreviation is a short form of a word or phrase. Abbreviation
            serves various purposes in English language. Initialism is helpful
            in writing long names in short way, thus, saving space and makes it
            easy to read. It is also used to replace long cumbersome phrases and
            sentences. Some abbreviations are appropriate for informal writing
            but for formal writing, it is better to write whole word or phrase.
            If the abbreviation is obscure or unfamiliar, it is better to
            explain when using first time in your writing.
          </p>
        </div>
      </div>
    </div>
  </div>
  <div class="container-fluid">
    <div class="container">
      <div class="row justify-content-center">
        <div class="col-12">
          <h2 class="update">Acronyms and Initialisms</h2>
          <br />

          <p>
            Both acronyms and initialisms are abbreviations. These are formed by
            combining the first letter of each word in a longer name or phrase.
            Usually, acronyms and initialisms are written in all capital letters
            to distinguish them from ordinary words.
          </p>
          <p>
            Acronym and Initialism are pronounced differently. An acronym is
            pronounced as a single word, and people never thought it as an
            acronym.
          </p>
          <br />
          <p class="examplFnt">Examples:</p>
          <ul class="example">
            <li>
              <i style="font-weight: bold"> SWOT-</i> is an acronym that stands
              for <i style="font-weight: bold">S</i>trengths,
              <i style="font-weight: bold">W</i>eaknesses,
              <i style="font-weight: bold">O</i>pportunities,
              <i style="font-weight: bold">T</i>hreats.
            </li>
            <li>
              Unlike acronyms, however, initialisms are pronounced as a series
              of letters.
            </li>
          </ul>
          <br />
          <p class="examplFnt">Examples:</p>
          <ul class="example">
            <li>
              <i style="font-weight: bold"> ATM </i> (Automated Teller Machine)
              is pronounced A-T-M.
            </li>
            <li>
              Indefinite articles placed before acronym and initialism are
              according to the initial sound of the word rather first letter of
              the word.
            </li>
          </ul>
          <br />
          <p class="examplFnt">Examples:</p>
          <ul class="example">
            <li>An <i style="font-weight: bold">MBA </i> course.</li>
            <li>
              Initialisms such as
              <i style="font-weight: bold"> LOL, BRB, IDK, FYI </i> are slangs
              and inappropriate to use in formal such as professional, business
              or academic communication. However, these can be used in informal
              communication such as chatting or texting family and friends.
            </li>
          </ul>
          <br />
        </div>
        <div class="col-12 mt-5">
          <h2 class="update">
            Abbreviations for Courtesy Titles and Academic Degrees
          </h2>

          <p>
            Titles such as <i style="font-weight: bold"> mister, miss, </i> and
            <i style="font-weight: bold"> doctor, </i> also, the names of
            academic degrees such as
            <i style="font-weight: bold"> bachelor of arts </i> and
            <i style="font-weight: bold"> doctor of philosophy </i> are almost
            always abbreviated.
          </p>
          <p>
            In American English, title abbreviations are followed by a period;
            in British English, the period is omitted.
          </p>
          <p>The most common title abbreviations include:</p>
          <p>Mr. = Mister</p>
          <p>Mr. = Mister</p>
          <p>Ms. = (pronounced “miss” or “miz”)</p>
          <p>Sr. = Senior Jr. = Junior</p>
          <p>Dr. = Doctor</p>
          <br />
          <p class="examplFnt">Examples:</p>
          <ul class="example">
            <li>
              <i style="font-weight: bold"> Mr. Brown </i> asked
              <i style="font-weight: bold"> Ms. Jennie </i> if she had met
              <i style="font-weight: bold"> Dr. Jack. </i> (AmE)
            </li>
            <li>
              <i style="font-weight: bold">Mr Brown </i> asked
              <i style="font-weight: bold"> Ms Jennie </i> if she had met
              <i style="font-weight: bold"> Dr Jack. </i> (BrE)
            </li>
          </ul>

          <br />
          <p>The most common academic degree abbreviations include:</p>
          <br />
          <p class="examplFnt">Examples:</p>
          <ul class="example">
            <li>
              <i style="font-weight: bold">B.S. </i> = Bachelor of Science
            </li>
            <li><i style="font-weight: bold">B.A. </i> = Bachelor of Arts</li>
            <li><i style="font-weight: bold">M.A. </i> = Master of Arts</li>
            <li>
              <i style="font-weight: bold">M.B.A. </i> = Master of Business
              Administration
            </li>
            <li>
              <i style="font-weight: bold">Ph.D.</i> = Doctor of Philosophy
            </li>
          </ul>
          <br />
          <p>
            Placing periods with abbreviations is optional. Follow the style
            guide and be consistent with that throughout the document. When an
            academic degree is used like a title, it follows a person’s name and
            is set off by commas.
          </p>
          <br />
          <p class="examplFnt">Examples:</p>
          <ul class="example">
            <li>
              Mary Boland, <i style="font-weight: bold"> Ph.D., </i> read her
              paper in the conference in 1991.
            </li>
          </ul>
        </div>
        <div class="col-12 mt-5">
          <h2 class="update">Latin Abbreviations</h2>

          <p>
            Latin abbreviations are also a part of English language. Period is
            used with Latin abbreviations.
          </p>
          <br />
          <p>
            <i style="font-weight: bold"> e.g.: exempli gratia </i> means “for
            example.” <i style="font-weight: bold"> e.g. </i> is used to provide
            specific examples of a generalization.
          </p>
          <br />
          <p class="examplFnt">Examples:</p>
          <ul class="example">
            <li>
              Food allergies <i style="font-weight: bold"> e.g. </i> gluten
              allergy, nut allergy, fish allergy, dairy products must be
              considered in setting up a day nursery.

              <br />

              <i style="font-weight: bold">i.e.: id </i> est means “that is.”
              <i style="font-weight: bold"> i.e. </i> is used to make provided
              information more clear and specific.
            </li>
          </ul>
          <br />
          <p class="examplFnt">Examples:</p>
          <ul class="example">
            <li>
              Services are not offered on weekend
              <i style="font-weight: bold"> i.e. </i> Saturday and Sunday

              <br />

              <i style="font-weight: bold"> etc.: et cetera </i> means “and so
              forth.” <i style="font-weight: bold"> etc. </i> is used to provide
              few items of the detailed list.
            </li>
          </ul>
          <br />
          <p class="examplFnt">Examples:</p>
          <ul class="example">
            <li>
              Salon offers various services such as manicure, pedicure, facials
              <i style="font-weight: bold"> etc. </i>
            </li>
          </ul>
        </div>
        <div class="col-12 mt-5">
          <h2 class="update">Other Common Abbreviations</h2>

          <p>
            There are few other abbreviations that are common in English. Keep
            in mind, abbreviations do not follow standardized format. So be
            consistent with style guide you follow in your document. For
            example, few style guides advise period with abbreviations, few do
            not. However, it is always better to use period rather skipping
            them.
          </p>
        </div>
        <div class="col-12 mt-5">
          <h2>Times and dates</h2>

          <p>a.m. (ante meridiem) = before noon</p>
          <p>p.m. (post meridiem) = after noon</p>
          <p class="examplFnt">Examples:</p>
          <ul>
            <li>
              The school opens at 7<i style="font-weight: bold"> a.m. </i> and
              closes at 4 <i style="font-weight: bold"> p.m.</i>
            </li>
          </ul>
          <br />
          <h2>Months:</h2>

          <p>
            Jan., Feb., Mar., Apr., May, Jun., Jul., Aug., Sep., Oct., Nov.,
            Dec.
          </p>
          <p class="examplFnt">Examples:</p>
          <ul>
            <li>
              I started this job on <i style="font-weight: bold"> Mar.</i>18,
              1990.
            </li>
          </ul>
          <br />
          <h2>Days:</h2>

          <p>Mon., Tues., Wed., Thurs., Fri., Sat., Sun.</p>
          <p class="examplFnt">Examples:</p>
          <ul>
            <li>
              The setting will be closed from
              <i style="font-weight: bold"> Fri.-Sun. </i> each week.
            </li>
          </ul>
          <br />
          <h2>Places:</h2>
          <p>
            U.S. (United States) U.K. (United Kingdom) E.U. (European Union)
            U.A.E. (United Arab Emirates)
          </p>
          <p class="examplFnt">Examples:</p>
          <ul>
            <li>
              The flights from the <i style="font-weight: bold"> U.A.E </i> to
              the <i style="font-weight: bold"> U.K.</i> are banned for two
              months during pandemic.
            </li>
          </ul>
        </div>
        <div class="col-12 mt-5">
          <h2 class="update">Units of Measurement</h2>

          <p>in. (inches) ft. (feet) lbs. (pounds)</p>
          <p>mm. (millimetres) cm. (centimetres) m. (meters)</p>
          <p>mg. (milligram) g. (gram) kg. (kilogram)</p>
          <p class="examplFnt">Examples:</p>
          <ul class="example">
            <li>
              The parcel weighs 10 <i style="font-weight: bold"> lbs.</i>, which
              is about 4.5 <i style="font-weight: bold"> kg.</i>
            </li>
          </ul>
        </div>
      </div>
    </div>
  </div>
</div>
<!--end abbreviation-->
<!--	Contractions-->
<div class="mb-5" *ngIf="section === 'what-are-contractions'">
  <div class="container-fluid hero-Adjectives">
    <app-header></app-header>

    <div class="container modify-container">
      <div class="row">
        <div class="col-12 head-top">
          <nav aria-label="breadcrumb" class="mb-1">
            <ol class="breadcrumb">
              <li class="breadcrumb-item">
                <a [routerLink]="['/']">Home</a>
              </li>
              <li class="breadcrumb-item">
                <a [routerLink]="['/handbook']">Handbook</a>
              </li>
              <li class="breadcrumb-item">
                <a [routerLink]="['/handbook/mechanics']">Mechanics</a>
              </li>
              <li class="breadcrumb-item activebread">
                <a [routerLink]="['/what-are-contractions']"
                  >What Are Contractions</a
                >
              </li>
            </ol>
          </nav>
          <h1 class="mb-2 heading">What Are Contractions</h1>
          <p class="py-3 head-details">
            A contraction is short form of a word or group of words by omitting
            certain letters or sounds. Usually missing letter is denoted by an
            apostrophe. The most common contractions are made up of verbs,
            auxiliaries, or modals attached to other words:
          </p>
        </div>
      </div>
    </div>
  </div>
  <div class="container-fluid">
    <div class="container">
      <div class="row justify-content-center">
        <div class="col-12">
          <p class="examplFnt">Examples:</p>
          <div class="tips">
            <ul class="example">
              <li>
                He would=<i style="font-weight: bold">He’d.</i> I have=<i
                  style="font-weight: bold"
                  >I’ve.</i
                >
                They are=<i style="font-weight: bold">They’re. </i> You
                cannot=<i style="font-weight: bold">You can’t. </i>
              </li>
            </ul>
            <table id="newone" style="width: 70%">
              <tr style="background-color: #08ba99; color: white">
                <th style="text-align: center">Contraction</th>
                <th style="text-align: center">Uncontracted</th>
                <th style="text-align: center">Examples</th>
              </tr>
              <tr>
                <td>-n’t</td>
                <td>Not</td>
                <td>Isn’t (is not), hasn’t (has not)</td>
              </tr>
              <tr>
                <td>-’re</td>
                <td>Are</td>
                <td>They’re (they are), we’re (we are), you’re (you are)</td>
              </tr>
              <tr>
                <td>-’d</td>
                <td>had, would</td>
                <td>She’d (she had, she would), I’d (I had, I would)</td>
              </tr>
              <tr>
                <td>-’ll</td>
                <td>Will</td>
                <td>We’ll (we will), you’ll (you will)</td>
              </tr>
              <tr>
                <td>-’s</td>
                <td>Is</td>
                <td>He’s (he is), it’s (it is)</td>
              </tr>
              <tr>
                <td>I’m</td>
                <td>I am</td>
                <td>—</td>
              </tr>
              <tr>
                <td>let’s</td>
                <td>let us</td>
                <td>—</td>
              </tr>
            </table>
            <br />
          </div>
        </div>
        <div class="col-12 mt-5">
          <h2 class="update">Other Contractions</h2>

          <p>
            Some contractions are less common and part of a particular style of
            speech. So, writers use them to represent that specific style of
            speech.

            <br />
            <br />
          </p>

          <p class="examplFnt">Examples:</p>
          <div class="tips">
            <ul class="example">
              <li>
                Writers sometimes write somethin’ instead of ‘something’ as
                people quite often do not pronounce ‘g’ in speech.
              </li>
              <li>Quite often, in poetry e’er (instead of ever) is written.</li>
              <li>
                Similarly, <i style="font-weight: bold">y’all</i> (you all),
                <i style="font-weight: bold">kinda</i> (kind of),
                <i style="font-weight: bold">gottcha</i> (got you),
                <i style="font-weight: bold"> gonna</i> (going to),
                <i style="font-weight: bold"> wanna </i> (want to) are
                frequently used contractions.
              </li>
              <li>
                Decade names are often contracted as well: the
                <i style="font-weight: bold"> ’60s</i> (the 1960s).
              </li>
              <li>
                Such contractions are mostly part of an informal writing and
                fiction writing. Whereas, in formal writing, such contractions
                must be avoided to sound more serious and accurate except
                o’clock.
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

<!--end Contractions-->

<!--Modifiers-->

<div class="mb-5" *ngIf="section === 'what-are-spelling-rules'">
  <div class="container-fluid hero-long">
    <app-header></app-header>

    <div class="container modify-container">
      <div class="row">
        <div class="col-12 head-top">
          <nav aria-label="breadcrumb" class="mb-1">
            <ol class="breadcrumb">
              <li class="breadcrumb-item">
                <a [routerLink]="['/']">Home</a>
              </li>
              <li class="breadcrumb-item">
                <a [routerLink]="['/handbook']">Handbook</a>
              </li>
              <li class="breadcrumb-item">
                <a [routerLink]="['/handbook/mechanics']">Mechanics</a>
              </li>
              <li class="breadcrumb-item activebread">
                <a [routerLink]="['/what-are-spelling-rules']"
                  >What Are Spelling Rules</a
                >
              </li>
            </ol>
          </nav>
          <h1 class="mb-2 heading">What Are Spelling Rules</h1>
          <p class="py-3 head-details">
            Spellings are hard to learn. Reasons are many. Few are added from
            other languages such as chandelier and chauffeur (derived from
            French) so they are pronounced differently and spelt differently.
          </p>
        </div>
      </div>
    </div>
  </div>
  <div class="container-fluid">
    <div class="container">
      <div class="row justify-content-center">
        <div class="col-12">
          <!-- <h2 class="mb-3 update">Spelling Rules</h2> -->
          <p>
            Whereas, many letters are not pronounced but they are part of
            spellings such as knife, knee, hour. In all these words k and h as a
            beginning sound are not pronounced and silent, yet, they are part of
            spelling.
          </p>

          <p>
            That makes spelling tricky and hard to memorize. This is not all.
            British and American spelling for the same word makes spellings more
            confusing.
          </p>
          <p>
            Nevertheless, there are few rules to memorize and accurate your
            spellings.
          </p>
          <p>
            Although these are not hard and fast rules. Exception is always
            there. However, these are helpful to spell many.
          </p>
        </div>
        <div class="col-12 mt-5">
          <h2 class="update">Spelling Rule 1</h2>
          <p>I before E, Except After C. The rule goes like this:</p>
          <p>
            I before E, Except after C, unless it sounds like A, as in neighbour
            or weigh.
          </p>

          <h2>I before E:</h2>
          <p>
            pieces, believe, field, Species, achieve, cashier, shriek, grief,
            chief
          </p>
          <h2>Except before C:</h2>
          <p>received, ceiling, deceitful, perceive, receipt, conceive</p>
          <h2>Unless it sounds like A</h2>
          <p>height, forfeit, foreign, seizure, weight, weird</p>
        </div>
        <div class="col-12 mt-5">
          <h2 class="update">Spelling Rule 2</h2>
          <p>Adding Suffixes to Words that End in Y</p>
          <p>
            When a suffix that starts with e (-ed, -er, -est) is added to a word
            that ends with y, Y is changed to I
          </p>
          <br />
          <p class="examplFnt">Examples:</p>
          <ul class="example">
            <li>Cry – cried – crier</li>
            <li>Dry – dried – drier</li>
            <li>Lay – laid (note the irregular spelling: no E)</li>
            <li>Baby – babies</li>
            <li>Family – families</li>
            <li>Ugly – ugliest</li>
          </ul>
          <h2>The Y doesn’t change for the suffix -ing.</h2>
          <p>
            crying, laying, tidying, mortifying, lying, annoying, glorifying,
            underlying.
          </p>
          <h2>Y changes to I when added suffix –ly</h2>
          <br />
          <p class="examplFnt">Examples:</p>
          <ul class="example">
            <li>Sloppy – sloppily</li>
            <li>Happy – happily</li>
            <li>Scary – scarily</li>
            <li>happy – happily</li>
            <li>angry- angrily</li>
          </ul>
          <h2>Exceptions:</h2>
          <p>dryly, wryly</p>
        </div>
        <div class="col-12 mt-5">
          <h2 class="update">Spelling Rule 3</h2>
          <p>The Silent E</p>
          <p>
            Usually, E at the end of the word is silent if preceded by
            consonant.
          </p>
          <br />
          <p class="examplFnt">Examples:</p>
          <ul class="example">
            <li>like, mike, bite.</li>
          </ul>
          <br />
          <p>
            However, the sound of vowel letter placed before the consonant is
            changed from short vowel sound to long vowel sound.
          </p>
          <br />
          <p class="examplFnt">Examples:</p>
          <ul class="example">
            <li>
              <i style="font-weight: bold">bit</i> (short vowel sound of I)
              pronounced as <i style="font-weight: bold"> bite</i> (long vowel
              sound of I).
            </li>
            <li>
              <i style="font-weight: bold">sit</i> (short vowel sound of I)
              pronounced as<i style="font-weight: bold"> site</i> (long vowel
              sound of I).
            </li>
          </ul>
          <br />
          <p>
            Therefore, the presence or absence of e in the end changes the
            meaning and pronunciation of the word.
          </p>
          <br />
          <p class="examplFnt">Examples:</p>
          <ul class="example">
            <li>
              Children waved <i style="font-weight: bold">bye </i> to their
              grandparents. He arrived at my place
              <i style="font-weight: bold"> by</i> car.
            </li>
            <li>
              You <i style="font-weight: bold"> can </i> do this. Sugar<i
                style="font-weight: bold"
                >cane</i
              >
              is one of the famous crops in this area.
            </li>
          </ul>
          <br />
          <p>
            If suffix <i style="font-weight: bold"> –ed. –er, -est</i> is added,
            silent <i style="font-weight: bold">E</i> is dropped.
          </p>
          <br />
          <p class="examplFnt">Examples:</p>
          <ul class="example">
            <li>His attitude <i style="font-weight: bold"> flared </i> her.</li>
            <li>
              Film<i style="font-weight: bold">maker</i> invested a lot in this
              movie.
            </li>
            <li>
              She is the <i style="font-weight: bold"> cutest </i> baby in this
              hall.
            </li>
          </ul>
        </div>
        <div class="col-12 mt-5">
          <h2 class="update">Spelling Rule 4</h2>
          <p>Double Consonants</p>
          <p>
            Double consonants are not pronounced separately rather as one sound.
          </p>
          <br />
          <p class="examplFnt">Examples:</p>
          <ul class="example">
            <li>blessed, baggage, footage</li>
          </ul>
          <br />
          <p>Usually consonants are double when suffix is added to them.</p>
          <br />
          <p class="examplFnt">Examples:</p>
          <ul class="example">
            <li>dropped, begged, flipped.</li>
          </ul>

          <br />
          <p>
            In some words, double consonants change the meaning and
            pronunciation of the word.
          </p>
          <br />
          <p class="examplFnt">Examples:</p>
          <ul class="example">
            <li>desert and dessert,</li>
            <li>in and inn,</li>
            <li>diner and dinner.</li>
          </ul>
        </div>
        <div class="col-12 mt-5">
          <h2 class="update">Spelling Rule 5</h2>
          <p>Plural Suffixes</p>
          <p>
            When a singular noun is changed to plural there are few rules to
            change the spellings.
          </p>
          <p>
            If a noun ends in an <i style="font-weight: bold"> s, sh, ch </i> or
            <i style="font-weight: bold"> x</i> then just add an e and an s on
            the end of the word.
          </p>
          <p>
            A useful way to remember this, is that words ending with a
            ‘hissing’, ‘buzzing’ or ‘whooshing’ sound end in an es when they
            become plural.
          </p>
          <br />
          <p class="examplFnt">Examples:</p>
          <ul class="example">
            <li>
              <i style="font-weight: bold">bus</i> becomes
              <i style="font-weight: bold">buses</i>
            </li>
            <li>
              <i style="font-weight: bold">box</i> becomes
              <i style="font-weight: bold">boxes</i>
            </li>
            <li>
              <i style="font-weight: bold">church</i> becomes
              <i style="font-weight: bold">churches</i>
            </li>
            <li>
              <i style="font-weight: bold">dish</i> becomes
              <i style="font-weight: bold">dishes</i>
            </li>
          </ul>
          <p>
            If a noun ends in a consonant and then an o you just add es to the
            end of the word.
          </p>
          <br />
          <p class="examplFnt">Examples:</p>
          <ul class="example">
            <li>
              <i style="font-weight: bold">volcano</i> becomes
              <i style="font-weight: bold">volcanoes</i>
            </li>
            <li>
              <i style="font-weight: bold">hero</i> becomes
              <i style="font-weight: bold">heroes</i>
            </li>
            <li>
              <i style="font-weight: bold">echo</i> becomes
              <i style="font-weight: bold">echoes</i>
            </li>
          </ul>
          <p>
            If a noun ends in a consonant and then a
            <i style="font-weight: bold">‘y’</i> then the y is removed and an
            ies is added.
          </p>
          <br />
          <p class="examplFnt">Examples:</p>
          <ul class="example">
            <li>
              <i style="font-weight: bold">army</i> becomes
              <i style="font-weight: bold">armies</i>
            </li>
            <li>
              <i style="font-weight: bold">story</i> becomes
              <i style="font-weight: bold">stories</i>
            </li>
            <li>
              <i style="font-weight: bold">berry</i> becomes
              <i style="font-weight: bold">berries</i>
            </li>
          </ul>
          <p>
            If a noun ends in an <i style="font-weight: bold">‘f’</i> or
            <i style="font-weight: bold">‘fe’</i> it is usually replaced with a
            ves ending.
          </p>
          <br />
          <p class="examplFnt">Examples:</p>
          <ul class="example">
            <li>
              <i style="font-weight: bold">half</i> becomes
              <i style="font-weight: bold">halves</i>
            </li>
            <li>
              <i style="font-weight: bold">life</i> becomes
              <i style="font-weight: bold">lives</i>
            </li>
            <li>
              <i style="font-weight: bold">scarf</i> becomes
              <i style="font-weight: bold">scarves</i>
            </li>
          </ul>
          <p>
            However, there are also some plural nouns that are irregular and
            don’t follow this rule.
          </p>
          <br />
          <p class="examplFnt">Examples:</p>
          <ul class="example">
            <li>
              <i style="font-weight: bold">belief</i> becomes
              <i style="font-weight: bold">beliefs</i>
            </li>
            <li>
              <i style="font-weight: bold">chef</i> becomes
              <i style="font-weight: bold">chefs</i>
            </li>
          </ul>
        </div>
      </div>
    </div>
  </div>
</div>
<!--End modifiers-->

<!-- 	Compound -->
<div class="mb-5" *ngIf="section === 'what-are-compound-words'">
  <div class="container-fluid hero-Adjectives">
    <app-header></app-header>

    <div class="container modify-container">
      <div class="row">
        <div class="col-12 head-top">
          <nav aria-label="breadcrumb" class="mb-1">
            <ol class="breadcrumb">
              <li class="breadcrumb-item">
                <a [routerLink]="['/']">Home</a>
              </li>
              <li class="breadcrumb-item">
                <a [routerLink]="['/handbook']">Handbook</a>
              </li>
              <li class="breadcrumb-item">
                <a [routerLink]="['/handbook/mechanics']">Mechanics</a>
              </li>
              <li class="breadcrumb-item activebread">
                <a [routerLink]="['/what-are-compound-words']"
                  >What Are Compound Words</a
                >
              </li>
            </ol>
          </nav>
          <h1 class="mb-2 heading">What Are Compound Words</h1>
          <p class="py-3 head-details">
            The words that are written together to produce a new meaning are
            called compound words. There are three ways to write compound words:
          </p>
        </div>
      </div>
    </div>
  </div>
  <div class="container-fluid">
    <div class="container">
      <div class="row justify-content-center">
        <div class="col-12">
          <h2 class="update">Open compound words (spelled as two words)</h2>
          <br />
          <p class="examplFnt">Examples:</p>
          <ul class="example">
            <li>real estate, high school</li>
          </ul>
        </div>
        <div class="col-12 mt-5">
          <h2 class="update">
            Closed compound words (spelled as one word no pace between two
            words)
          </h2>
          <br />
          <p class="examplFnt">Examples:</p>
          <ul class="example">
            <li>sunflower, farmhouse</li>
          </ul>
        </div>
        <div class="col-12 mt-5">
          <h2 class="update">
            Hyphenated compound words (words are joined by hyphen)
          </h2>
          <br />
          <p class="examplFnt">Examples:</p>
          <ul class="example">
            <li>father-in-law, seventy-two, check-in</li>
          </ul>
        </div>
      </div>
    </div>
  </div>
</div>
<!--end Compound -->

<!-- 	Capitalization -->
<div class="mb-5" *ngIf="section === 'what-is-capitalization'">
  <div class="container-fluid hero-Adjectives">
    <app-header></app-header>

    <div class="container modify-container">
      <div class="row">
        <div class="col-12 head-top">
          <nav aria-label="breadcrumb" class="mb-1">
            <ol class="breadcrumb">
              <li class="breadcrumb-item">
                <a [routerLink]="['/']">Home</a>
              </li>
              <li class="breadcrumb-item">
                <a [routerLink]="['/handbook']">Handbook</a>
              </li>
              <li class="breadcrumb-item">
                <a [routerLink]="['/handbook/mechanics']">Mechanics</a>
              </li>
              <li class="breadcrumb-item activebread">
                <a [routerLink]="['/what-is-capitalization']"
                  >What is Capitalization</a
                >
              </li>
            </ol>
          </nav>
          <h1 class="mb-2 heading">What is Capitalization</h1>
          <p class="py-3 head-details">
            Capitalization is the practice of writing the first letter of a word
            in uppercase while keeping the rest in lowercase, typically used for
            proper nouns, the first word of a sentence, titles, and certain
            stylistic purposes.
          </p>
        </div>
      </div>
    </div>
  </div>
  <div class="container-fluid">
    <div class="container">
      <div class="row justify-content-center">
        <div class="col-12">
          <h2 class="mb-3 update">English Capitalization Rules:</h2>
        </div>
        <div class="col-12 mt-5">
          <h2 class="update">Begin sentence with capital letter</h2>
          <p>
            Always capitalize the first letter of the first word in a sentence.
          </p>
          <br />
          <p class="examplFnt">Examples:</p>
          <ul class="example">
            <li><i style="font-weight: bold"> The</i> dog is barking.</li>
            <li><i style="font-weight: bold">How</i> are you?</li>
            <li>
              <i style="font-weight: bold">Hurray!</i> You did it! How did you
              do it?
            </li>
          </ul>
        </div>
        <div class="col-12 mt-5">
          <h2 class="update">Capitalize Proper Nouns</h2>
          <p>Proper Nouns are names.</p>
          <br />
          <p class="examplFnt">Examples:</p>
          <ul class="example">
            <li>
              <i style="font-weight: bold"> People’s Names:</i> Charles Dickens,
              Emily Bronte
            </li>
            <li>
              <i style="font-weight: bold">Cities’ Names:</i> London, New York,
              Jeddah
            </li>
            <li>
              <i style="font-weight: bold">Countries’ Names:</i> England,
              Pakistan, Australia
            </li>
            <li>
              <i style="font-weight: bold">Companies’ Names:</i> Boots,
              Sketchers
            </li>
            <li>
              <i style="font-weight: bold">Religions’ Names:</i> Islam,
              Christianity
            </li>
            <li>
              <i style="font-weight: bold">Political Parties:</i> Labour,
              Democratic
            </li>
            <li>
              <i style="font-weight: bold">Nationalities:</i> Dutch, French,
              American, Arab
            </li>
            <li>
              <i style="font-weight: bold">Languages:</i> English, Urdu,
              Romanian
            </li>
          </ul>
          <p>
            When Mom and grandpa are used to address them, they should be
            capitalized too.
          </p>
          <br />
          <p class="examplFnt">Examples:</p>
          <ul class="example">
            <li>Look, Mom I did it.</li>
          </ul>
          <h2>But</h2>
          <p>My mom will not appreciate this.</p>
        </div>
        <div class="col-12 mt-5">
          <h2 class="update">Don’t Capitalize After a Colon</h2>
          <p>Usually, words are not capitalized after colon</p>
          <br />
          <p class="examplFnt">Example:</p>
          <ul class="example">
            <li>I have only thing in my box: earrings.</li>
          </ul>
          <p>
            However, if proper noun is used after colon then it will be in
            capital letter.
          </p>
          <br />
          <p class="examplFnt">Example:</p>
          <ul class="example">
            <li>There is only one place I want to visit: Paris</li>
          </ul>
        </div>

        <div class="col-12 mt-5">
          <h2 class="update">Capitalize the First Word of a Quote</h2>
          <p>
            Capitalize the first letter of the word when the quote is a complete
            sentence.
          </p>
          <br />
          <p class="examplFnt">Example:</p>
          <ul class="example">
            <li>Mary asked, “Who discovered America?”</li>
            <li>Do not capitalize the first word of partial quotes.</li>
          </ul>
          <br />
          <p class="examplFnt">Example:</p>
          <ul class="example">
            <li>Greta said she was “not free” to attend the meeting.</li>
          </ul>
        </div>
        <div class="col-12 mt-5">
          <h2 class="update">
            Capitalize Days, Months, and Holidays, But Not Seasons
          </h2>
          <p>
            The names of days, months, and holidays are proper nouns. So, they
            are capitalized.
          </p>
          <br />
          <p class="examplFnt">Example:</p>
          <ul class="example">
            <li>
              My <i style="font-weight: bold"> Mondays</i> are always busy.
            </li>
            <li>My birthday is in <i style="font-weight: bold">March.</i></li>
            <li>
              <i style="font-weight: bold">London</i> looks beautiful during
              <i style="font-weight: bold">Christmas</i> holidays.
            </li>
            <li>I love snowfall in <i style="font-weight: bold">winter.</i></li>
          </ul>
        </div>

        <div class="col-12 mt-5">
          <h2 class="update">Capitalize Most Words in Titles</h2>
          <p>
            The titles for books, movies and other works are capitalized. In
            general, the first letter of all the words in title should be
            capitalized, except prepositions, conjunctions and articles.
          </p>
          <br />
          <p class="examplFnt">Examples:</p>
          <ul class="example">
            <li>
              <i style="font-weight: bold"> The Doll’s House</i> by
              <i style="font-weight: bold"> Ibsen</i> is my favourite.
            </li>
            <li>
              <i style="font-weight: bold">The Lord of the Rings</i> is a binge
              watch.
            </li>
          </ul>
        </div>
        <div class="col-12 mt-5">
          <h2 class="update">Capitalize Time Periods and Events (Sometimes)</h2>
          <p>
            Specific periods, and historical events that have proper names
            should be capitalized.
          </p>
          <br />
          <p class="examplFnt">Examples:</p>
          <ul class="example">
            <li>
              Most of the
              <i style="font-weight: bold"> World War II</i> veterans are now
              deceased.
            </li>
            <li>
              In the <i style="font-weight: bold"> Victorian era,</i> role of
              women was limited to domestic responsibilities and raising
              children.
            </li>
          </ul>
          <br />
          <p>
            However, centuries—and the numbers before them—are not capitalized.
          </p>
          <br />
          <p class="examplFnt">Examples:</p>
          <ul class="example">
            <li>
              In <i style="font-weight: bold"> nineteenth century</i> role of ,
              women were given the right to vote.
            </li>
          </ul>
        </div>
      </div>
    </div>
  </div>
</div>
<!--end Capitalization -->

<!-- 	Satire -->
<div class="mb-5" *ngIf="section === 'what-is-satire'">
  <div class="container-fluid hero-Adjectives">
    <app-header></app-header>

    <div class="container modify-container">
      <div class="row">
        <div class="col-12 head-top">
          <nav aria-label="breadcrumb" class="mb-1">
            <ol class="breadcrumb">
              <li class="breadcrumb-item">
                <a [routerLink]="['/']">Home</a>
              </li>
              <li class="breadcrumb-item">
                <a [routerLink]="['/handbook']">Handbook</a>
              </li>
              <li class="breadcrumb-item">
                <a [routerLink]="['/handbook/techniques']">Techniques</a>
              </li>
              <li class="breadcrumb-item activebread">
                <a [routerLink]="['/what-is-satire']">What Is Satire</a>
              </li>
            </ol>
          </nav>
          <h1 class="mb-2 heading">What Is Satire</h1>
          <p class="py-3 head-details">
            The formal definition of satire is “the use of humour, irony,
            exaggeration, or ridicule to expose and criticize people’s stupidity
            or vices.” It is an extremely broad category. The most satires are
            humorous, ironic, and exaggerated, but necessarily they have to make
            fun of a person, idea, or institution and its purpose is not just to
            entertain, but also to inform or make people think.
          </p>
        </div>
      </div>
    </div>
  </div>
  <div class="container-fluid">
    <div class="container">
      <div class="row justify-content-center">
        <div class="col-12">
          <p class="examplFnt">Example:</p>
          <ul class="example">
            <li>
              The famous comic strip Calvin & Hobbes was renowned for its
              satire. The comic takes on everything from politics and science to
              parenting. Calvin himself satirizes selfish, lazy, media-saturated
              Americans, while his father satirizes the opposite extreme.
            </li>
          </ul>
        </div>
      </div>
    </div>
  </div>
</div>
<!--end Satire -->

<!-- 	Suspense -->
<div class="mb-5" *ngIf="section === 'what-is-suspense'">
  <div class="container-fluid hero-Adjectives">
    <app-header></app-header>

    <div class="container modify-container">
      <div class="row">
        <div class="col-12 head-top">
          <nav aria-label="breadcrumb" class="mb-1">
            <ol class="breadcrumb">
              <li class="breadcrumb-item">
                <a [routerLink]="['/']">Home</a>
              </li>
              <li class="breadcrumb-item">
                <a [routerLink]="['/handbook']">Handbook</a>
              </li>
              <li class="breadcrumb-item">
                <a [routerLink]="['/handbook/techniques']">Techniques</a>
              </li>
              <li class="breadcrumb-item activebread">
                <a [routerLink]="['/what-is-suspense']">What Is Suspense</a>
              </li>
            </ol>
          </nav>
          <h1 class="mb-2 heading">What Is Suspense</h1>
          <p class="py-3 head-details">
            No matter what type of story you are telling, suspense is a valuable
            tool for keeping a reader’s attention and interest. Building
            suspense involves withholding information and raising key questions
            that pique readers’ curiosity. Character development plays a big
            role in generating suspense.
          </p>
        </div>
      </div>
    </div>
  </div>

  <div class="container-fluid">
    <div class="container">
      <div class="row justify-content-center">
        <div class="col-12">
          <p class="examplFnt">Example:</p>
          <ul class="example">
            <li>
              if a character’s desire is not fulfilled by the end of the book,
              the story will not feel complete for the reader.
            </li>
          </ul>
        </div>
      </div>
    </div>
  </div>
</div>
<!--end Suspense -->

<!-- 	Symbol -->
<div class="mb-5" *ngIf="section === 'what-is-a-symbol'">
  <div class="container-fluid hero-Adjectives">
    <app-header></app-header>

    <div class="container modify-container">
      <div class="row">
        <div class="col-12 head-top">
          <nav aria-label="breadcrumb" class="mb-1">
            <ol class="breadcrumb">
              <li class="breadcrumb-item">
                <a [routerLink]="['/']">Home</a>
              </li>
              <li class="breadcrumb-item">
                <a [routerLink]="['/handbook']">Handbook</a>
              </li>
              <li class="breadcrumb-item">
                <a [routerLink]="['/handbook/techniques']">Techniques</a>
              </li>
              <li class="breadcrumb-item activebread">
                <a [routerLink]="['/what-is-a-symbol']">What Is a Symbol</a>
              </li>
            </ol>
          </nav>
          <h1 class="mb-2 heading">What Is a Symbol</h1>
          <p class="py-3 head-details">
            A symbol (pronounced SIM-bull) is any image or thing that stands for
            something else. It could be as simple as a letter, which is a symbol
            for a given sound (or set of sounds).
          </p>
        </div>
      </div>
    </div>
  </div>
  <div class="container-fluid">
    <div class="container">
      <div class="row justify-content-center">
        <div class="col-12">
          <p>
            Similarly, every word is a symbol for the idea it represents. Flags
            are symbols for nations. And of course, we have all sorts of visual
            symbols that we use every day: $ & =
          </p>
          <p>
            Similarly, flowers might symbolize beauty of nature. Einstein
            symbolizes genius in our culture. In literature, Symbolism is a
            literary device that uses symbols, be they words, people, marks,
            locations, or abstract ideas to represent something beyond the
            literal meaning.
          </p>
          <br />
          <p class="examplFnt">Example:</p>
          <ul class="example">
            <li>
              In Greek mythology, the gods are all symbols for forces of nature
              – for example, Poseidon is a symbol for the sea. He is extremely
              powerful, but also wrathful and unpredictable. By telling stories
              of Poseidon’s vengeful fury, the Greeks (who were not great
              shipbuilders) symbolically delivered a message about how dangerous
              the sea can be.
            </li>
          </ul>
        </div>
      </div>
    </div>
  </div>
</div>
<!--end Symbol -->

<!-- Vignette -->
<div class="mb-5" *ngIf="section === 'what-is-vignette'">
  <div class="container-fluid hero-Adjectives">
    <app-header></app-header>

    <div class="container modify-container">
      <div class="row">
        <div class="col-12 head-top">
          <nav aria-label="breadcrumb" class="mb-1">
            <ol class="breadcrumb">
              <li class="breadcrumb-item">
                <a [routerLink]="['/']">Home</a>
              </li>
              <li class="breadcrumb-item">
                <a [routerLink]="['/handbook']">Handbook</a>
              </li>
              <li class="breadcrumb-item">
                <a [routerLink]="['/handbook/techniques']">Techniques</a>
              </li>
              <li class="breadcrumb-item activebread">
                <a [routerLink]="['/what-is-vignette']">What Is Vignette</a>
              </li>
            </ol>
          </nav>
          <h1 class="mb-2 heading">What Is Vignette</h1>
          <p class="py-3 head-details">
            Notably, the word vignette comes from the French vigne meaning
            “little vine,” and the term specifically arose for the small vines
            drawn on the pages of printed texts.
          </p>
        </div>
      </div>
    </div>
  </div>
  <div class="container-fluid">
    <div class="container">
      <div class="row justify-content-center">
        <div class="col-12">
          <h2 class="mb-3 update">Vignette</h2>
          <p>(pronounced vin-yet)</p>
          <!-- <p>
            Notably, the word vignette comes from the French vigne meaning
            “little vine,” and the term specifically arose for the small vines
            drawn on the pages of printed texts.
          </p> -->
          <p>
            In literature, a <i style="font-weight: bold"> vignette </i> is a
            short scene that captures a single moment or a defining detail about
            a character, idea, or other element of the story. Vignettes are
            mostly descriptive. Vignettes are small parts of a larger work, and
            can only exist as pieces of a whole story.
          </p>
          <br />
          <p class="examplFnt">Example:</p>
          <ul class="example">
            <li>
              The room was warm and stuffy, but in a comforting way. It had the
              heavy but pleasing odor of musty books and old upholstery, with an
              overall air of ash and cedar from the fire that was always burning
              low the stone hearth, crackling and spitting quietly. There was a
              patchwork blanket resting over the side of the sunken but cozy
              couch, its squares tattered by the love and wear of time. A wooden
              clock ticked reliably on the wall.
            </li>
          </ul>
        </div>
      </div>
    </div>
  </div>
</div>
<!--end Vignette -->

<!-- Hyperbole -->
<div class="mb-5" *ngIf="section === 'what-is-hyperbole'">
  <div class="container-fluid hero-Adjectives">
    <app-header></app-header>

    <div class="container modify-container">
      <div class="row">
        <div class="col-12 head-top">
          <nav aria-label="breadcrumb" class="mb-1">
            <ol class="breadcrumb">
              <li class="breadcrumb-item">
                <a [routerLink]="['/']">Home</a>
              </li>
              <li class="breadcrumb-item">
                <a [routerLink]="['/handbook']">Handbook</a>
              </li>
              <li class="breadcrumb-item">
                <a [routerLink]="['/handbook/techniques']">Techniques</a>
              </li>
              <li class="breadcrumb-item activebread">
                <a [routerLink]="['/what-is-hyperbole']">What Is Hyperbole</a>
              </li>
            </ol>
          </nav>
          <h1 class="mb-2 heading">What Is Hyperbole</h1>
          <p class="py-3 head-details">
            (pronounced hi-PER-buh-lee)
            <br />
            Hyperbole is a type of a figurative language. Often metaphors and
            simile incorporate hyperbole. The writers use this technique to make
            their writing engaging, funny and livelier. Hyperbole is an
            exaggeration to create humour effect and should not be taken on
            literal meaning. Many idioms are also hyperboles.
          </p>
        </div>
      </div>
    </div>
  </div>
  <div class="container-fluid">
    <div class="container">
      <div class="row justify-content-center">
        <div class="col-12">
          <p class="examplFnt">Example:</p>
          <ul class="example">
            <li>Compare both sentences.</li>
            <li>Alex is very hungry.</li>
            <li>
              Alex is so hungry that he will eat a horse.
              <i style="font-weight: bold"> (hyperbole)</i>
            </li>

            <p>Other common hyperboles:</p>
            <li>I have seen the world.</li>
            <li>Best thing ever happened.</li>
          </ul>
        </div>
      </div>
    </div>
  </div>
</div>
<!--end Hyperbole -->

<!-- Onomatopoeia Words -->
<div class="mb-5" *ngIf="section === 'what-are-onomatopoeia-words'">
  <div class="container-fluid hero-short">
    <app-header></app-header>

    <div class="container modify-container">
      <div class="row">
        <div class="col-12 head-top">
          <nav aria-label="breadcrumb" class="mb-1">
            <ol class="breadcrumb">
              <li class="breadcrumb-item">
                <a [routerLink]="['/']">Home</a>
              </li>
              <li class="breadcrumb-item">
                <a [routerLink]="['/handbook']">Handbook</a>
              </li>
              <li class="breadcrumb-item">
                <a [routerLink]="['/handbook/techniques']">Techniques</a>
              </li>
              <li class="breadcrumb-item activebread">
                <a [routerLink]="['/what-are-onomatopoeia-words']"
                  >What Are Onomatopoeia Words</a
                >
              </li>
            </ol>
          </nav>
          <h1 class="mb-2 heading">What Are Onomatopoeia Words</h1>
          <p class="py-3 head-details">
            The words denoted to the sounds produced by various things and
            beings are called onomatopoeia words.
          </p>
        </div>
      </div>
    </div>
  </div>
  <div class="container-fluid">
    <div class="container">
      <div class="row justify-content-center">
        <div class="col-12">
          <p class="examplFnt">Example:</p>
          <ul class="example">
            <li>
              <i style="font-weight: bold"> Machine noises</i>—honk, beep,
              vroom, clang, zap, boing.
            </li>
            <li>
              <i style="font-weight: bold">Animal names</i>—cuckoo,
              whip-poor-will, whooping crane, chickadee.
            </li>
            <li>
              <i style="font-weight: bold">Impact sounds</i>—boom, crash, whack,
              thump, bang.
            </li>

            <li>
              Sounds of the voice—shush, giggle, growl, whine, murmur, blurt,
              whisper, hiss.
            </li>
          </ul>
          <p>
            Using onomatopoeia words give writing more vivid imagery and helps
            reader to visualize the happening through auditory imagery.
          </p>
          <br />
          <p class="examplFnt">Example:</p>
          <ul class="example">
            <li>Little girl <i style="font-weight: bold"> giggled.</i></li>
            <li>
              The door closed with a <i style="font-weight: bold"> bang. </i>
            </li>
          </ul>
        </div>
      </div>
    </div>
  </div>
</div>
<!--end Onomatopoeia Words -->

<!-- Collocations -->
<div class="mb-5" *ngIf="section === 'what-are-collocations'">
  <div class="container-fluid hero-short">
    <app-header></app-header>

    <div class="container modify-container">
      <div class="row">
        <div class="col-12 head-top">
          <nav aria-label="breadcrumb" class="mb-1">
            <ol class="breadcrumb">
              <li class="breadcrumb-item">
                <a [routerLink]="['/']">Home</a>
              </li>
              <li class="breadcrumb-item">
                <a [routerLink]="['/handbook']">Handbook</a>
              </li>
              <li class="breadcrumb-item">
                <a [routerLink]="['/handbook/techniques']">Techniques</a>
              </li>
              <li class="breadcrumb-item activebread">
                <a [routerLink]="['/what-are-collocations']"
                  >What Are Collocations</a
                >
              </li>
            </ol>
          </nav>
          <h1 class="mb-2 heading">What Are Collocations</h1>
          <p class="py-3 head-details">
            The way Native speakers combine words to express certain meaning to
            their thought is called collocation.
          </p>
        </div>
      </div>
    </div>
  </div>
  <div class="container-fluid">
    <div class="container">
      <div class="row justify-content-center">
        <div class="col-12">
          <p class="examplFnt">Example:</p>
          <ul class="example">
            <li><i style="font-weight: bold"> to make </i> bed</li>
            <li><i style="font-weight: bold">to do </i> homework</li>
            <li><i style="font-weight: bold"> to take </i> a risk</li>
          </ul>
        </div>
      </div>
    </div>
  </div>
</div>
<!--end 	Collocations -->

<!-- Prepositional idioms -->
<div class="mb-5" *ngIf="section === 'what-are-prepositional'">
  <div class="container-fluid hero-Adjectives">
    <app-header></app-header>

    <div class="container modify-container">
      <div class="row">
        <div class="col-12 head-top">
          <nav aria-label="breadcrumb" class="mb-1">
            <ol class="breadcrumb">
              <li class="breadcrumb-item">
                <a [routerLink]="['/']">Home</a>
              </li>
              <li class="breadcrumb-item">
                <a [routerLink]="['/handbook']">Handbook</a>
              </li>
              <li class="breadcrumb-item">
                <a [routerLink]="['/handbook/techniques']">Techniques</a>
              </li>
              <li class="breadcrumb-item activebread">
                <a [routerLink]="['/what-are-prepositional']"
                  >What Are Prepositional idioms</a
                >
              </li>
            </ol>
          </nav>
          <h1 class="mb-2 heading">What Are Prepositional idioms</h1>
          <p class="py-3 head-details">
            English prepositional idioms are numerous. In prepositional idiom,
            meaning is determined by the choice of preposition.
          </p>
        </div>
      </div>
    </div>
  </div>
  <div class="container-fluid">
    <div class="container">
      <div class="row justify-content-center">
        <div class="col-12">
          <p class="examplFnt">Example:</p>
          <ul class="example">
            <li>
              Break out: When something suddenly begins (often dangerous or
              unpleasant),
            </li>
            <li>Break down: To stop workin</li>
            <li>Break through: To go higher than certain or expected level</li>
            <li>
              All have different meaning by changing the preposition with the
              word ‘break’. Prepositional Idioms do not follow any grammar rule.
              Native speakers rely as it ‘sounds right’ to them.
            </li>
          </ul>

          <br />
          <br />
          <br />
          <br />
        </div>
      </div>
    </div>
  </div>
</div>
<!--end Prepositional idioms -->

<!-- Idiom-->
<div class="mb-5" *ngIf="section === 'what-is-an-idiom'">
  <div class="container-fluid hero-short">
    <app-header></app-header>

    <div class="container modify-container">
      <div class="row">
        <div class="col-12 head-top">
          <nav aria-label="breadcrumb" class="mb-1">
            <ol class="breadcrumb">
              <li class="breadcrumb-item">
                <a [routerLink]="['/']">Home</a>
              </li>
              <li class="breadcrumb-item">
                <a [routerLink]="['/handbook']">Handbook</a>
              </li>
              <li class="breadcrumb-item">
                <a [routerLink]="['/handbook/techniques']">Techniques</a>
              </li>
              <li class="breadcrumb-item activebread">
                <a [routerLink]="['/what-is-an-idiom']">What Is an Idiom</a>
              </li>
            </ol>
          </nav>
          <h1 class="mb-2 heading">What Is an Idiom</h1>
          <p class="py-3 head-details">
            Idiom is a phrase that has different meaning from the words it is
            composed of.
          </p>
        </div>
      </div>
    </div>
  </div>
  <div class="container-fluid">
    <div class="container">
      <div class="row justify-content-center">
        <div class="col-12">
          <p class="examplFnt">Example:</p>
          <ul class="example">
            <li>
              ‘cold feet’ its literal meaning is ‘feet are cold’. Actually it
              means being nervous.
            </li>
          </ul>
        </div>

        <div class="col-12 mt-5">
          <h2 class="update">Idiom vs. Cliché</h2>
          <p>
            Cliché are like idioms, its actual meaning is different from its
            literal meaning. However, due to its overuse, it has lost its impact
            and makes writing dull and unimaginative.
          </p>
          <br />
          <p class="examplFnt">Example of Cliché:</p>
          <ul class="example">
            <li>Read between the lines.</li>
            <li>Play your cards right.</li>
            <li>It is an uphill battle.</li>
            <li>Better safe than sorry.</li>
            <li>
              The main difference between two is – idiom is taken as a positive
              part of language and cliché is taken as negative part of language.
              Cliché is old dusted one, whereas idiom is an essential of English
              language.
            </li>
          </ul>
        </div>

        <div class="col-12 mt-5">
          <h2 class="mb-3 update">What are Prepositional idioms?</h2>
          <p>
            English prepositional idioms are numerous. In prepositional idiom,
            meaning is determined by the choice of preposition.
          </p>

          <br />
          <p class="examplFnt">Example:</p>
          <ul class="example">
            <li>
              Break out: When something suddenly begins (often dangerous or
              unpleasant),
            </li>
            <li>Break down: To stop working</li>
            <li>Break through: To go higher than certain or expected level</li>
            <li>
              All have different meaning by changing the preposition with the
              word ‘break’. Prepositional Idioms do not follow any grammar rule.
              Native speakers rely as it ‘sounds right’ to them.
            </li>
          </ul>
        </div>
      </div>
    </div>
  </div>
</div>
<!--end Idiom -->

<!-- Similes-->
<div class="mb-5" *ngIf="section === 'what-are-similes'">
  <div class="container-fluid hero-Adjectives">
    <app-header></app-header>

    <div class="container modify-container">
      <div class="row">
        <div class="col-12 head-top">
          <nav aria-label="breadcrumb" class="mb-1">
            <ol class="breadcrumb">
              <li class="breadcrumb-item">
                <a [routerLink]="['/']">Home</a>
              </li>
              <li class="breadcrumb-item">
                <a [routerLink]="['/handbook']">Handbook</a>
              </li>
              <li class="breadcrumb-item">
                <a [routerLink]="['/handbook/techniques']">Techniques</a>
              </li>
              <li class="breadcrumb-item activebread">
                <a [routerLink]="['/what-are-similes']">What is a Simile</a>
              </li>
            </ol>
          </nav>
          <h1 class="mb-2 heading">What is a Simile</h1>
          <p class="py-3 head-details">
            Simile is a figure of speech that describes the object by directly
            comparing it with other obejct in an interesting way. The connection
            between two objects is based on common characteristic to describe,
            highlight and emphasize in a way that reader can imagine vividly.
            Similes make writing exciting and colourful. Simile is a comparison
            by using words ‘like’ or ‘as.’
          </p>
        </div>
      </div>
    </div>
  </div>
  <div class="container-fluid">
    <div class="container">
      <div class="row justify-content-center">
        <div class="col-12">
          <p class="examplFnt">Example:</p>
          <ul class="example">
            <li>as innocent as an angel.</li>
            <li>soft like a fur</li>
            <li>fierce like a lion</li>
            <li>More Simile Examples from literature:</li>
          </ul>
        </div>

        <div class="col-12 mt-5">
          <h2 class="update">The Handmaid’s Tale (1985)</h2>
          <p>
            “Time has not stood still. It has washed over me, washed me away, as
            if I’m nothing more than a woman of sand, left by a careless child
            too near the water.” Margaret Atwood
          </p>
        </div>
        <div class="col-12 mt-5">
          <h2 class="update">The Adventure of the Three Gables (1926)</h2>
          <p>
            “She entered with ungainly struggle like some huge awkward chicken,
            torn, squawking, out of its coop.” Sir Arthur Conan Doyle
          </p>
          <p>
            “Daffodils” (1807). “I wandered lonely as a cloud that floats on
            high o’er vales and hills.” (Wordsworth)
          </p>
        </div>
        <div class="col-12 mt-5">
          <h2 class="update">Similes and Exaggeration</h2>
          <p>Similes often make use of hyperbole, or exaggeration:</p>
          <p>She is as light as a feather.</p>
          <p>He runs like a panther.</p>
        </div>
      </div>
    </div>
  </div>
</div>
<!--end 	Similes -->

<!-- 	Verisimilitude-->
<div class="mb-5" *ngIf="section === 'what-is-verisimilitude'">
  <div class="container-fluid hero-Adjectives">
    <app-header></app-header>

    <div class="container modify-container">
      <div class="row">
        <div class="col-12 head-top">
          <nav aria-label="breadcrumb" class="mb-1">
            <ol class="breadcrumb">
              <li class="breadcrumb-item">
                <a [routerLink]="['/']">Home</a>
              </li>
              <li class="breadcrumb-item">
                <a [routerLink]="['/handbook']">Handbook</a>
              </li>
              <li class="breadcrumb-item">
                <a [routerLink]="['/handbook/techniques']">Techniques</a>
              </li>
              <li class="breadcrumb-item activebread">
                <a [routerLink]="['/what-is-verisimilitude']"
                  >What Is Verisimilitude</a
                >
              </li>
            </ol>
          </nav>
          <h1 class="mb-2 heading">What Is Verisimilitude</h1>
          <p class="py-3 head-details">
            (pronounced VAIR-ih-sih-MILL-ih-tude) simply means ‘the quality of
            resembling reality.’ A work of art, or any part of a work of art,
            has verisimilitude if it seems realistic. The word verisimilitude is
            derived from the Latin words verum and similis meaning “truth” and
            “similar.”
          </p>
        </div>
      </div>
    </div>
  </div>
  <div class="container-fluid">
    <div class="container">
      <div class="row justify-content-center">
        <div class="col-12">
          <!-- <h2 class="mb-3 update">Verisimilitude?</h2> -->
          <p>
            The definition of verisimilitude is the semblance of truth. A work
            of fiction although made up with elements of fiction has
            verisimilitude when portrays situations, dialogue, and characters in
            a way that seems authentic and truthful. When using verisimilitude
            in writing, the goal is to be credible and convincing. There are two
            types of verisimilitude in fiction.
          </p>
        </div>

        <div class="col-12">
          <h2 class="update">Cultural verisimilitude:</h2>
          <p>
            This refers to the overall ‘believability’ of a work of fiction in
            the context of “real life” in the “real world.” For example, any
            novel that faithfully portrays the real world, regardless of time
            period or location, is said to have cultural verisimilitude.
          </p>
        </div>
        <div class="col-12 mt-5">
          <h2 class="update">Generic verisimilitude</h2>
          <p>
            This refers to the overall ‘believability’ of a work of fiction in
            the context of its own genre. For example, a fantasy novel that
            portrays an imaginary world using conventions of the fantasy genre
            feels real to the reader is said to have generic verisimilitude.
          </p>

          <br />
          <p class="examplFnt">Example:</p>
          <ul class="example">
            <li>
              The following books provide examples of how writers can finely
              balance reality and imagination, and transport their readers to
              amazingly believable worlds.
            </li>
            <li>
              <i style="font-weight: bold"
                >Michael Chabon, The Yiddish Policemen’s Union (2007):</i
              >
              What if a Jewish state had been established in Alaska?
            </li>
            <li>
              <i style="font-weight: bold"
                >Ben Winters, Underground Airlines (2016):</i
              >
              What if slavery had never ended in America?
            </li>
            <li>
              <i style="font-weight: bold">J.K. Rowling’s Harry Potter</i>
              series resemble real British boarding school life.
            </li>
          </ul>
        </div>
      </div>
    </div>
  </div>
</div>
<!--end Verisimilitude -->

<!-- Oxymoron-->
<div class="mb-5" *ngIf="section === 'what-is-oxymoron'">
  <div class="container-fluid hero-Adjectives">
    <app-header></app-header>

    <div class="container modify-container">
      <div class="row">
        <div class="col-12 head-top">
          <nav aria-label="breadcrumb" class="mb-1">
            <ol class="breadcrumb">
              <li class="breadcrumb-item">
                <a [routerLink]="['/']">Home</a>
              </li>
              <li class="breadcrumb-item">
                <a [routerLink]="['/handbook']">Handbook</a>
              </li>
              <li class="breadcrumb-item">
                <a [routerLink]="['/handbook/techniques']">Techniques</a>
              </li>
              <li class="breadcrumb-item activebread">
                <a [routerLink]="['/what-is-oxymoron']">What Is Oxymoron</a>
              </li>
            </ol>
          </nav>
          <h1 class="mb-2 heading">What Is Oxymoron</h1>
          <p class="py-3 head-details">
            An oxymoron is a figure of speech that puts together opposite
            elements. The combination of these contradicting elements serves to
            reveal a paradox, confuse, or give the reader a laugh.
          </p>
        </div>
      </div>
    </div>
  </div>
  <div class="container-fluid">
    <div class="container">
      <div class="row justify-content-center">
        <div class="col-12">
          <p class="examplFnt">Example:</p>
          <ul class="example">
            <li>
              My room is an <i style="font-weight: bold">organized mess.</i>
            </li>
            <li>
              There is <i style="font-weight: bold"> controlled chaos</i> in the
              market.
            </li>
          </ul>
        </div>
      </div>
    </div>
  </div>
</div>
<!--end Oxymoron -->

<!-- Motif-->
<div class="mb-5" *ngIf="section === 'what-is-a-motif'">
  <div class="container-fluid hero-Adjectives">
    <app-header></app-header>

    <div class="container modify-container">
      <div class="row">
        <div class="col-12 head-top">
          <nav aria-label="breadcrumb" class="mb-1">
            <ol class="breadcrumb">
              <li class="breadcrumb-item">
                <a [routerLink]="['/']">Home</a>
              </li>
              <li class="breadcrumb-item">
                <a [routerLink]="['/handbook']">Handbook</a>
              </li>
              <li class="breadcrumb-item">
                <a [routerLink]="['/handbook/techniques']">Techniques</a>
              </li>
              <li class="breadcrumb-item activebread">
                <a [routerLink]="['/what-is-a-motif']">What Is a Motif</a>
              </li>
            </ol>
          </nav>
          <h1 class="mb-2 heading">What Is a Motif</h1>
          <p class="py-3 head-details">
            The word motif (pronounced moh-teef) is derived from the French
            phrase motif meaning “pattern.” A motif is a symbolic image or idea
            that appears frequently in a story. Motifs can be symbols, sounds,
            actions, ideas, or words. Motifs strengthen a story by adding images
            and ideas to the theme present throughout the narrative.
          </p>
        </div>
      </div>
    </div>
  </div>
  <div class="container-fluid">
    <div class="container">
      <div class="row justify-content-center">
        <div class="col-12">
          <h2>The typewriter:</h2>
          <br />
          <p class="examplFnt">Example:</p>
          <ul class="example">
            <li>
              Throughout a novel, the main character considers buying a
              typewriter but decides against it, as they are too expensive or
              old-fashioned. Deep down she wants one, as she has always dreamed
              of being a writer. The typewriter emphasizes the theme of
              avoidance and the protagonist’s temptation to pursue a different
              career.
            </li>
          </ul>
        </div>

        <!-- <div class="col-12 mt-5">
          <h2 class="update">Motif vs. Symbol</h2>
          <p>
            A symbol is a sign, shape or object used to represent an idea, while
            a motif is an idea used many times in a piece of writing to
            represent the theme. Hence, while a motif must recur in a work
            (appear many times), a symbol could appear just once or twice.
          </p>
        </div> -->
      </div>
    </div>
  </div>
</div>
<!--end 	Motif -->
<!-- Irony-->
<div class="mb-5" *ngIf="section === 'what-is-irony'">
  <div class="container-fluid hero-Adjectives">
    <app-header></app-header>

    <div class="container modify-container">
      <div class="row">
        <div class="col-12 head-top">
          <nav aria-label="breadcrumb" class="mb-1">
            <ol class="breadcrumb">
              <li class="breadcrumb-item">
                <a [routerLink]="['/']">Home</a>
              </li>
              <li class="breadcrumb-item">
                <a [routerLink]="['/handbook']">Handbook</a>
              </li>
              <li class="breadcrumb-item">
                <a [routerLink]="['/handbook/techniques']">Techniques</a>
              </li>
              <li class="breadcrumb-item activebread">
                <a [routerLink]="['/what-is-irony']">What Is Irony</a>
              </li>
            </ol>
          </nav>
          <h1 class="mb-2 heading">What Is Irony</h1>
          <p class="py-3 head-details">
            (pronounced eye-run-ee) is when there are two contradicting meanings
            of the same situation, event, image, sentence, phrase, or story.
            Irony is often used for critical or humorous effect in literature,
            music, art, and film. In many cases, this refers to the difference
            between expectations and reality.
          </p>
        </div>
      </div>
    </div>
  </div>
  <div class="container-fluid">
    <div class="container">
      <div class="row justify-content-center">
        <div class="col-12">
          <p class="examplFnt">Example:</p>
          <ul class="example">
            <li>
              If you go sightseeing anywhere in the world today, you will see
              crowds of people who are so busy taking cell-phone pictures of
              themselves in front of the sight that they don’t actually look at
              what they came to see with their own eyes. This is ironic,
              specifically, situational irony. This one situation has two
              opposing meanings that contradict expectations:
            </li>
            <li>(1) Going to see a sight and prove that you were there</li>
            <li>(2) Not enjoying the thing you went to see.</li>
            <li>
              A popular visual representation of irony shows a seagull sitting
              on top of a “no seagulls” sign. The meaning of the sign is that
              seagulls are not allowed in the area. The seagull sitting on the
              sign not only contradicts it, but calls attention to the absurdity
              of trying to dictate where seagulls may or may not go, which makes
              us laugh.
            </li>
            <li>
              In conversation, people often use verbal irony to express humour,
              affection, or emotion, by saying the opposite of what they mean to
              somebody who is expected to recognize the irony. “I hate you” can
              mean “I love you”—but only if the person you’re saying it to
              already knows that!
            </li>
          </ul>
        </div>

        <div class="col-12 mt-5">
          <h2 class="update">Motif vs. Symbol</h2>
          <p>
            A symbol is a sign, shape or object used to represent an idea, while
            a motif is an idea used many times in a piece of writing to
            represent the theme. Hence, while a motif must recur in a work
            (appear many times), a symbol could appear just once or twice.
          </p>
        </div>
      </div>
    </div>
  </div>
</div>
<!--end 		Irony -->

<!-- Personification-->
<div class="mb-5" *ngIf="section === 'what-is-personification'">
  <div class="container-fluid hero-Adjectives">
    <app-header></app-header>

    <div class="container modify-container">
      <div class="row">
        <div class="col-12 head-top">
          <nav aria-label="breadcrumb" class="mb-1">
            <ol class="breadcrumb">
              <li class="breadcrumb-item">
                <a [routerLink]="['/']">Home</a>
              </li>
              <li class="breadcrumb-item">
                <a [routerLink]="['/handbook']">Handbook</a>
              </li>
              <li class="breadcrumb-item">
                <a [routerLink]="['/handbook/techniques']">Techniques</a>
              </li>
              <li class="breadcrumb-item activebread">
                <a [routerLink]="['/what-is-personification']"
                  >What Is Personification</a
                >
              </li>
            </ol>
          </nav>
          <h1 class="mb-2 heading">What Is Personification</h1>
          <p class="py-3 head-details">
            Personification is a kind of metaphor in which we describe an
            inanimate object, abstract thing in human terms. It is used to
            create more interesting and engaging scenes or characters. When we
            talk about non-human things as if they were human, we personify
            them. Personification is very common in both literature and everyday
            speech.
          </p>
        </div>
      </div>
    </div>
  </div>
  <div class="container-fluid">
    <div class="container">
      <div class="row justify-content-center">
        <div class="col-12">
          <p class="examplFnt">Example:</p>
          <ul class="example">
            <li>
              Sometimes the sun smiles, the wind whispers to the trees, and the
              shadows of the leaves dance in the wind.
            </li>
            <li>
              Although literally, the sun cannot smile, the leaves cannot dance
              without legs, and the wind cannot whisper because it does not have
              a mouth; we apply human characteristics and create these metaphors
              to describe a scene.
            </li>
          </ul>
        </div>
      </div>
    </div>
  </div>
</div>
<!--end Personification -->

<!-- 	Paradox-->
<div class="mb-5" *ngIf="section === 'what-is-paradox'">
  <div class="container-fluid hero-Adjectives">
    <app-header></app-header>

    <div class="container modify-container">
      <div class="row">
        <div class="col-12 head-top">
          <nav aria-label="breadcrumb" class="mb-1">
            <ol class="breadcrumb">
              <li class="breadcrumb-item">
                <a [routerLink]="['/']">Home</a>
              </li>
              <li class="breadcrumb-item">
                <a [routerLink]="['/handbook']">Handbook</a>
              </li>
              <li class="breadcrumb-item">
                <a [routerLink]="['/handbook/techniques']">Techniques</a>
              </li>
              <li class="breadcrumb-item activebread">
                <a [routerLink]="['/what-is-paradox']">What Is Paradox</a>
              </li>
            </ol>
          </nav>
          <h1 class="mb-2 heading">What Is Paradox</h1>
          <p class="py-3 head-details">
            A paradox is a statement that contradicts itself, or that must be
            both true and untrue at the same time. However, a key part of
            paradoxes is that they sound reasonable.
          </p>
        </div>
      </div>
    </div>
  </div>
  <div class="container-fluid">
    <div class="container">
      <div class="row justify-content-center">
        <div class="col-12">
          <p class="examplFnt">Example:</p>
          <ul class="example">
            <li>Less is more.</li>
            <li>This is the beginning of the end.</li>
            <li>Save money by spending it.</li>

            <li>Here is the rule: Ignore all rules.</li>
            <li>Nobody goes to Murphy’s Bar anymore — it’s too crowded.</li>
          </ul>
          <br />
          <p>
            If the bar is crowded, then lots of people are going. But if so many
            people are going, it makes no sense to say “nobody goes” there
            anymore.
          </p>
          <br />
          <p>
            In literary analysis, “paradox” can sometimes have a looser meaning:
            a person or situation that contains contradictions.
          </p>
          <br />
          <p class="examplFnt">Example:</p>
          <ul class="example">
            <li>
              A character who is both charming and rude might be referred to as
              a “paradox” even though in the strict logical sense, there is
              nothing self-contradictory about a single person combining
              disparate personality traits.
            </li>
          </ul>
        </div>
      </div>
    </div>
  </div>
</div>
<!--end Paradox -->

<!-- Metaphors-->
<div class="mb-5" *ngIf="section === 'what-are-metaphors'">
  <div class="container-fluid hero-Adjectives">
    <app-header></app-header>

    <div class="container modify-container">
      <div class="row">
        <div class="col-12 head-top">
          <nav aria-label="breadcrumb" class="mb-1">
            <ol class="breadcrumb">
              <li class="breadcrumb-item">
                <a [routerLink]="['/']">Home</a>
              </li>
              <li class="breadcrumb-item">
                <a [routerLink]="['/handbook']">Handbook</a>
              </li>
              <li class="breadcrumb-item">
                <a [routerLink]="['/handbook/techniques']">Techniques</a>
              </li>
              <li class="breadcrumb-item activebread">
                <a [routerLink]="['/what-are-metaphors']">What are Metaphors</a>
              </li>
            </ol>
          </nav>
          <h1 class="mb-2 heading">What are Metaphors</h1>
          <p class="py-3 head-details">
            Metaphor is a figure of speech that describes the object by stating
            one object as another thing. The purpose is to compare the features
            between two so to clear or explain the idea. In literal meaning, it
            does not make sense, rather amusing and funny.
          </p>
        </div>
      </div>
    </div>
  </div>
  <div class="container-fluid">
    <div class="container">
      <div class="row justify-content-center">
        <div class="col-12">
          <p class="examplFnt">Example:</p>
          <ul class="example">
            <li>He is a lion.</li>
            <li>She is a firework.</li>
          </ul>
          <p style="font-weight: bold">
            Metaphors help to explain the idea in a vibrant and vivacious way.
          </p>
          <br />
          <p>Take these famous metaphor examples:</p>
          <ul class="example">
            <li>
              “All the world’s a stage, and all the men and women merely
              players. They have their exits and their entrances.” William
              Shakespeare
            </li>
            <li>
              “All our words are but crumbs that fall down from the feast of the
              mind.” Khalil Gibran
            </li>
            <li>
              “If you want a love message to be heard, it has got to be sent
              out. To keep a lamp burning, we have to keep putting oil in it.”
              Mother Teresa
            </li>
            <li>
              “Art washes away from the soul the dust of everyday life.” Pablo
              Picasso
            </li>
          </ul>
        </div>

        <div class="col-12 mt-5">
          <h2 class="update">Metaphor vs. Simile</h2>
          <p>
            Although both simile and metaphor are used to compare between two
            objects and make writing vivid, interesting and lively, yet these
            are different in a way that metaphor states something is something
            else, whereas, simile explains something is like or similar to
            something else in a specific quality.
          </p>
        </div>
        <div class="col-12 mt-5">
          <h2 class="update">Different Types of Metaphor</h2>
          <p>
            Often, metaphor is used loosely to mean any kind of symbolism. In
            literature, there are many other types of metaphors too: implied,
            sustained, and dead metaphors.
          </p>
          <br />
          <h2>1. Implied Metaphor</h2>
          <p>
            Implied metaphor is a type of metaphor where one object is not
            directly stated as other object, rather comparison is extracted from
            the characteristics denoted to the object.
          </p>
          <br />
          <p class="examplFnt">Example:</p>
          <ul class="example">
            <li>
              “Elise finally lured Adam into her web.” In this line, we know
              what Elise is being compared to a spider, but it is not expressly
              stated.
            </li>
            <li>
              Samuel brayed his refusal to leave the party peacefully. (Compares
              Samuel to a donkey)
            </li>
            <li>
              Jennifer purred over the lavish present. (Compares Jennifer to a
              cat)
            </li>
          </ul>
          <br />
          <h2>2. Extended Metaphor</h2>
          <p>(See in Literary device)</p>
          <p>
            Extended metaphor is also called sustained metaphor. The term
            “extended metaphor” refers to a comparison between two unlike things
            that continues throughout a series of sentences in a paragraph, or
            lines in a poem. It is often comprised of more than one sentence,
            and sometimes consists of a full paragraph. This literary device is
            helpful in creating vivid imagery in the reader’s mind.
          </p>
          <p class="examplFnt">Example:</p>
          <p>
            “Bobby Holloway says my imagination is a three-hundred-ring circus.
            Currently, I was in ring two hundred and ninety-nine, with elephants
            dancing and clowns cart wheeling and tigers leaping through rings of
            fire. The time had come to step back, leave the main tent, go buy
            some popcorn and a Coke, bliss out, cool down.” (Dean Koontz, Seize
            the Night. Bantam, 1999) Here extended metaphor is comparing
            writer’s imagination with the circus.
          </p>
          <br />
          <h2>3. Dead Metaphor</h2>
          <p>
            Metaphors are a useful descriptive tool, but when the metaphorical
            meaning of a phrase has overcome the original image, it is said to
            have become a dead metaphor.
          </p>
          <p>
            Dead metaphors are also known as
            <i style="font-weight: bold">frozen metaphors</i> and
            <i style="font-weight: bold">historical metaphors</i>.
          </p>
          <br />
          <p class="examplFnt">Examples:</p>
          <h2>Groundbreaking</h2>
          <br />
          <ul class="example">
            <li>
              While a shovel digging into the earth is literally breaking the
              ground, the dead metaphor is also used in a figurative sense, even
              if the imagery of digging into soil is no longer pictured.
            </li>
          </ul>

          <br />
          <h2>Deadline</h2>
          <br />
          <ul class="example">
            <li>
              While everyone understands this to mean when something is due, a
              deadline originally referred to the line around the perimeter of a
              prison wherein a prisoner would be shot if they went beyond it.
            </li>
          </ul>
          <br />
          <h2>Time is running out</h2>
          <br />
          <ul class="example">
            <li>
              When you say that time is running out, it means that you almost
              don’t have enough time to do the thing you need to do. The
              original metaphor referred to the sand in an hourglass, so time
              (as measured by the sand) would literally run out of the top bulb
              into the bottom.
            </li>
          </ul>
          <br />
          <h2>4. Mixed Metaphor</h2>
          <p>
            A mixed metaphor occurs when two or more metaphors, which are
            inconsistent or contradictory, are combined in a way that can create
            confusion, humor, or unintended meaning. This typically happens when
            different imagery or ideas are improperly fused.
          </p>
          <br />
          <p class="examplFnt">Examples:</p>
          <p>
            Merges two unrelated metaphors: sharks smelling blood and taking
            control of a bull.
          </p>
          <br />
          <ul class="example">
            <li>
              The CEO smelled blood in the water and grabbed the bull by the
              horns.
            </li>
          </ul>
          <br />
          <p>
            A humorous blend of "It's not rocket science" and "It's not brain
            surgery.
          </p>
          <br />
          <ul class="example">
            <li>It's not rocket surgery.</li>
          </ul>
        </div>
      </div>
    </div>
  </div>
</div>
<!--end Metaphors -->

<!-- Literary Devices-->
<div class="mb-5" *ngIf="section === 'what-are-literary-devices'">
  <div class="container-fluid hero-Adjectives">
    <app-header></app-header>

    <div class="container modify-container">
      <div class="row">
        <div class="col-12 head-top">
          <nav aria-label="breadcrumb" class="mb-1">
            <ol class="breadcrumb">
              <li class="breadcrumb-item">
                <a [routerLink]="['/']">Home</a>
              </li>
              <li class="breadcrumb-item">
                <a [routerLink]="['/handbook']">Handbook</a>
              </li>
              <li class="breadcrumb-item">
                <a [routerLink]="['/handbook/techniques']">Techniques</a>
              </li>
              <li class="breadcrumb-item activebread">
                <a [routerLink]="['/what-are-literary-devices']"
                  >What Are Literary Devices</a
                >
              </li>
            </ol>
          </nav>
          <h1 class="mb-2 heading">What Are Literary Devices</h1>
          <p class="py-3 head-details">
            Literary devices are techniques that writers use to create a special
            and pointed effect in their writing, to convey information, or to
            help readers understand their writing on a deeper level.
          </p>
        </div>
      </div>
    </div>
  </div>
  <div class="container-fluid">
    <div class="container">
      <div class="row justify-content-center">
        <div class="col-12 mt-5">
          <h2 class="mb-3 update">Allegory</h2>
          <p>(pronounced AL-eh-goh-ree):</p>
          <p>
            Allegory is a narration or description in which events, actions,
            characters, settings or objects represent ideas specifically related
            to religion, politics and morality.
          </p>
          <p>
            An allegory is a story within a story. It has a “surface story” and
            another story hidden underneath. It can be explained as the surface
            story might be about two neighbours throwing rocks at each other’s
            homes, but the hidden story would be about war between countries.
          </p>
          <p>
            Some allegories are very subtle, while others can be more obvious.
          </p>
          <br />
          <p class="examplFnt">Example:</p>
          <ul class="example">
            <li>Animal Farm by George Orwell</li>
            <li>Aesop’s fables</li>

            <li>The Alchemist by Paulo Coelho</li>
          </ul>
        </div>

        <div class="col-12 mt-5">
          <h2 class="update">Allusion</h2>
          <p>
            Allusion (pronounced ah-LOO-zhun) is a reference to something else.
            It is when a writer mentions some other work, or refers to an
            earlier part of the current work.
          </p>
          <p>
            In literature, it is frequently used to reference cultural works
            (e.g. by alluding to a Bible story or Greek myth). Allusion also
            exists in other art forms – musicians, for example, frequently
            “allude” to melodies used by other musicians.
          </p>
          <br />
          <p class="examplFnt">Example:</p>
          <ul class="example">
            <li>
              “Open up Pandora’s box” This is an allusion to the Greek story of
              Pandora, the first woman, who accidentally released evil into the
              world.
            </li>
            <li>
              You’re acting like such a Scrooge! this is allusion to Dickens’s A
              Christmas Carol, this line means that the person is being miserly
              and selfish, just like the character Scrooge from the story.
            </li>
          </ul>
        </div>
        <div class="col-12 mt-5">
          <h2 class="update">Anachronism</h2>
          <p>
            (pronounced ah-NACK-ruh-nism) is a Greek word meaning “backward
            time.” It is what happens when an author, deliberately or
            accidentally, puts historical events, fashions, technology, etc., in
            the wrong place. The story shows something happening at a time when
            it would be impossible, or at least extremely unlikely, for that
            thing to happen.
          </p>
          <br />
          <p class="examplFnt">Example:</p>
          <ul class="example">
            <li>
              William Shakespeare sometimes used anachronisms deliberately in
              his plays about the ancient world. He has Cleopatra play
              billiards, a game that didn’t exist until over 1,000 years after
              her death. Shakespeare did this because he wanted his plays to be
              staged as though the events were happening in his own day, much
              the way we might do with a “modernized” version of old stories. In
              a story if a caveman is shown enjoying Xbox games, as Xbox never
              existed at that time!
            </li>
          </ul>
        </div>

        <div class="col-12 mt-5">
          <h2 class="update">Cliff hanger</h2>
          <p>
            When a story or plotline ends suddenly or a large plot twist occurs
            and is left unresolved. It is a device that is used to create
            suspense, but most importantly, it leaves unanswered questions that
            make the reader or viewer want to come back to learn what will
            happen next. Cliff hangers are a particularly popular and widely
            used device in television, whose success relies heavily on audiences
            returning to watch week after week with episodes that are “to be
            continued.”
          </p>
          <br />
          <p class="examplFnt">Example:</p>
          <ul class="example">
            <li>Read the following short passage:</li>
            <li>
              The man stood on the end of the platform, looking down at the
              still turquoise water ten meters below. He had worked towards this
              his whole life. He wasn’t nervous, even though what would happen
              in the next few moments—few seconds—would determine his future.
              But he was as tranquil as the water below. He arched his heels,
              balancing on the balls of his feet; his arms extended above him
              into the perfect point. He filled his lungs with air and closed
              his eyes for only a fraction of a second, and when they opened, he
              exhaled calmly, and dove.
            </li>
            <li>
              The passage above leaves one huge question unanswered—how did the
              diver perform? We wonder, what will happen if he fails? If he
              succeeds? Each possibility creates further questions for readers
              to consider, and in turn, we are likely to continue reading to get
              answers.
            </li>
          </ul>
        </div>

        <div class="col-12 mt-5">
          <h2 class="update">Dramatic Irony</h2>
          <p>
            Dramatic irony is when the audience knows something that the
            characters do not — so the characters might get an unexpected
            outcome, but for the audience it’s not unexpected at all.
          </p>
          <br />
          <p class="examplFnt">Example:</p>
          <ul class="example">
            <li>
              We all know the ending of Titanic — that ship is going down. But
              everyone on board thinks that it’s “unsinkable”!
            </li>
            <li>
              Shakespearean plays used lots of dramatic irony to create sympathy
              for the protagonist.
            </li>
          </ul>
        </div>

        <div class="col-12 mt-5">
          <h2 class="update">Foreshadowing</h2>
          <p>
            It gives the audience hints or signs about the future. It suggests
            what is to come through imagery, language, and/or symbolism. It does
            not directly give away the outcome, but rather, suggests it.
          </p>
          <br />
          <p class="examplFnt">Example:</p>
          <ul class="example">
            <li>
              A professionally dressed woman hurriedly leaves the house,
              slamming the front door. She frantically searches for her keys in
              the bottom of a giant purse while balancing a briefcase under her
              other arm. She finds her keys, gets in the car and begins backing
              out of the driveway, and then slams on the brakes. “I feel like
              I’m forgetting something,” she says. She shrugs and drives away.
            </li>
            <li>
              With only this information, we can predict the outcome of this
              story—the woman has forgotten something important at home, and she
              probably won’t realize it until she needs it, perhaps at a
              meeting. Her clothing, behaviour, and dialogue are all clues that
              work together to foreshadow what will happen in her future.
            </li>
          </ul>
        </div>

        <div class="col-12 mt-5">
          <h2 class="update">Extended Metaphor</h2>
          <p>
            An extended metaphor is a metaphor that is developed in great
            detail. The amount of detail can vary from that of a sentence or a
            paragraph, to encompassing an entire work. In an extended metaphor,
            the author takes a single metaphor and employs it at length, using
            various subjects, images, ideas, and situations. They are commonly
            used in poetry, as well as prose.
          </p>
          <br />
          <p class="examplFnt">Example:</p>
          <ul class="example">
            <li>
              An author wanting to tell a story about a criminal might employ
              extended metaphor and instead, tell a story about a fox who
              attacks a farmer’s flock of chickens. The fox would represent the
              criminal and the chickens would represent the victims.
            </li>
          </ul>
        </div>
        <div class="col-12 mt-5">
          <h2 class="update">Imagery</h2>
          <p>
            Imagery is language used by poets, novelists and other writers to
            create images in the mind of the reader. Imagery includes figurative
            and metaphorical language to make imagination more vivid to the
            readers through their senses.
          </p>
        </div>

        <div class="col-12 mt-5">
          <h2 class="update">Visual Imagery</h2>
          <p>
            The night was black as ever, but bright stars lit up the sky in
            beautiful and varied constellations that were sprinkled across the
            astronomical landscape.
          </p>
          <p>
            In this example, the experience of the night sky is described in
            depth with color (black as ever, bright), shape (varied
            constellations), and pattern (sprinkled).
          </p>
        </div>

        <div class="col-12 mt-5">
          <h2 class="update">Auditory Imagery</h2>
          <p>
            Auditory imagery describes what we hear, from music to noise o pure
            silence. Auditory imagery may include:
          </p>
          <p>
            Enjoyable sounds, such as: beautiful music, bird song, and the
            voices of a chorus. Noises such as: the bang of a gun, the sound of
            a broom moving across the floor, and the sound of broken glass
            shattering on the hard floor.
          </p>
          <p>
            The lack of noise is described as peaceful calm or eerie silence.
          </p>
        </div>

        <div class="col-12 mt-5">
          <h2 class="update">Olfactory Imagery</h2>
          <p>
            Olfactory imagery describes what we smell. Olfactory imagery may
            include:
          </p>
          <p>
            Fragrances such as perfumes, enticing food and drink, blooming
            flowers.
          </p>
          <p>
            Odours, such as rotting trash, body odours, or a stinky wet dog.
          </p>
        </div>
        <div class="col-12 mt-5">
          <h2 class="update">Gustatory Imagery</h2>
          <p>
            Gustatory imagery describes what we taste. Gustatory imagery can
            include:
          </p>
          <p>Sweetness: such as candies, cookies, and desserts.</p>
          <p>Sourness: bitterness, and tartness, such as lemons and limes.</p>
          <p>Saltiness: such as pretzels, French fries, and pepperonis.</p>
          <p>Spiciness: such as salsas and curries.</p>
          <p>Savouriness: such as a steak dinner or thick soup.</p>
        </div>

        <div class="col-12 mt-5">
          <h2 class="update">Tactile Imagery</h2>
          <p>
            Lastly, tactile imagery describes what we feel or touch. Tactile
            imagery includes:
          </p>
          <p>
            Temperature: such as bitter cold, humidity, mildness, and stifling
            heat.
          </p>
          <p>Texture: such as rough, ragged, seamless, and smooth.</p>
          <p>
            Touch: such as handholding, one’s in the grass, or the feeling of
            starched fabric on one’s skin.
          </p>
          <p>
            Movement: such as burning muscles from exertion, swimming in cold
            water, or kicking a soccer ball.
          </p>
        </div>
      </div>
    </div>
  </div>
</div>
<!--end Literary Devices -->

<!-- Passive Voice-->
<div class="mb-5" *ngIf="section === 'what-is-passive-voice-construction'">
  <div class="container-fluid hero-long">
    <app-header></app-header>

    <div class="container modify-container">
      <div class="row">
        <div class="col-12 head-top">
          <nav aria-label="breadcrumb" class="mb-1">
            <ol class="breadcrumb">
              <li class="breadcrumb-item">
                <a [routerLink]="['/']">Home</a>
              </li>
              <li class="breadcrumb-item">
                <a [routerLink]="['/handbook']">Handbook</a>
              </li>
              <li class="breadcrumb-item">
                <a [routerLink]="['/handbook/style']">Style</a>
              </li>
              <li class="breadcrumb-item activebread">
                <a [routerLink]="['/what-is-passive-voice-construction']"
                  >What Is Passive Voice Construction</a
                >
              </li>
            </ol>
          </nav>
          <h1 class="mb-2 heading">What Is Passive Voice Construction</h1>
          <p class="py-3 head-details">
            Tenses are time references and voice shows who perform and receive
            the action. Passive voice is a form of sentence construction, which
            changes the focus of a sentence.
            <br />
            We use the passive voice to change the focus of the sentence.
            <br />
            My bike was stolen. (Passive – focus on my bike)
            <br />
            Someone stole my bike. (Active – focus on someone)
          </p>
        </div>
      </div>
    </div>
  </div>
  <div class="container-fluid">
    <div class="container">
      <div class="row justify-content-center">
        <div class="col-12">
          <h2 class="mb-3 update">We often use the passive:</h2>
          <p>
            When we prefer not to mention who or what does the action; because
            either it is not known, it's obvious or we don't want to say.
          </p>
          <br />
          <p class="examplFnt">Example:</p>
          <ul class="example">
            <li>
              The house will be cleaned every Saturday. (who will clean the
              house, this is missing)
            </li>
          </ul>
          <p>
            To start a sentence with the most important or most logical
            information
          </p>
          <br />
          <p class="examplFnt">Example:</p>
          <ul class="example">
            <li>
              Insulin was first discovered in 1921 by researchers at the
              University of Toronto.
            </li>
          </ul>
          <p>To be vague about who is responsible:</p>
          <ul class="example">
            <li>
              Unspoken truths are blessing sometimes.(Common in bureaucratic
              writing.)
            </li>
          </ul>

          <p>When talking about a general truth:</p>
          <ul class="example">
            <li>Food is served to feed. (By whom is missing</li>
          </ul>

          When writing in a scientific genre that traditionally relies on
          passive voice. Passive voice is often preferred in lab reports and
          scientific research papers, most notably in the Materials and Methods
          section.

          <ul class="example">
            <li>
              The sodium hydroxide was dissolved in water. This solution was
              then titrated with hydrochloric acid.
            </li>
          </ul>
          <p>To reports of crimes or incidents with unknown perpetrators</p>
          <ul class="example">
            <li>
              My car was stolen yesterday. (The passive voice emphasizes the
              stolen item and the action of theft.)
            </li>
          </ul>
        </div>
        <div class="col-12 mt-5">
          <h2 class="mb-3 update">When to avoid passive voice?</h2>
          <p>
            Passive sentences can get you into trouble in academic writing
            because they can be vague about who is responsible for the action.
          </p>
          <br />
          <p class="examplFnt">Example:</p>
          <ul class="example">
            <li>
              Both Othello and Iago desire Desdemona. She is courted. (Who
              courts Desdemona? Othello? Iago? Both of them?)
            </li>
          </ul>
          <br />
          <p>
            Academic writing often focuses on differences between the ideas of
            different researchers, or between your own ideas and those of the
            researchers you are discussing. Too many passive sentences can
            create confusion.
          </p>
          <br />
          <p class="examplFnt">Example:</p>
          <ul class="example">
            <li>
              Research has been done to discredit this theory. (Who did the
              research? You? Your professor? Another author?)
            </li>
          </ul>
          <br />
          <p>
            Some students use passive sentences to hide holes in their research.
          </p>
          <br />
          <ul class="example">
            <li>
              The telephone was invented in the nineteenth century. (I couldn’t
              find out who invented the telephone!)
            </li>
          </ul>
          <br />
          <p>
            Finally, passive sentences often sound wordy and indirect. They can
            make the reader work unnecessarily hard. In addition, they are
            usually longer than active sentences; passive sentences take up
            precious room in your paper.
          </p>
          <br />
          <p class="examplFnt">Example:</p>
          <ul class="example">
            <li>
              Since the car was being driven by Michael at the time of the
              accident, the damages should be paid for by him.
            </li>
          </ul>
        </div>

        <div class="col-12 mt-5">
          <h2 class="mb-3 update">
            The difference between active and passive voice
          </h2>
          <p>
            At the most basic level, the active voice emphasizes the person or
            agent who performs an action, in short, the ‘doer’. The passive
            voice emphasizes the recipient of the action or sometimes the action
            itself.
          </p>
          <br />
          <p class="examplFnt">Example:</p>
          <ul class="example">
            <li>
              The dog chased the ball.
              <i style="font-weight: bold"> (Active) </i>
            </li>
            <li>
              The ball was chased by the dog.
              <i style="font-weight: bold">(Passive)</i>
            </li>
            <li>
              The construction of active voice: subject + verb+ object
              (optional)
            </li>
            <li>
              The passive voice sentence construction: Object + verb (to be) +
              past participle of transitive verb + prepositional phrase
              (optional)
            </li>
          </ul>
          <br />
          <p class="examplFnt">Example:</p>
          <ul class="example">
            <li>
              Avatar was directed by David Cameron.
              <i style="font-weight: bold"> (Passive)</i>
            </li>
            <li>
              David Cameron directed Avatar.
              <i style="font-weight: bold"> (Active)</i>
            </li>
          </ul>
          <ul class="example">
            <li>
              My flight is cancelled.
              <i style="font-weight: bold">(Passive:</i> It is not always
              necessary to add who or what did the action).
            </li>
            <li>
              They ate, played, and slept during whole vacation.
              <i style="font-weight: bold">(Active:</i> Object is not always
              necessary)
            </li>
          </ul>
        </div>

        <div class="col-12 mt-5">
          <h2 class="mb-3 update">Weeding out passive sentences</h2>
          <p>
            To spot passive sentences, check a form of the verb ‘to be’ in your
            sentence is followed by participle verb and the doer is either
            missing or introduced after the verb using the word “by.”
          </p>
          <br />
          <p class="examplFnt">Example:</p>
          <ul class="example">
            <li>
              Poland was invaded in 1939, thus initiating the Second World War.
              (Doer is missing)
            </li>
            <li>
              Genetic information is encoded by DNA. (doer is introduced after
              ‘by’)
            </li>
            <li>
              The possibility of cold fusion has been examined for many years.
            </li>
          </ul>
          <br />
          <p>
            Turn passive sentences into active sentences. Begin new sentences
            with doer (who performed action). Active sentences are stronger,
            shorter, and precise.
          </p>
          <br />
          <p class="examplFnt">Example:</p>
          <ul class="example">
            <li>
              Germany invaded Poland in 1939, thus initiating the Second World
              War.
            </li>
            <li>DNA encodes genetic information.</li>
            <li>
              Physicists have examined the possibility of cold fusion for many
              years.
            </li>
          </ul>
        </div>
      </div>
    </div>
  </div>
</div>
<!--end 	Passive Voice: -->

<!-- Parallelism-->
<div class="mb-5" *ngIf="section === 'what-is-parallelism'">
  <div class="container-fluid hero-Adjectives">
    <app-header></app-header>

    <div class="container modify-container">
      <div class="row">
        <div class="col-12 head-top">
          <nav aria-label="breadcrumb" class="mb-1">
            <ol class="breadcrumb">
              <li class="breadcrumb-item">
                <a [routerLink]="['/']">Home</a>
              </li>
              <li class="breadcrumb-item">
                <a [routerLink]="['/handbook']">Handbook</a>
              </li>
              <li class="breadcrumb-item">
                <a [routerLink]="['/handbook/style']">Style</a>
              </li>
              <li class="breadcrumb-item activebread">
                <a [routerLink]="['/what-is-parallelism']"
                  >What Is Parallelism</a
                >
              </li>
            </ol>
          </nav>
          <h1 class="mb-2 heading">What Is Parallelism</h1>
          <p class="py-3 head-details">
            Parallelism is when phrases in a sentence have similar or have the
            same grammatical structure. In its most basic usage, parallelism
            provides a phrase with balance and clarity. Parallelism also serves
            to give phrases a pattern and rhythm and makes writing effective,
            classy and clear.
          </p>
        </div>
      </div>
    </div>
  </div>
  <div class="container-fluid">
    <div class="container">
      <div class="row justify-content-center">
        <div class="col-12">
          <h2 class="mb-3 update">How to ensure parallelism in writing?</h2>
          <p>
            Lack of parallelism results in lack of rhythm and pattern in writing
            and speech. To attain parallelism in writing, writer must use same
            structure in a sentence of multiple clauses and phrases.
          </p>

          <br />
          <p class="examplFnt">Example:</p>
          <ul class="example">
            <li>
              I need you to first water the plants, and then feed the dogs. For
              the last thing, I need you to put dinner in the oven.
            </li>
            <li>
              This example lists three tasks in chronological order. In order to
              clarify this, find the parallel elements. There are two potential
              types of parallelism. First, the tasks are parallel: “water the
              plants,” “feed the dogs,” and “I need you to put the dinner in the
              oven.” Secondly, the timing is parallel with the time markers
              “first,” “then,” and “the last thing.” Adjust these phrases to be
              grammatically parallel:
            </li>
          </ul>
        </div>
        <div class="col-12 mt-5">
          <h2 class="mb-3 update">Sentence with Parallel Structure</h2>
          <p>
            I need you to first water the plants, then feed the dogs, and lastly
            make the dinner.
          </p>

          <p style="font-weight: bold">
            This usage of parallelism lists the tasks in a simpler and clearer
            way:
          </p>
          <p>
            I need you to first (adverb) water the plants (verb and object),
            then (adverb) feed the dogs (verb and object), and lastly (adverb)
            make the dinner (verb and object).
          </p>
        </div>

        <div class="col-12 mt-5">
          <h2 class="mb-3 update">Rules of parallelism</h2>
          <p>
            Parallelism is used to balance nouns with nouns, prepositional
            phrases with prepositional phrases, participles with participles,
            infinitives with infinitives, clauses with clauses.
          </p>
          <h2>
            1. Parallelism is used with elements joined by coordinating
            conjunctions.
          </h2>
          <br />
          <p class="examplFnt">Example:</p>
          <ul class="example">
            <li>
              My mother likes cooking
              <i style="font-weight: bold"> and </i> to read.
              <i style="font-weight: bold"> (Not Parallel) </i>
            </li>
            <li>
              My mother likes cooking
              <i style="font-weight: bold"> and </i> reading.
              <i style="font-weight: bold"> (Parallel)</i>
            </li>
            <li>
              My mother likes to cook
              <i style="font-weight: bold"> and </i> read.
              <i style="font-weight: bold"> (Parallel)</i>
            </li>
          </ul>
          <h2>2. Parallelism is used with elements in lists or in a series.</h2>
          <br />
          <p class="examplFnt">Example:</p>
          <ul class="example">
            <li>
              This task can be done individually, in pairs, or can be done in
              groups of four. <i style="font-weight: bold"> (Not Parallel)</i>
            </li>
            <li>
              This task can be done individually, in pairs, or in groups of
              four.
              <i style="font-weight: bold"> (Parallel) </i>
            </li>
          </ul>
          <h2>3. Parallelism is used with elements being compared.</h2>
          <br />
          <p class="examplFnt">Example:</p>
          <ul class="example">
            <li>
              She is mad about watching TV more than to read a book.
              <i style="font-weight: bold"> (Not Parallel)</i>
            </li>
            <li>
              She is mad about watching TV more than reading a book.
              <i style="font-weight: bold"> (Parallel)</i>
            </li>
          </ul>

          <h2>
            4. Parallelism is used with elements joined by a linking verb or a
            form of be
          </h2>
          <br />
          <p class="examplFnt">Example:</p>
          <ul class="example">
            <li>
              To learn is understanding the world.
              <i style="font-weight: bold"> (Not Parallel)</i>
            </li>
            <li>
              To learn is to understand the world.
              <i style="font-weight: bold"> (Parallel)</i>
            </li>
          </ul>
          <h2>5. Parallelism is used with elements joined by linking words.</h2>
          <br />
          <p class="examplFnt">Example:</p>
          <ul class="example">
            <li>
              The teacher <i style="font-weight: bold"> not only </i> wants his
              students to keep quiet
              <i style="font-weight: bold"> but also </i> doing the task.
              <i style="font-weight: bold"> (Not Parallel)</i>
            </li>
            <li>
              The teacher wants his students
              <i style="font-weight: bold"> not only </i> to keep quiet
              <i style="font-weight: bold"> but also </i> to do the task.
              <i style="font-weight: bold"> (Parallel)</i>
            </li>
          </ul>

          <h2>6. Verb Forms should be same.</h2>
          <br />
          <p class="examplFnt">Example:</p>
          <ul class="example">
            <li>
              Nancy likes playing the piano, to blow the trumpet and beat the
              drum.
              <i style="font-weight: bold">
                (Not parallel, different verb forms are used)
              </i>
            </li>
            <li>
              Nancy likes playing the piano, blowing the trumpet and beating the
              drum. <i style="font-weight: bold"> (Parallel)</i>
            </li>
            <li>
              Nancy likes to play the piano, blow the trumpet and beat the drum.
              <i style="font-weight: bold"> (Parallel)</i>
            </li>
            <li>
              Either Gerund should be used or to-infinitive should be used.
            </li>
            <li>
              We do not need to repeat ‘to’ to avoid redundancy and
              interruption.
            </li>
          </ul>
          <h2>7. Nouns vs. Verbs</h2>
          <br />
          <p class="examplFnt">Example:</p>
          <ul class="example">
            <li>
              My favourite breakfast is pancakes and to boil beans.
              <i style="font-weight: bold">
                (Not parallel; Pancakes is a noun but to boil is a verb.)</i
              >
            </li>
            <li>
              My favourite breakfast is pancakes and beans.
              <i style="font-weight: bold"> (Parallel, both are noun)</i>
            </li>
            <p><b>Or</b></p>
            <li>
              My favourite breakfast is baked pancakes and boiled beans.
              <i style="font-weight: bold">
                (Parallel because verb is added before both nouns)</i
              >
            </li>
          </ul>
          <h2>8. Noun Number should be same.</h2>
          <br />
          <p class="examplFnt">Example:</p>
          <ul class="example">
            <li>
              Leaves and a flower are parts of a plant.
              <i style="font-weight: bold"> (Not parallel)</i>
            </li>
            <li>
              Leaves and flowers are parts of a plant.
              <i style="font-weight: bold"> (Parallel)</i>
            </li>
          </ul>

          <h2>9. Subject matter should be relevant.</h2>
          <p>
            Parallelism in subject matter means that everything discussed in a
            sentence should have at least some amount of clarity and
            relatedness. In addition, connection must be clear.
          </p>
          <br />
          <p class="examplFnt">Example:</p>
          <ul class="example">
            <li>
              He decided to cover the gown in sequins, and had a steak for
              dinner.
              <i style="font-weight: bold"
                >(Not parallel, as tasks mentioned are not related to each
                other)</i
              >
            </li>
            <li>
              He decided to cover the gown in sequins; later, had a steak for
              dinner.
              <i style="font-weight: bold">
                (Relevance in terms of sequence of tasks)</i
              >
            </li>
          </ul>

          <h2>10. Parallelism to create impact</h2>
          <p>
            In rhetoric, in the world of literature and speeches, or anytime to
            sound more empowered and want to create an impact parallelism is one
            of very good technique to do so. It involves one or more sentences
            with similar structures to produce a pattern of repetition and
            balance.
          </p>
          <br />
          <p class="examplFnt">Example:</p>
          <ul class="example">
            <li>No pain, no gain. — Common saying</li>
            <li>
              Not everything that is faced can be changed; but nothing can be
              changed until it is faced. (James Baldwin)
            </li>
            <li>I came, I saw, I conquered.</li>
          </ul>
        </div>
      </div>
    </div>
  </div>
</div>
<!--end Parallelism: -->

<!-- SCROL -->
<a
  (click)="scrollToTop()"
  *ngIf="shouldShowButton"
  id="scroll-to-top"
  data-tooltip="Go to top"
>
  <app-icons-free-tools name="goToTopIcon" />
</a>
<!-- SCROL -->
<app-footer></app-footer>
<router-outlet></router-outlet>
